require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0d21bcaaf9225eaf120e4006b08f507d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0d21bcaaf9225eaf120e4006b08f507d'] = async function fn_0d21bcaaf9225eaf120e4006b08f507d(listToModify) {
  await (async function(array) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.reverse(array)
  })(listToModify);

}

})
define('./functions/0ea1d65b7a2db5c48adc82f4f78b00c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0ea1d65b7a2db5c48adc82f4f78b00c1'] = async function fn_0ea1d65b7a2db5c48adc82f4f78b00c1(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/15ca0e8cc5e67ed6b62edeb5642db8ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ca0e8cc5e67ed6b62edeb5642db8ca'] = async function fn_15ca0e8cc5e67ed6b62edeb5642db8ca(listToCompact) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.compact(array)
})(listToCompact))
}

})
define('./functions/15ceddbd38db9429a0f97a454e8b367a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ceddbd38db9429a0f97a454e8b367a'] = async function fn_15ceddbd38db9429a0f97a454e8b367a(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.take(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/16424e16271fba19226ae38e9f473baa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_16424e16271fba19226ae38e9f473baa'] = async function fn_16424e16271fba19226ae38e9f473baa(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.head(array)
})(listToQuery))
}

})
define('./functions/1c281acb3a51cd63d152afb639d9a49f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1c281acb3a51cd63d152afb639d9a49f'] = async function fn_1c281acb3a51cd63d152afb639d9a49f(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.dropRight(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/269ae5233b7fb77961825d7b294a2826/code.js', () => { 

BackendlessUI.Functions.Custom['fn_269ae5233b7fb77961825d7b294a2826'] = function fn_269ae5233b7fb77961825d7b294a2826(number, decimals) {
var factor, returnVar;


  if (!(typeof number === 'undefined')) {
    factor = Math.pow(10,decimals);
    returnVar = Math.round(number * factor) / factor;
  } else {
    returnVar = null;
  }

return returnVar
}

})
define('./functions/26d5effe010a024af594e7ea0151369e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_26d5effe010a024af594e7ea0151369e'] = async function fn_26d5effe010a024af594e7ea0151369e(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/27a3d5b5fe9f5c3e7f0c16ee16cd7b55/code.js', () => { 

BackendlessUI.Functions.Custom['fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55'] = async function fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55(propertyNamePathsList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObjectDeep(props, values)
})(propertyNamePathsList, propertyValuesList))
}

})
define('./functions/2a1538e41c7c2966c613c5082d9cc4a6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a1538e41c7c2966c613c5082d9cc4a6'] = async function fn_2a1538e41c7c2966c613c5082d9cc4a6(listOfGroupedElements, combinerFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzipWith(array, iteratee)
})(listOfGroupedElements, combinerFunction))
}

})
define('./functions/2bab1b7406627074e9c73f97d5958322/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2bab1b7406627074e9c73f97d5958322'] = async function fn_2bab1b7406627074e9c73f97d5958322(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.initial(array)
})(listToQuery))
}

})
define('./functions/3095c06bc8f18d2d297f84d34988c3d9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3095c06bc8f18d2d297f84d34988c3d9'] = function fn_3095c06bc8f18d2d297f84d34988c3d9(imgname) {
var img;


  img = imgname;
  Object.assign(img, {});

return 
}

})
define('./functions/33f4c01b8e8eda17aee5c5294b33b8fc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_33f4c01b8e8eda17aee5c5294b33b8fc'] = async function fn_33f4c01b8e8eda17aee5c5294b33b8fc(listsToProcess) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zip(...arrays)
})(listsToProcess))
}

})
define('./functions/37a70893d34d348151130eb779d90624/code.js', () => { 

BackendlessUI.Functions.Custom['fn_37a70893d34d348151130eb779d90624'] = async function fn_37a70893d34d348151130eb779d90624(listsToProcess, combinerFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipWith(...arrays, iteratee)
})(listsToProcess, combinerFunction))
}

})
define('./functions/38c2ffe50d0e5cca36f20903850cc95a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_38c2ffe50d0e5cca36f20903850cc95a'] = async function fn_38c2ffe50d0e5cca36f20903850cc95a(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.last(array)
})(listToQuery))
}

})
define('./functions/3a17163a8ed3566b1d770b133f9e456c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3a17163a8ed3566b1d770b133f9e456c'] = async function fn_3a17163a8ed3566b1d770b133f9e456c(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/3b22bf56ea095bef299e80632005db52/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3b22bf56ea095bef299e80632005db52'] = async function fn_3b22bf56ea095bef299e80632005db52(listToProcess, chunkLength) {
return (await (async function(array, size) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (size == null) {
	  size = 1
	}

	return _.chunk(array, size)
})(listToProcess, chunkLength))
}

})
define('./functions/3da675c9560df4688c120284991f799e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3da675c9560df4688c120284991f799e'] = async function fn_3da675c9560df4688c120284991f799e(listToInspect, valuesToExclude, comparatorFunction) {
return (await (async function(array, values, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceWith(array, values, comparator)
})(listToInspect, valuesToExclude, comparatorFunction))
}

})
define('./functions/40a4b1ce5bb12cc3ab9d535404cdb19d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_40a4b1ce5bb12cc3ab9d535404cdb19d'] = async function fn_40a4b1ce5bb12cc3ab9d535404cdb19d(date) {
return (await (async function(dateValue) {
	const ensureTwoDigitFormat = value => value < 10 ? '0' + value : value
	
	// Create a new Date object with the desired date
	const date = new Date(dateValue)
	
	// Extract the date components
	const month = ensureTwoDigitFormat(date.getMonth() + 1) // Months are zero-based, so we add 1
	const day = ensureTwoDigitFormat(date.getDate())
	const year = date.getFullYear()
	
	// Create the formatted date string
	//const formattedDate = `'${ month }/${ day }/${ year }'`
	const formattedDate = `${ month }/${ day }/${ year }`
	
	return formattedDate
})(date))
}

})
define('./functions/4305c6b3c9678eaff3f213c4ef4213e4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4305c6b3c9678eaff3f213c4ef4213e4'] = async function fn_4305c6b3c9678eaff3f213c4ef4213e4(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.tail(array)
})(listToQuery))
}

})
define('./functions/4496bd57400824fe76c4deb64607becf/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf'] = async function fn_4496bd57400824fe76c4deb64607becf(dateType) {
var dd, mm, yyyy, datenow;


  datenow = (new Date());
  if (dateType == 'D') {
    dd = (new Date(datenow).getDate());
    mm = (new Date(datenow).getMonth() + 1);
    yyyy = (new Date(datenow).getFullYear());
  } else if (dateType == 'W') {
    dd = (new Date(datenow).getDate()) - 7;
    if (dd < 1) {
      mm = mm - 1;
      if (mm < 1) {
        mm = 12;
        yyyy = yyyy - 1;
      }
      dd = (await BackendlessUI.Functions.Custom['fn_49c91d56168f9adf63be0b8cad29399d'](mm, yyyy)) + dd;
    }
  } else if (dateType == 'M') {
    dd = (new Date(datenow).getDate());
    mm = (new Date(datenow).getMonth() + 1) - 1;
    yyyy = (new Date(datenow).getFullYear());
    if (mm < 1) {
      mm = 12;
      yyyy = yyyy - 1;
    }
  } else if (dateType == 'Y') {
    dd = (new Date(datenow).getDate());
    mm = (new Date(datenow).getMonth() + 1);
    yyyy = (new Date(datenow).getFullYear()) - 1;
  } else {
    dd = 0;
    mm = 0;
    yyyy = 0;
  }

return (new Date(([yyyy,'-',mm,'-',dd].join(''))))
}

})
define('./functions/45e840d979f666875cfc9d9849ef3d28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_45e840d979f666875cfc9d9849ef3d28'] = async function fn_45e840d979f666875cfc9d9849ef3d28(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/461d17e665f8b6391823125f6307ab14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_461d17e665f8b6391823125f6307ab14'] = async function fn_461d17e665f8b6391823125f6307ab14(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniq(array)
})(listToInspect))
}

})
define('./functions/486ef78363267883c1df0cc331fd1a59/code.js', () => { 

BackendlessUI.Functions.Custom['fn_486ef78363267883c1df0cc331fd1a59'] = async function fn_486ef78363267883c1df0cc331fd1a59(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.without(array, ...values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/49c91d56168f9adf63be0b8cad29399d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_49c91d56168f9adf63be0b8cad29399d'] = function fn_49c91d56168f9adf63be0b8cad29399d(currentMonth, yyyy) {
return ([31, (yyyy + 4) % 1 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][(currentMonth - 1)])
}

})
define('./functions/4cf12a1449b890f2c42b8fe2a753bc14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4cf12a1449b890f2c42b8fe2a753bc14'] = async function fn_4cf12a1449b890f2c42b8fe2a753bc14(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/520e5b11f44ee8f88266875f0285766e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_520e5b11f44ee8f88266875f0285766e'] = async function fn_520e5b11f44ee8f88266875f0285766e(propertyNamesList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObject(props, values)
})(propertyNamesList, propertyValuesList))
}

})
define('./functions/52fdb524073bbad39dd107b4c7541e2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_52fdb524073bbad39dd107b4c7541e2d'] = async function fn_52fdb524073bbad39dd107b4c7541e2d(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/56599adc54c74c9fdbc667193c854a77/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56599adc54c74c9fdbc667193c854a77'] = async function fn_56599adc54c74c9fdbc667193c854a77(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.drop(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/56884591a118bc7af84daa6bfc0ea942/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56884591a118bc7af84daa6bfc0ea942'] = async function fn_56884591a118bc7af84daa6bfc0ea942(listToModify, valuesToRemove, filterFunction) {
  await (async function(array, values, iteratee) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllBy(array, values, iteratee)
  })(listToModify, valuesToRemove, filterFunction);

}

})
define('./functions/58ac96052b6cbe4266b47f18e18aecef/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58ac96052b6cbe4266b47f18e18aecef'] = async function fn_58ac96052b6cbe4266b47f18e18aecef(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/58b599fc79a1984718ac68445dc7b9e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58b599fc79a1984718ac68445dc7b9e6'] = async function fn_58b599fc79a1984718ac68445dc7b9e6(listToFill, valueToFillListWith, startPosition, endPosition) {
  await (async function(array, value, start, end) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	if (start == null) {
  	  start = 0
  	}
  	if (end == null) {
  	  end = array.length
  	}

  	_.fill(array, value, start, end)
  })(listToFill, valueToFillListWith, startPosition, endPosition);

}

})
define('./functions/58db38bddf2dcf8f42d5e5214a01acc1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58db38bddf2dcf8f42d5e5214a01acc1'] = async function fn_58db38bddf2dcf8f42d5e5214a01acc1(listOfGroupedElements) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzip(array)
})(listOfGroupedElements))
}

})
define('./functions/5aa80c3936bd19c8f14dd135542b64be/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5aa80c3936bd19c8f14dd135542b64be'] = async function fn_5aa80c3936bd19c8f14dd135542b64be(listsTonspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorBy(...arrays, iteratee)
})(listsTonspect, filterFunction))
}

})
define('./functions/601f96e6c6e413ff585a05b78783325d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_601f96e6c6e413ff585a05b78783325d'] = async function fn_601f96e6c6e413ff585a05b78783325d(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/74c621ab98a12163bece4cad7be292b9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_74c621ab98a12163bece4cad7be292b9'] = async function fn_74c621ab98a12163bece4cad7be292b9(listToConcatenate, valuesToConcatenate) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.concat(array, ...values)
})(listToConcatenate, valuesToConcatenate))
}

})
define('./functions/7508d2443aea24ba74d73b27671a9829/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7508d2443aea24ba74d73b27671a9829'] = async function fn_7508d2443aea24ba74d73b27671a9829(listToModify, indexesOfElementsToRemove) {
return (await (async function(array, indexes) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.pullAt(array, ...indexes)
})(listToModify, indexesOfElementsToRemove))
}

})
define('./functions/77bed231064ec0e2a7d4ac07f751667a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_77bed231064ec0e2a7d4ac07f751667a'] = async function fn_77bed231064ec0e2a7d4ac07f751667a(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.findIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/79a6f77258336011dee2ccdfcf062c76/code.js', () => { 

BackendlessUI.Functions.Custom['fn_79a6f77258336011dee2ccdfcf062c76'] = async function fn_79a6f77258336011dee2ccdfcf062c76(listToInspect, valuesToExclude, filterFunction) {
return (await (async function(array, values, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceBy(array, values, iteratee)
})(listToInspect, valuesToExclude, filterFunction))
}

})
define('./functions/7bd98f3e8e1d5a6571e78cd4492f75a8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7bd98f3e8e1d5a6571e78cd4492f75a8'] = async function fn_7bd98f3e8e1d5a6571e78cd4492f75a8(listToModify, valuesToRemove, comparatorFunction) {
  await (async function(array, values, comparator) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllWith(array, values, comparator)
  })(listToModify, valuesToRemove, comparatorFunction);

}

})
define('./functions/7e649ea1525e52829e82c43fc4f84e2f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7e649ea1525e52829e82c43fc4f84e2f'] = async function fn_7e649ea1525e52829e82c43fc4f84e2f(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flatten(array)
})(listToFlatten))
}

})
define('./functions/84c352dcf0d18e7fa2ca41bb0fa92c91/code.js', () => { 

BackendlessUI.Functions.Custom['fn_84c352dcf0d18e7fa2ca41bb0fa92c91'] = async function fn_84c352dcf0d18e7fa2ca41bb0fa92c91(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/854e825608123b86707265b1cfb74f87/code.js', () => { 

BackendlessUI.Functions.Custom['fn_854e825608123b86707265b1cfb74f87'] = async function fn_854e825608123b86707265b1cfb74f87(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/8c6afca1481cdc048f1c296a77be1975/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8c6afca1481cdc048f1c296a77be1975'] = async function fn_8c6afca1481cdc048f1c296a77be1975(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flattenDeep(array)
})(listToFlatten))
}

})
define('./functions/8f4b34774e84b8b3681c852e49ed1ac5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8f4b34774e84b8b3681c852e49ed1ac5'] = async function fn_8f4b34774e84b8b3681c852e49ed1ac5(listToSlice, startPosition, endPosition) {
return (await (async function(array, start, end) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (start == null) {
	  start = 0
	}

	if (end == null) {
	  end = array.length
	}

	return _.slice(array, start, end)
})(listToSlice, startPosition, endPosition))
}

})
define('./functions/9458f55be4fb02eee2e72e0b6b1c347c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9458f55be4fb02eee2e72e0b6b1c347c'] = async function fn_9458f55be4fb02eee2e72e0b6b1c347c(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/95a8a1ed4f6da56382e43a6149f25d0c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_95a8a1ed4f6da56382e43a6149f25d0c'] = async function fn_95a8a1ed4f6da56382e43a6149f25d0c(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeRightWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/9743fcc6f0cc18c8ec28a5f4d0d17e34/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9743fcc6f0cc18c8ec28a5f4d0d17e34'] = async function fn_9743fcc6f0cc18c8ec28a5f4d0d17e34(listToModify, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.remove(array, predicate)
})(listToModify, valuePickerFunction))
}

})
define('./functions/9ef225438f774527c9eb1feb6044ce26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9ef225438f774527c9eb1feb6044ce26'] = async function fn_9ef225438f774527c9eb1feb6044ce26(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/a1856c74d27745ecf1c18a8269e6103d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a1856c74d27745ecf1c18a8269e6103d'] = async function fn_a1856c74d27745ecf1c18a8269e6103d(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	    fromIndex = array.length - 1
	}

	return _.findLastIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/a31cc1e78e8181c26dea68480a76ff51/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a31cc1e78e8181c26dea68480a76ff51'] = async function fn_a31cc1e78e8181c26dea68480a76ff51(clientid, vendorid, billaccountnumber) {
var CurrClientBase;


  CurrClientBase = (await Backendless.Data.of('vwClientTrxBase').find(Backendless.DataQueryBuilder.create().setWhereClause((['clientid=',clientid,' AND ','vendorid=',vendorid,' AND ','billaccountnumber=\'',billaccountnumber,'\''].join(''))).setSortBy('created desc').setPageSize(10)))[0];

return CurrClientBase
}

})
define('./functions/a376d7d6007e9dbebe6eea15750b4b61/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a376d7d6007e9dbebe6eea15750b4b61'] = async function fn_a376d7d6007e9dbebe6eea15750b4b61(listToInspect, comparatorFunction) {
return (await (async function(array, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqWith(array, comparator)
})(listToInspect, comparatorFunction))
}

})
define('./functions/a868a6a4f6678dfcdaf2fbd8ee89f031/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a868a6a4f6678dfcdaf2fbd8ee89f031'] = async function fn_a868a6a4f6678dfcdaf2fbd8ee89f031(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAll(array, values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/b10683b89d3a8232328807d905aa7ecc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b10683b89d3a8232328807d905aa7ecc'] = async function fn_b10683b89d3a8232328807d905aa7ecc(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/b55a0b2dad43d733ad63285e237240c8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b55a0b2dad43d733ad63285e237240c8'] = async function fn_b55a0b2dad43d733ad63285e237240c8(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropRightWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b665c075565aa28862ac1e9374ca2b96/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b665c075565aa28862ac1e9374ca2b96'] = async function fn_b665c075565aa28862ac1e9374ca2b96(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b8d6305d8b24558eb58f8fe7c0212833/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b8d6305d8b24558eb58f8fe7c0212833'] = async function fn_b8d6305d8b24558eb58f8fe7c0212833(listToFlatten, maxRecursionDepth) {
return (await (async function(array, depth) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (depth == null) {
	  depth = 1
	}

	return _.flattenDepth(array, depth)
})(listToFlatten, maxRecursionDepth))
}

})
define('./functions/b93bcd5de56aa56928854fbb554683b1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b93bcd5de56aa56928854fbb554683b1'] = async function fn_b93bcd5de56aa56928854fbb554683b1(listToQuery, elementIndex) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 0
	}

	return _.nth(array, n)
})(listToQuery, elementIndex))
}

})
define('./functions/c1083dfc958bfce9f511282469f18202/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c1083dfc958bfce9f511282469f18202'] = async function fn_c1083dfc958bfce9f511282469f18202(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.union(...arrays)
})(listsToInspect))
}

})
define('./functions/c44ffc3ca2e2aa52008a39e743ed1c5e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e'] = function fn_c44ffc3ca2e2aa52008a39e743ed1c5e(currPage, tgtPage, pgRecord) {
var pgNEXT, fieldname, nextIDX, pgLIST, currIDX, idx, j, semicolon, pgSEQ;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  semicolon = ';';
  pgSEQ = (getObjectProperty(pgRecord, 'pgSequence'));
  pgLIST = pgSEQ.split(semicolon);
  console.log(String('currPage=') + String(JSON.stringify(currPage)));
  console.log(String('tgtPage=') + String(JSON.stringify(tgtPage)));
  console.log(String('pgLIST=') + String(JSON.stringify(pgLIST)));
  if ((typeof tgtPage === 'undefined') || (tgtPage === null)) {
    idx = 1;
    for (var j_index in pgLIST) {
      j = pgLIST[j_index];
      if (j == currPage.toUpperCase()) {
        currIDX = idx;
        break;
      }
      idx = idx + 1;
    }
    nextIDX = currIDX + 1;
    console.log(['currIDX=',currIDX,'  ','nextIDX=',nextIDX].join(''));
    fieldname = String('pg') + String(pgLIST[((nextIDX + 0) - 1)]);
  } else {
    fieldname = String('pg') + String(tgtPage);
  }
  pgNEXT = (getObjectProperty(pgRecord, fieldname));
  console.log(String('FieldName=') + String(fieldname));
  console.log(String('pgNEXT=') + String(pgNEXT));

return pgNEXT
}

})
define('./functions/c58e08966457701101ab34279f33af6d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c58e08966457701101ab34279f33af6d'] = async function fn_c58e08966457701101ab34279f33af6d(keyValuePairsList) {
return (await (async function(pairs) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.fromPairs(pairs)
})(keyValuePairsList))
}

})
define('./functions/cab97651610a7df89b05dbc568adb257/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cab97651610a7df89b05dbc568adb257'] = async function fn_cab97651610a7df89b05dbc568adb257(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = array.length - 1
	}

	return _.lastIndexOf(array, value, fromIndex);
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/cf0cee815db7c56daa3d4a3f0704a8ac/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cf0cee815db7c56daa3d4a3f0704a8ac'] = async function fn_cf0cee815db7c56daa3d4a3f0704a8ac(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersection(...arrays)
})(listsToInspect))
}

})
define('./functions/d535622b38bb7a25aa31ae757fe6869c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d535622b38bb7a25aa31ae757fe6869c'] = async function fn_d535622b38bb7a25aa31ae757fe6869c(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.takeRight(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/d813cd0b8767bda332b7d73f1ea8155b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d813cd0b8767bda332b7d73f1ea8155b'] = async function fn_d813cd0b8767bda332b7d73f1ea8155b(listToConvert, elementSeparator) {
return (await (async function(array, separator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.join(array, separator)
})(listToConvert, elementSeparator))
}

})
define('./functions/dfe6f4741626a11429b6777d44ba18e7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfe6f4741626a11429b6777d44ba18e7'] = async function fn_dfe6f4741626a11429b6777d44ba18e7(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.difference(array, values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/dfef9391c409b8519db2242d696ca08c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfef9391c409b8519db2242d696ca08c'] = async function fn_dfef9391c409b8519db2242d696ca08c(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniq(array)
})(listToInspect))
}

})
define('./functions/e04783eefccc55279cd3ffc580231f28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e04783eefccc55279cd3ffc580231f28'] = async function fn_e04783eefccc55279cd3ffc580231f28(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/e5c2d44fae98ad119555d2c93f14b509/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509'] = function fn_e5c2d44fae98ad119555d2c93f14b509(currencySymbol, amount) {
var part2, part1, parts, formattedAmt;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  formattedAmt = String(amount);
  parts = formattedAmt.split('.');
  part1 = ((parts[0]).replace((new RegExp('\\B(?=(d{3})+(?!\\d))', 'g')), ','));
  part2 = parts[1];
  if ((Number(part2)) > 0) {
    part2 = Math.round(((Number(part2)) * 100) / 100);
    part2 = (JSON.stringify(part2)).slice(0, 2);
  } else {
    part2 = '00';
  }
  if (getValueLength(part2) < 2) {
    part2 = String(part2) + String('0');
  }

return (String(currencySymbol) + String([part1, part2].join('.')))
}

})
define('./functions/eab6964cdd451a9c2dbbbeb2cbcc36de/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eab6964cdd451a9c2dbbbeb2cbcc36de'] = async function fn_eab6964cdd451a9c2dbbbeb2cbcc36de(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pull(array, ...values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ec97791f4918eb07b6dff2a5bfec059a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ec97791f4918eb07b6dff2a5bfec059a'] = async function fn_ec97791f4918eb07b6dff2a5bfec059a(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xor(...arrays)
})(listsToInspect))
}

})
define('./functions/f1c97833e26b0995f236b863812bfed2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f1c97833e26b0995f236b863812bfed2'] = async function fn_f1c97833e26b0995f236b863812bfed2(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.indexOf(array, value, fromIndex)
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./pages/400/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'msgdetails')) === 'undefined') {
    ___arguments.context.pageData['msgdetails'] = '';
  } else {
    ___arguments.context.pageData['msgdetails'] = (getObjectProperty(___arguments.context.pageData, 'msgdetails'));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/400/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://gprsaves.com', false, undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://gprsaves.com', false, undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/Contact-Us/components/d60f8405a625f681df9e7e4829273212/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var contactinfo, error, EmailTmplName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function SendEmailToGPR() {
  console.log('=11= send email to GPR');
  EmailTmplName = 'Contact_Request';
  for (var count = 0; count < 3; count++) {
    try {
      console.log('==sending email==');
      console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: ['dennis@dncmarketingassociates.com'], ccAddresses: undefined, bccAddresses: ['rmunger@eigercreative.com', 'support@eigercreative.com'], query: '', uniqueEmails: false }), contactinfo, undefined)));
      break;

    } catch (error) {
      console.log(error);

    }
  }
}


  contactinfo = ({ [`contactdate`]: (new Date()),[`contactname`]: (getObjectProperty(___arguments.context.dataModel, 'contactname')),[`contactemail`]: (getObjectProperty(___arguments.context.dataModel, 'contactemail')),[`contactphone`]: (getObjectProperty(___arguments.context.dataModel, 'contactphone')),[`contactmessage`]: (getObjectProperty(___arguments.context.dataModel, 'contactmessage')) });
  console.log(String('contactinfo=') + String(JSON.stringify(contactinfo)));
  console.log('==save the data to DB==');
  console.log((await Backendless.Data.of('ContactRequests').save( contactinfo )));
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('db77de73c155d8aee3facc3e7b573df6', true, false, undefined, 'Thank you. Your request has been submitted.', 'info');
  await SendEmailToGPR();
  await new Promise(r => setTimeout(r, 4000 || 0));

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/Contact-Us/components/48614a8c1b5b0fb265d56efb96bafb0f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;


  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(___arguments.value))).setPageSize(10)))[0];
  ___arguments.context.appData['agent'] = list;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
      return (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('active=') + String(true))).setProperties('name as label, agentid as value').setSortBy('name').setPageSize(100)))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Contact-Us/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var agSelect;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Dash00/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var savings, clientTrxListY, savingsO, savingsM, savingsList, CurrentTrx, clientTrxList, clientList2, j, ClientObj, ClientList, ClientListCount, xx, rptr_name, dirlist, savingsGPR, savingsTotal, currentMonthTrx, CurrClientBase, clientTrxListM, AgentRes2, AgentRes1, list, agid, clientTrxListD, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Calc_Yearly() {
  savings = await getTrxTotals(clientTrxListY);
  ___arguments.context.pageData['savingsYearlyM'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (savings[0])));
  ___arguments.context.pageData['savingsYearlyO'] = (savings.slice(-1)[0]);
}

/**
 * Describe this function...
 */
async function getTrxTotals(clientTrxList) {
  savingsM = 0;
  savingsO = 0;
  for (var CurrentTrx_index in clientTrxList) {
    CurrentTrx = clientTrxList[CurrentTrx_index];
    savingsList = await getsavings(CurrentTrx);
    savingsM = savingsM + savingsList.slice(-1)[0];
    savingsO = savingsO + 1;
  }
  return [savingsM, savingsO]
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GetClientJourney() {
  console.log('=D00= GetClientJourney');
  ClientList = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) == 1 ? '' : String('agentid=') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userid')))).setProperties((['cmpname',',','name',',','AgrDocLink',',','AgrSigLink',',','isACHcomplete',',','ACHcompleteDate',',','CSAactive',',','CSApending'].join(''))).setPageSize(100)));
  clientList2 = [];
  for (var j_index in ClientList) {
    j = ClientList[j_index];
    addItemToList(clientList2, ({ [`cmpname`]: (typeof (getObjectProperty(j, 'cmpname')) === 'undefined') || ((getObjectProperty(j, 'cmpname')) === null) ? '' : (getObjectProperty(j, 'cmpname')).trim(),[`name`]: (typeof (getObjectProperty(j, 'name')) === 'undefined') || ((getObjectProperty(j, 'name')) === null) ? '' : (getObjectProperty(j, 'name')).trim(),[`imgAGR`]: (typeof (getObjectProperty(j, 'AgrDocLink')) === 'undefined') || ((getObjectProperty(j, 'AgrDocLink')) === null) ? false : true,[`imgSIG`]: (typeof (getObjectProperty(j, 'AgrSigLink')) === 'undefined') || ((getObjectProperty(j, 'AgrSigLink')) === null) ? false : true,[`imgACH`]: (typeof (getObjectProperty(j, 'ACHcompleteDate')) === 'undefined') || ((getObjectProperty(j, 'ACHcompleteDate')) === null) ? false : true,[`imgCSAA`]: (getObjectProperty(j, 'CSAactive')),[`imgCSAP`]: (getObjectProperty(j, 'CSApending')) }));
  }
  ___arguments.context.pageData['clientJourney'] = clientList2;
  console.log('=D00= END ClientJourney=');
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function FormatDirContent() {
  dirlist = [(await Backendless.Files.listing(encodePath('documents/agents'), '*.pdf', false, 100, 0))];
  for (var j_index2 in dirlist) {
    j = dirlist[j_index2];
    rptr_name = (getObjectProperty(j, 'name')).slice(0, ((getObjectProperty(j, 'name')).lastIndexOf('.') + 1) - 1);
    console.log(String('filename=') + String(rptr_name));
  }
  return { [`type`]: 'PDF',[`document`]: (getObjectProperty(j, 'name')),[`size`]: (Number((getObjectProperty(j, 'size')))) / 1024,[`action`]: ['<button type=\'button\' style=\'border:"none"; padding:"5px 15px"; background-color:"#008CBA";\'>',(getObjectProperty(j, 'url')),'</button>'].join('') }
}

/**
 * Describe this function...
 */
async function getsavings(currentMonthTrx) {
  CurrClientBase = (getObjectProperty(currentMonthTrx, 'billbaseamt'));
  savingsTotal = CurrClientBase - (getObjectProperty(currentMonthTrx, 'billamount'));
  if (savingsTotal <= 0) {
    savingsTotal = 0;
    savingsGPR = 0;
  } else {
    savingsGPR = savingsTotal / 2;
  }
  savingsGPR = (await BackendlessUI.Functions.Custom['fn_269ae5233b7fb77961825d7b294a2826'](savingsGPR, 2));
  return [savingsTotal, savingsGPR]
}

/**
 * Describe this function...
 */
async function Calc_Monthly() {
  savings = await getTrxTotals(clientTrxListM);
  ___arguments.context.pageData['savingsMonthlyM'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (savings[0])));
  ___arguments.context.pageData['savingsMonthlyO'] = (savings.slice(-1)[0]);
}

/**
 * Describe this function...
 */
async function getAgentResources() {
  console.log('=D00= GetAgentResources');
  AgentRes1 = (await Backendless.Data.of('vwAgentResources').find(Backendless.DataQueryBuilder.create().setSortBy('resourcename').setPageSize(100)));
  AgentRes2 = [];
  for (var j_index3 in AgentRes1) {
    j = AgentRes1[j_index3];
    addItemToList(AgentRes2, ({ [`resname`]: (typeof (getObjectProperty(j, 'resourcename')) === 'undefined') || ((getObjectProperty(j, 'resourcename')) === null) ? '' : (getObjectProperty(j, 'resourcename')).trim(),[`resdesc`]: (typeof (getObjectProperty(j, 'resourcedescription')) === 'undefined') || ((getObjectProperty(j, 'resourcedescription')) === null) ? '' : (getObjectProperty(j, 'resourcedescription')).trim(),[`resimg`]: (typeof (getObjectProperty(j, 'resourceimage')) === 'undefined') || ((getObjectProperty(j, 'resourceimage')) === null) ? '' : (getObjectProperty(j, 'resourceimage')).trim(),[`reslink`]: (typeof (getObjectProperty(j, 'resourcelink')) === 'undefined') || ((getObjectProperty(j, 'resourcelink')) === null) ? '' : (getObjectProperty(j, 'resourcelink')).trim(),[`resdwn`]: (typeof (getObjectProperty(j, 'resourcelink')) === 'undefined') || ((getObjectProperty(j, 'resourcelink')) === null) ? '' : (getObjectProperty(j, 'resourcelink')).trim() }));
  }
  ___arguments.context.pageData['agentResources'] = AgentRes2;
}

/**
 * Describe this function...
 */
async function getAgent(agid) {
  console.log(String('=D00 Page= getagent == agid=') + String(agid));
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(agid))).setPageSize(100)));
  ___arguments.context.appData['agent'] = (list[0]);
  console.log(String('=D00 Page= agent=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'agent')))));
  console.log('=D00= end getagent');
}

/**
 * Describe this function...
 */
async function Calc_Daily() {
  savings = await getTrxTotals(clientTrxListD);
  ___arguments.context.pageData['savingsDailyM'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (savings[0])));
  ___arguments.context.pageData['savingsDailyO'] = (savings.slice(-1)[0]);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getTrxLists() {
  clientTrxListY = (await Backendless.Data.of('vwClientTrx').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) == 1 ? ['created >= \'',((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('Y')).valueOf()),'\''].join('') : ['agentid=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userid')),' AND ',['created >= \'',((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('Y')).valueOf()),'\''].join('')].join(''))).setPageSize(10)));
  ___arguments.context.pageData['savingsYearlyO'] = 0;
  ___arguments.context.pageData['savingsYearlyM'] = 0;
  clientTrxListM = (await asyncListFilter(clientTrxListY, async (item) => {


   return ((getObjectProperty(item, 'created')) >= ((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('M')).valueOf()));
  }));
  ___arguments.context.pageData['savingsMonthlyO'] = 0;
  ___arguments.context.pageData['savingsMonthlyM'] = 0;
  clientTrxListD = (await asyncListFilter(clientTrxListY, async (item) => {


   return ((getObjectProperty(item, 'created')) >= ((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('D')).valueOf()));
  }));
  ___arguments.context.pageData['savingsDailyO'] = 0;
  ___arguments.context.pageData['savingsDailyM'] = 0;
}


  if ((typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'currentUser')) === null)) {
    console.log('=D00= No CurrentUser -- go back to Login');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
  } else {
    console.log(String('=D00 Page= CurrentUser=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser')))));
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) > 2) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    } else {
      if ((typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'agent')) === null)) {
        console.log('=D00 Page= agent undefined');
        await getAgent((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userid')));
      }
      await GetClientJourney();
      await getAgentResources();
      await getTrxLists();
      await Calc_Yearly();
      await Calc_Monthly();
      await Calc_Daily();
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Dash00/components/675730aaa884b057c9ea5742b6585efe/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b62651c9f1d3a4ad7a63c2a5dfaaec19'), 'imgAGR')) == true ? 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_green.png' : 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_red.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/Dash00/components/6add4f7c981bbb9434a81d0959a887f8/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b62651c9f1d3a4ad7a63c2a5dfaaec19'), 'imgSIG')) == true ? 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_green.png' : 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_red.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/Dash00/components/2f47aca2d97827a9795a8c8b2c164572/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b62651c9f1d3a4ad7a63c2a5dfaaec19'), 'imgACH')) == true ? 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_green.png' : 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_red.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/Dash00/components/20db7bf5d4ebbff9d7445d024eb911c6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var filename, filepath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  filepath = '/agent-docs/resources/';
  filename = subsequenceFromStartLast((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5fa4108384284d834285a3b74b4f116d'), 'resimg')), (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5fa4108384284d834285a3b74b4f116d'), 'resimg')).lastIndexOf('/') + 1 + 1) - 1));

  return (String(filepath) + String(filename))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20db7bf5d4ebbff9d7445d024eb911c6'))['width'] = '50px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20db7bf5d4ebbff9d7445d024eb911c6'))['height'] = '50px';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20db7bf5d4ebbff9d7445d024eb911c6'))['width'] = '150px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20db7bf5d4ebbff9d7445d024eb911c6'))['height'] = '150px';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/Dash00/components/74bc4fa9837a4a2bbaf959bbd8c8ea72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['agInfo'] = ({ [`agSubject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f3a2ae17aede3dc653f60bb6ee76ead'), 'resname')),[`agName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'name')),[`agEmail`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')),[`agPhone`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone')),[`agLink`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f3a2ae17aede3dc653f60bb6ee76ead'), 'reslink')),[`agDwn`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f3a2ae17aede3dc653f60bb6ee76ead'), 'resdwn')),[`agLinkB`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'qrbusinesscard')),[`agLinkC`]: ['https://app.gprsaves.com/?page=landing00','&agid=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid'))].join('') });
  console.log(String('agInfo=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'agInfo')))));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('1824231a9e85415eb64769bec054dc0c');

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('74bc4fa9837a4a2bbaf959bbd8c8ea72'))['animation'] = 'shake 0.5s';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('74bc4fa9837a4a2bbaf959bbd8c8ea72'))['animation-iteration-count'] = 'infinite';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('74bc4fa9837a4a2bbaf959bbd8c8ea72'))['animation-iteration-count'] = '0';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Dash00/components/46bded1a46e664fa61ab2f1ed9770d9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var filename, filepath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f3a2ae17aede3dc653f60bb6ee76ead'), 'resdwn')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46bded1a46e664fa61ab2f1ed9770d9d'))['animation'] = 'shake 0.5s';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46bded1a46e664fa61ab2f1ed9770d9d'))['animation-iteration-count'] = 'infinite';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('46bded1a46e664fa61ab2f1ed9770d9d'))['animation-iteration-count'] = '0';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Dash00/components/22ae1aef07cc843f697702cf276c4d48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('1824231a9e85415eb64769bec054dc0c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Dash00/components/1f75ccd7e293d6afd1bc1d5b03119e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var filename, filepath, templateVars, tmplBuscard;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  filepath = '/agent-docs/resources/';
  filename = subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agLink')), (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agLink')).lastIndexOf('/') + 1 + 1) - 1));
  templateVars = ({ [`name`]: (getObjectProperty(___arguments.context.dataModel, 'recipName')),[`ag_id`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')),[`ag_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agName')),[`ag_email`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agEmail')),[`ag_phone`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agPhone')) });
  console.log(String('templateVars=') + String(JSON.stringify(templateVars)));
  console.log((await Backendless.Messaging.sendEmailFromTemplate('Document_You_Requested', Backendless.EmailEnvelope.create({ addresses: [(getObjectProperty(___arguments.context.dataModel, 'recipEmail'))], ccAddresses: ((typeof (getObjectProperty(___arguments.context.dataModel, 'recipCC')) === 'undefined') || ((getObjectProperty(___arguments.context.dataModel, 'recipCC')) === null) ? null : [(getObjectProperty(___arguments.context.dataModel, 'recipCC'))]), bccAddresses: undefined, query: '', uniqueEmails: false }), templateVars, [String(filepath) + String(filename)])));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('1824231a9e85415eb64769bec054dc0c');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/Dash00/components/62ada53829993d0b0e0222380f48883c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agSubject'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Dash00/components/e1fa180e89ecb367d52c4b21242cf718/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var val;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Dash00/components/588bca71a04ff9e5dff8d031cc7fdd82/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var val;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agEmail'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Dash00/components/612b8d0448ef58b222b63f8c3294ac62/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var val;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agPhone'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Dash00/components/9f096709a69ca89efd35747137195a3d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf9b3a523e6fdf4c5bfdefd15827ec82', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Dash00/components/4b1bc7333b230691e03ccacd1a3cf8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf9b3a523e6fdf4c5bfdefd15827ec82', (!((new RegExp('', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f75ccd7e293d6afd1bc1d5b03119e1f'), 'recipEmail'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f75ccd7e293d6afd1bc1d5b03119e1f'), 'recipEmail')));

  return false

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Dash00/components/f28fd74a193c30d99c3b73fd1fcbe5ff/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    
  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Dash00/components/631a7d8147b17ea285a9bece328ee248/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    
  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Login/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var buttonLogin, dashboardname, error, logging, password, rememberMe, stayLoggedIn, user, username;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));
    if (stayLoggedIn) {
      Backendless.Users.setCurrentUser((getObjectProperty(user, 'objectId')), true);
      user['stayLoggedIn'] = stayLoggedIn;
    }

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}

/**
 * Describe this function...
 */
async function setError(error) {
  console.log(String('Error code=') + String(getObjectProperty(error, 'code')));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  dashboardname = 'dashboard';
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  if (typeof (getObjectProperty(___arguments.context.dataModel, 'rememberMe')) === 'undefined') {
    rememberMe = false;
  } else {
    rememberMe = (getObjectProperty(___arguments.context.dataModel, 'rememberMe'));
  }
  if (typeof (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn')) === 'undefined') {
    stayLoggedIn = false;
  } else {
    stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  }
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      console.log(String('') + String(error));
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
    if ((getObjectProperty(user, 'usertype')) == 1) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(dashboardname, (getObjectProperty(___arguments.context.appData, 'currentUser')));
    } else if ((getObjectProperty(user, 'usertype')) == 2) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(dashboardname, (getObjectProperty(___arguments.context.appData, 'currentUser')));
    } else if ((getObjectProperty(user, 'usertype')) == 3) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ClientDash', (getObjectProperty(___arguments.context.appData, 'currentUser')));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('404', undefined);
    }
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/Login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      console.log('Entering Login');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/LoginPasswordRecovery/components/4641c8cb6f0597610bb5b1fce8828044/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.restorePassword((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'emailInput')));

  },
  /* handler:onClick *//* content */
}));

define('./pages/acct-settings/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/acct_inv_list/components/2c56ff01398fbb7da01ac5925bbf8935/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/acct_inv_list/components/06dd968214db95881541edc8a7181fa3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('Checked Value=') + String(JSON.stringify(___arguments.checkedValue)));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/acct_inv_list/components/27a1dc4b80ae0a672c285361c4d825ac/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      console.log(String('card details=') + String(JSON.stringify(___arguments['cardDetails'])));
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateNumber() })('27a1dc4b80ae0a672c285361c4d825ac')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateExpiry() })('27a1dc4b80ae0a672c285361c4d825ac')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateCVC() })('27a1dc4b80ae0a672c285361c4d825ac')) == false) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/acct_inv_list/components/5f6a70fd1073c0579c9b7eed646c7241/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'A' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/acct_inv_list/components/676b151843b4699ca08433cd09ffd765/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'C' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/acct_inv_list/components/debcf98e899e295179472f9b00929bf9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'O' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/acct_inv_list/components/d3e3430bfabe3597bf5625476e6136ea/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CheckCC() {
  console.log('==CheckCC==');
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'name'));
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccacct'] = '';
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccexpdt'] = '';
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['cccvc'] = '';
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccauth')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccauth')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccauth'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccfeeauth')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccfeeauth')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccfeeauth'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
}

/**
 * Describe this function...
 */
async function CheckZELLE() {
  console.log('==CheckZELLE==');
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'name'));
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'zellid')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'zellid')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['zellid'] = '';
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
}

/**
 * Describe this function...
 */
async function CheckACH() {
  console.log('==CheckACH==');
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'name'));
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achrout'] = '';
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achacct'] = '';
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achauth')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achauth')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achauth'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
}

/**
 * Describe this function...
 */
async function CheckOTH() {
  console.log('==CheckOTH==');
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['othClientid'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid'));
  }
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')) === null)) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['othPO'] = '';
  }
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) === null)) {
    console.log('==billingmethod undefined==');
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = '';
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = false;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = null;
  }
  await CheckACH();
  await CheckCC();
  await CheckOTH();
  await CheckZELLE();
  console.log(String('SR after selection=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4e4142bc4e462bb95edc9543f775edfc');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/acct_inv_list/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/acct_inv_list/components/1c7d832e50b4314f0454ca01eef3565f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cardobj, cardobj_07dc, clientobj, isOKstatusACH, isOKstatusCC, isOKstatusOTH, isOKstatusZ;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ClientUpdate(clientobj) {
  ___arguments.context.pageData['selectedRecord'] = (await Backendless.Data.of('Clients').save(clientobj, true));
  console.log(String('selectedRecord Result=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));
}

/**
 * Describe this function...
 */
async function OnclickACH() {
  console.log('== enter onclickACH =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'billingmethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'achAccountholderName'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achrout'] = (getObjectProperty(___arguments.context.pageData, 'achrout'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achacct'] = (getObjectProperty(___arguments.context.pageData, 'achacct'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achauth'] = (getObjectProperty(___arguments.context.pageData, 'achauth'));
  console.log(['screen=',(getObjectProperty(___arguments.context.pageData, 'achrout')),'  SR=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout'))].join(''));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`achrout`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')),[`achacct`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')),[`achauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`iaACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}

/**
 * Describe this function...
 */
async function OnclickCC() {
  console.log('== enter onclickCC =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'billingmethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cardholderName'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccacct'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cardNumber'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccexpdt'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'expiry'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['cccvc'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cvc'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccauth'] = (getObjectProperty(___arguments.context.pageData, 'ccAuth'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccfeeauth'] = (getObjectProperty(___arguments.context.pageData, 'ccFeeAuth'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`ccacct`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')),[`ccexpdt`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')),[`cccvc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')),[`ccauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccauth')),[`ccfeeauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccfeeauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}

/**
 * Describe this function...
 */
async function statusACH() {
  isOKstatusACH = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'achrout')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'Routing Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d73cd83d37e97e943628e46a86d1755')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achacct')) === 'undefined') {
    if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('59b668c81e8b78c996484b423e1b1d33'), 'achacct')) === 'undefined') {
      isOKstatusACH = false;
      await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'Account Number missing or invalid.', 'error');
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da92246d5bd2649838ca2edf12481311')));
    } else {
      ___arguments.context.pageData['achacct'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('59b668c81e8b78c996484b423e1b1d33'), 'achacct'));
    }
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achauth')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'ACH Billing Authority must be granted to proceed.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b0b9e19694cdd3fa7ddab09dd2b616c2')));
  }
}

/**
 * Describe this function...
 */
async function statusCC() {
  isOKstatusCC = true;
  console.log(String('FD=') + String(JSON.stringify(___arguments.context.getComponentDataStoreByUid('59b668c81e8b78c996484b423e1b1d33'))));
  console.log(String('PD=') + String(JSON.stringify(___arguments.context.pageData)));
  console.log(String('CC cardNumber=') + String(getObjectProperty(___arguments.context.pageData, 'cardNumber')));
  console.log(String('CC cardholderName=') + String(getObjectProperty(___arguments.context.pageData, 'cardholderName')));
  console.log(String('CC expiry=') + String(getObjectProperty(___arguments.context.pageData, 'expiry')));
  console.log(String('CC cvc=') + String(getObjectProperty(___arguments.context.pageData, 'cvc')));
  cardobj = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27a1dc4b80ae0a672c285361c4d825ac'));
  console.log(cardobj);
  cardobj_07dc = (getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc'));
  console.log(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc'))));
  if (typeof (getObjectProperty(cardobj, 'cardNumber')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'Card Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27a1dc4b80ae0a672c285361c4d825ac')));
  } else if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cardholderName')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'Cardholder Name missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27a1dc4b80ae0a672c285361c4d825ac')));
  } else if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'expiry')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'CC Expire Date missing or invalid', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27a1dc4b80ae0a672c285361c4d825ac')));
  } else if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cvc')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'CVC Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27a1dc4b80ae0a672c285361c4d825ac')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccauth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'You must authorize charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d645be96eac3068a3451716cf7875a9d')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccfeeauth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'You must authorize the CC Fee charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a5798489e02770259110fa67afb3132')));
  }
}

/**
 * Describe this function...
 */
async function statusOTH() {
  isOKstatusOTH = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'othClientid')) === 'undefined') {
    ___arguments.context.pageData['othClientid'] = '';
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'othPO')) === 'undefined') {
    isOKstatusOTH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', true, false, undefined, 'PO Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('125caa0231e8df09c8c815947c77a33e')));
  }
}

/**
 * Describe this function...
 */
async function statusZ() {
  isOKstatusZ = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'zelleid')) === 'undefined') {
    isOKstatusZ = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('99d2ef61c35c840beb197d1bb302644f', undefined, undefined, undefined, 'Zelle ID missing or invalid.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'zelleid')));
  }
}

/**
 * Describe this function...
 */
async function OnclickOTH() {
  console.log('== enter onclickOTH =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'billingmethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['othClientid'] = (getObjectProperty(___arguments.context.pageData, 'othClientid'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['othPO'] = (getObjectProperty(___arguments.context.pageData, 'othPO'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`othClientid`]: (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')))),[`othPO`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}

/**
 * Describe this function...
 */
async function OnclickZ() {
  console.log('== enter onclickZ =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-873d')), 'cardholderName'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['zelleid'] = (getObjectProperty(___arguments.context.pageData, 'zelleid'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`zelleid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'zelleid')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}


  console.log('===submit button clicked===');
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'A') {
    await statusACH();
    if (isOKstatusACH) {
      await OnclickACH();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');
    }
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'C') {
    await statusCC();
    if (isOKstatusCC) {
      await OnclickCC();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');
    }
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'O') {
    await statusOTH();
    if (isOKstatusOTH) {
      await OnclickOTH();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');
    }
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'Z') {
    await statusZ();
    if (isOKstatusZ) {
      await OnclickZ();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');
    }
  }
  console.log('===end submit button===');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/acct_inv_list/components/59b668c81e8b78c996484b423e1b1d33/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`cmpname`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cmpname')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cmpname')),[`lastname`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'lastname')),[`firstname`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'firstname')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`achrout`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')),[`achacct`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')),[`achauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achauth')),[`ccauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccauth')),[`ccfeeauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccfeeauth')),[`ccacct`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')),[`ccexpdt`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')),[`cccvc`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')),[`othClientid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')),[`othPO`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/acct_inv_list/components/0d73cd83d37e97e943628e46a86d1755/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['achrout'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/acct_inv_list/components/da92246d5bd2649838ca2edf12481311/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['achacct'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/acct_inv_list/components/c1d1407cf82967f1825185a1c88cf161/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['othClientid'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'othClientid')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')) : (getObjectProperty(___arguments.context.pageData, 'othClientid')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/acct_inv_list/components/125caa0231e8df09c8c815947c77a33e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['othPO'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_data_import/components/2e289d0c1259b2288d882a9123ccd137/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'formFields')), 'form-U1-UG')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aff_data_import/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formFields'] = ({ [`d1-UG`]: '/documents/AgentDataTemplate_UserGuide.pdf',[`d1-DT`]: '/documents/AgentDataTemplate.csv',[`d2-UG`]: '/documents/AgentBillsTemplate_UserGuide.pdf',[`d2-DT`]: '/documents/AgentBillsTemplate.csv',[`img`]: '/images/btn_dn_green.png',[`exportDomain`]: ((function () { return BackendlessUI.isProd })()) ? 'https://app.gprsaves.com/api/files' : 'https://perkycollar.backendless.app/api/files',[`btnImage`]: '',[`formURL1`]: '',[`formURL2`]: '' });
  (getObjectProperty(___arguments.context.pageData, 'formFields'))['form-U1-UG'] = (String(getObjectProperty(___arguments.context.pageData, 'formFields.exportDomain')) + String(getObjectProperty(___arguments.context.pageData, 'formFields.d1-UG')));
  (getObjectProperty(___arguments.context.pageData, 'formFields'))['form-U1-DT'] = (String(getObjectProperty(___arguments.context.pageData, 'formFields.exportDomain')) + String(getObjectProperty(___arguments.context.pageData, 'formFields.d1-DT')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/aff_data_import/components/53a6360a9e03375db695f0290ba7cc81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'formFields')), 'form-U1-DT')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aff_data_import/components/a624cfdd3436a5fc9deaaae98d2aafc2/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['agent-upload-FN'] = (['1','-',((new Date()).valueOf()),'-',(getObjectProperty(___arguments.file, 'name'))].join(''));

  return (getObjectProperty(___arguments.context.pageData, 'agent-upload-FN'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var i, agentbilling, agent, fieldname, fieldpos, fieldnum, agentSearchString, agstate, agentbillingparent, agparent, id, agtype, y, z, file1, icnt;

/**
 * Describe this function...
 */
async function updAgent() {
  console.log('=== UPD AGENT ===');
  console.log(String('updAgent ENTER [db] agent=') + String(JSON.stringify(agent)));
  console.log(String('updAgent ENTER [i] agent=') + String(JSON.stringify(i)));
  agent = (await Backendless.Data.of('Agents').save( (await CreateAgentObject()) ));
  console.log(String('agent (upd)=') + String(JSON.stringify(agent)));
  await SetAgentRelations_State();
  await SetAgentRelations_Type(i);
  await SetAgentRelations_Parent(agent);
  console.log(String('updAgent EXIT agent=') + String(JSON.stringify(agent)));
}

/**
 * Describe this function...
 */
async function DoesAgentExist() {
  agent = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((await AgentSearchString())).setPageSize(10)))[0];
  console.log(String('DAE agent result=') + String(JSON.stringify(agent)));
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function addUpdAgentBilling() {
  console.log(String('ADD/UPD agentbilling (before)=') + String(JSON.stringify(i)));
  agentbilling = (await Backendless.Data.of('AgentBilling').save( (await CreateAgentBillingObject()) ));
  console.log(String('ADD/UPD Agentbilling rec [after]=') + String(JSON.stringify(agentbilling)));
  agentbillingparent = (await Backendless.Data.of('AgentBilling').setRelation(({ [`objectId`]: (getObjectProperty(agentbilling, 'objectId')) }), 'agentid', [(getObjectProperty(agent, 'objectId'))]));
  console.log(String('ADD/UPD Agentbilling parentrec [after]=') + String(JSON.stringify(agentbillingparent)));
}

/**
 * Creates a Client Record Search String
 */
async function AgentSearchString() {
  agentSearchString = '';
  await GetParam('agentid', 1, true);
  await GetParam('lastname', 4, false);
  await GetParam('cmpname', 6, false);
  await GetParam('addr1', 7, false);
  await GetParam('city', 9, false);
  await GetParam('state', 10, false);
  await GetStateRecord();
  if (!!(getObjectProperty(___arguments.context.pageData, 'agentid')).length) {
    agentSearchString = (getObjectProperty(___arguments.context.pageData, 'agentid'));
  } else {
    await FormCSS('state');
    await FormCSS('city');
    await FormCSS('cmpname');
    await FormCSS('lastname');
    await FormCSS('addr1');
  }
  console.log(String('AgentSS(result)=') + String(agentSearchString));
  return agentSearchString
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function CreateAgentObject() {
  if (typeof agent === 'undefined') {
    ___arguments.context.pageData['AgentObj'] = ({ [`cmpname`]: i[5],[`lastname`]: i[3],[`firstname`]: i[4],[`addr1`]: i[6],[`addr2`]: i[7],[`city`]: i[8],[`state`]: undefined,[`zip`]: getValueLength(i[10]) == 4 ? String(0) + String(i[10]) : i[10],[`country`]: i[11],[`phone`]: (typeof (i[12]) === 'undefined') || !i[12].length ? '' : i[12],[`phone_mobile`]: (typeof (i[13]) === 'undefined') || !i[13].length ? '' : i[13],[`email`]: i[14],[`agenttype`]: undefined,[`agentid`]: undefined,[`agentparent`]: (typeof (i[1]) === 'undefined') ? 1 : (Number((i[1]))) });
  } else {
    ___arguments.context.pageData['AgentObj'] = ({ [`objectId`]: (getObjectProperty(agent, 'objectId')),[`agentid`]: (getObjectProperty(agent, 'agentid')),[`cmpname`]: i[5],[`lastname`]: i[3],[`firstname`]: i[4],[`addr1`]: i[6],[`addr2`]: i[7],[`city`]: i[8],[`state`]: i[9],[`zip`]: getValueLength(i[10]) == 4 ? String(0) + String(i[10]) : i[10],[`country`]: i[11],[`phone`]: (typeof (i[12]) === 'undefined') || !i[12].length ? '' : i[12],[`phone_mobile`]: (typeof (i[13]) === 'undefined') || !i[13].length ? '' : i[13],[`email`]: i[14],[`agenttype`]: (typeof (i[2]) === 'undefined') ? 10 : i[2],[`agentid`]: i[0],[`agentparent`]: (typeof (i[1]) === 'undefined') ? 1 : (Number((i[1]))) });
  }
  return getObjectProperty(___arguments.context.pageData, 'AgentObj')
}

/**
 * Describe this function...
 */
async function CreateAgentBillingObject() {
  if (typeof agentbilling === 'undefined') {
    ___arguments.context.pageData['AgentBillingObj'] = ({ [`agentid`]: (Number((i[0]))),[`billingmethod`]: (typeof (i[16]) === 'undefined') ? 'Z' : i[16],[`accountholdername`]: (typeof (i[17]) === 'undefined') || !i[17].length ? [i[4],' ',i[3]].join('') : i[17],[`achrout`]: i[18],[`achacct`]: i[19],[`achauth`]: (typeof (i[20]) === 'undefined') ? false : (i[20] == 'Y' ? true : false),[`zelleid`]: (typeof (i[16]) === 'undefined') && (typeof (i[21]) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AgentObj')), 'phone')) : ((typeof (i[21]) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AgentObj')), 'phone')) : i[21]),[`agentpct01`]: (typeof (i[22]) === 'undefined') || !i[22].length ? 10 : i[22],[`agentpct02`]: (typeof (i[23]) === 'undefined') || !i[23].length ? 5 : i[23],[`agentpct03`]: (typeof (i[24]) === 'undefined') || !i[24].length ? 1 : i[24],[`approvaldate`]: !i[25].length ? (new Date()) : i[25],[`approvalcode`]: i[26] });
  } else {
    ___arguments.context.pageData['AgentBillingObj'] = ({ [`objectId`]: (getObjectProperty(agentbilling, 'objectId')),[`agentid`]: (Number((i[0]))),[`billingmethod`]: (typeof (i[16]) === 'undefined') ? 'Z' : i[16],[`accountholdername`]: (typeof (i[17]) === 'undefined') || !i[17].length ? [i[4],' ',i[3]].join('') : i[17],[`achrout`]: i[18],[`achacct`]: i[19],[`achauth`]: (typeof (i[20]) === 'undefined') ? false : (i[20] == 'Y' ? true : false),[`zelleid`]: (typeof (i[16]) === 'undefined') && (typeof (i[21]) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AgentObj')), 'phone')) : ((typeof (i[21]) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AgentObj')), 'phone')) : i[21]),[`agentpct01`]: (typeof (i[22]) === 'undefined') || !i[22].length ? 10 : i[22],[`agentpct02`]: (typeof (i[23]) === 'undefined') || !i[23].length ? 5 : i[23],[`agentpct03`]: (typeof (i[24]) === 'undefined') || !i[24].length ? 1 : i[24],[`approvaldate`]: !i[25].length ? (new Date()) : i[25],[`approvalcode`]: i[26] });
  }
  return getObjectProperty(___arguments.context.pageData, 'AgentBillingObj')
}

/**
 * Describe this function...
 */
async function addAgent() {
  console.log('=== ADD AGENT ===');
  agent = (await Backendless.Data.of('Agents').save( (await CreateAgentObject()) ));
  console.log(String('agent (new)=') + String(JSON.stringify(agent)));
  await SetAgentRelations_State();
  await SetAgentRelations_Type(agent);
  await SetAgentRelations_Parent(agent);
}

/**
 * Describe this function...
 */
async function DoesAgentBillingExist() {
  agentbilling = (await Backendless.Data.of('ClientBilling').find(Backendless.DataQueryBuilder.create().setWhereClause((String('clientid=') + String(getObjectProperty(agent, 'clientid')))).setPageSize(10)))[0];
}

/**
 * Describe this function...
 */
async function SetAgentRelations_State() {
  console.log('== ag state ==================');
  agstate = (await Backendless.Data.of('Agents').setRelation(({ [`objectId`]: (getObjectProperty(agent, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'state')), 'objectId'))]));
}

/**
 * Describe this function...
 */
async function GetParam(fieldname, fieldpos, fieldnum) {
  if (typeof (i[(fieldpos - 1)]) === 'undefined') {
    ___arguments.context.pageData[fieldname] = '';
  } else if (!i[(fieldpos - 1)].length) {
    ___arguments.context.pageData[fieldname] = '';
  } else {
    ___arguments.context.pageData[fieldname] = (fieldnum == true ? [fieldname,'=',i[(fieldpos - 1)].toLowerCase()].join('') : [fieldname,'=\'',i[(fieldpos - 1)].toLowerCase(),'\''].join(''));
  }
}

/**
 * Describe this function...
 */
async function SetAgentRelations_Type(z) {
  console.log('== ag type ==================');
  if (typeof (getObjectProperty(z, 'agenttype')) === 'undefined') {
    z['agenttype'] = 10;
  }
  await DoesTypeExist((getObjectProperty(z, 'agenttype')));
  agtype = (await Backendless.Data.of('Agents').setRelation(({ [`objectId`]: (getObjectProperty(agent, 'objectId')) }), 'agenttype', [(getObjectProperty(agtype, 'objectId'))]));
}

/**
 * Describe this function...
 */
async function GetStateRecord() {
  ___arguments.context.pageData['state'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2=\'',i[9],'\''].join(''))).setPageSize(10)))[0]);
}

/**
 * Describe this function...
 */
async function DoesParentExist(id) {
  agparent = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(id))).setPageSize(10)))[0];
}

/**
 * Describe this function...
 */
async function SetAgentRelations_Parent(y) {
  console.log('== ag parent ==================');
  if (typeof (getObjectProperty(y, 'agentparent')) === 'undefined') {
    y['agentparent'] = 1;
  }
  await DoesParentExist((getObjectProperty(y, 'agentparent')));
  y['agentparent'] = ((typeof agparent === 'undefined') ? 1 : (Number((getObjectProperty(y, 'agentparent')))));
}

/**
 * Describe this function...
 */
async function FormCSS(fieldname) {
  if (typeof (getObjectProperty(___arguments.context.pageData, fieldname)) === 'undefined') {
    ___arguments.context.pageData[fieldname] = '';
  }
  if (!!(getObjectProperty(___arguments.context.pageData, fieldname)).length) {
    if (!!agentSearchString.length) {
      agentSearchString = String(agentSearchString) + String(' AND ');
    }
    agentSearchString = String(agentSearchString) + String(getObjectProperty(___arguments.context.pageData, fieldname));
  }
}

/**
 * Describe this function...
 */
async function DoesTypeExist(id) {
  agtype = (await Backendless.Data.of('AgentTypes').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agenttype=') + String(id))).setPageSize(10)))[0];
}


  file1 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/csv2list`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...true, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'csvURL': ___arguments.uploadedFiles }));
  icnt = 1;
  for (var i_index in file1) {
    i = file1[i_index];
    if (icnt == 1) {
      icnt = (typeof icnt == 'number' ? icnt : 0) + 1;
    } else {
      await DoesAgentExist();
      if (typeof agent === 'undefined') {
        await addAgent();
        await addUpdAgentBilling();
      } else {
        await updAgent();
        await DoesAgentBillingExist();
        await addUpdAgentBilling();
      }
      icnt = (typeof icnt == 'number' ? icnt : 0) + 1;
    }
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      console.log(___arguments.error);
  console.log(String('pagedata=') + String(JSON.stringify(___arguments.context.pageData)));
  console.log(String('appdata=') + String(JSON.stringify(___arguments.context.appData)));

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/aff_fin_data/components/047db4ddebd1c6686b2a359546647e53/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord.accountholdername')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.accoutholdername')) === null)) {
    ___arguments.context.pageData['selectedRecord.accountholdername'] = '';
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f3846a1fde61ceb04bbbd4465551f14');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/aff_fin_data/components/462b3781ff1376676fbdb76f504ffa34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('Checked Value=') + String(JSON.stringify(___arguments.checkedValue)));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_fin_data/components/38134e380be85904b6215ab95eac74c9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['achrout'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_fin_data/components/c0b7f45b72b36eb71dfe03f47115c5f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['achacct'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_fin_data/components/98ee4144d57560b76aa3d88d552a6639/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['achacct'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_fin_data/components/8f4820c5c46590da3b549749fdecb128/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['achauth'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_fin_data/components/8266e17f98498868fcc4052c27b846fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`agentid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentid')),[`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.cmpname')),[`firstname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.firstname')),[`lastname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.lastname')),[`name`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.name')),[`billingmethod`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')),[`accountholdername`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.accountholdername')),[`approvaldate`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.approvaldate')),[`approvalcode`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.approvalcode')),[`zelleid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zelleid')),[`achrout`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.achrout')),[`achacct`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.achacct')),[`achauth`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.achauth')),[`checkname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.checkname')),[`checkaddr1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.checkaddr1')),[`checkaddr2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.checkaddr2')),[`checkcity`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.checkcity')),[`checkstate`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.checkstate')),[`checkzip`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.checkzip')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/aff_fin_data/components/4b0d630fe067cd5e4dc974469662abae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'A' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/aff_fin_data/components/d6c36e21440e5971257fd26b9493f13e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'Z' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/aff_fin_data/components/d10d087d5bc5ac9bde05ead346ad3ede/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['zelleid'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['zelleid'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_fin_data/components/ed01d877ceadd1c1c8de09524ebcd86a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'P' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/aff_fin_data/components/82c4527eeec1eea8fab86ed9f7331c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aff_fin_data/components/985f9dcfb247e2b13181ecb8a426fa81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var agentBilling;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getUpdatesACH() {
  agentBilling['achrout'] = (getObjectProperty(___arguments.context.pageData, 'achrout'));
  agentBilling['achacct'] = (getObjectProperty(___arguments.context.pageData, 'achacct'));
  agentBilling['achauth'] = (getObjectProperty(___arguments.context.pageData, 'achauth'));
  agentBilling['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  agentBilling['approvaldate'] = (new Date());
  console.log((await Backendless.Data.of('Agents').deepSave( ({ [`agentid`]: (getObjectProperty(agentBilling, 'agentid')),[`billingmethod`]: (getObjectProperty(agentBilling, 'billingmethod')),[`accountholdername`]: (getObjectProperty(agentBilling, 'accountholdername')),[`achrout`]: (getObjectProperty(agentBilling, 'achrout')),[`achacct`]: (getObjectProperty(agentBilling, 'achacct')),[`achauth`]: (getObjectProperty(agentBilling, 'achauth')),[`approvaldate`]: (getObjectProperty(agentBilling, 'approvaldate')),[`objectId`]: (getObjectProperty(agentBilling, 'objectId')) }) )));
}

/**
 * Describe this function...
 */
async function updAgentBilling() {
  agentBilling = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentid')))).setPageSize(10)))[0];
  console.log('===screen updates ===');
  if ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'A') {
    await getUpdatesACH();
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'Z') {
    await getUpdatesZelle();
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'P') {
    await getUpdatesPaperCheck();
  }
}

/**
 * Describe this function...
 */
async function getUpdatesZelle() {
  agentBilling['zelleid'] = (getObjectProperty(___arguments.context.pageData, 'zelleid'));
  agentBilling['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  agentBilling['approvaldate'] = (new Date());
  console.log((await Backendless.Data.of('Agents').deepSave( ({ [`agentid`]: (getObjectProperty(agentBilling, 'agentid')),[`billingmethod`]: (getObjectProperty(agentBilling, 'billingmethod')),[`accountholdername`]: (getObjectProperty(agentBilling, 'accountholdername')),[`zelleid`]: (getObjectProperty(agentBilling, 'zelleid')),[`approvaldate`]: (getObjectProperty(agentBilling, 'approvaldate')),[`objectId`]: (getObjectProperty(agentBilling, 'objectId')) }) )));
}

/**
 * Describe this function...
 */
async function getUpdatesPaperCheck() {
  agentBilling['checkname'] = (getObjectProperty(___arguments.context.pageData, 'checkname'));
  agentBilling['checkaddr1'] = (getObjectProperty(___arguments.context.pageData, 'checkaddr1'));
  agentBilling['checkaddr2'] = (getObjectProperty(___arguments.context.pageData, 'checkaddr2'));
  agentBilling['checkcity'] = (getObjectProperty(___arguments.context.pageData, 'checkcity'));
  agentBilling['checkstate'] = (getObjectProperty(___arguments.context.pageData, 'checkstate'));
  agentBilling['checkzip'] = (getObjectProperty(___arguments.context.pageData, 'checkzip'));
  agentBilling['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  agentBilling['approvaldate'] = (new Date());
  console.log((await Backendless.Data.of('Agents').deepSave( ({ [`agentid`]: (getObjectProperty(agentBilling, 'agentid')),[`billingmethod`]: (getObjectProperty(agentBilling, 'billingmethod')),[`accountholdername`]: (getObjectProperty(agentBilling, 'accountholdername')),[`checkname`]: (getObjectProperty(agentBilling, 'checkname')),[`checkaddr1`]: (getObjectProperty(agentBilling, 'checkaddr1')),[`checkaddr2`]: (getObjectProperty(agentBilling, 'checkaddr2')),[`checkcity`]: (getObjectProperty(agentBilling, 'checkcity')),[`checkstate`]: (getObjectProperty(agentBilling, 'checkstate')),[`checkzip`]: (getObjectProperty(agentBilling, 'checkzip')),[`approvaldate`]: (getObjectProperty(agentBilling, 'approvaldate')),[`objectId`]: (getObjectProperty(agentBilling, 'objectId')) }) )));
}


  console.log('========== BUTTON CLICK ==========');
  await updAgentBilling();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aff_profile/components/047db4ddebd1c6686b2a359546647e53/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  ___arguments.context.appData['selectedState'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2 like \'',(getObjectProperty(___arguments.selectedRecord, 'state')),'%\''].join(''))).setPageSize(10)))[0]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('5db144f869bd266f4948c13495f4cd15');
  console.log(String('Whole Record=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/aff_profile/components/513451f381bec312d8c4398ccaa7c58e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.fname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/29064a0e68bb04be23953574bf5ef057/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.cmpname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/10c81e8d7368930ac57d57b8e89558f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/a7d929754a543632484ac6c93338d9af/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/a03e7657ee042ee726d9e7cf0f0cb93a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/600596583c0f8c133e5982fa637e2e58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.city'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/a4550ddd18c60368069b23c3241240dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/41b7f8b93736cf3c8c3afd12b3e979a4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/025113c2649aa09a4efd081e750e0875/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone_mobile'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aff_profile/components/601343a6fb9a94a381cb43e90f1fc15d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e3e7f951e18cddf2a8c440410c9454c5');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aff_profile/components/3db451cfadc949192f486d71905fb5b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var agent, addr2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updAgent() {
  console.log('==update Agent record from screen');
  console.log(String('Agent before=') + String(JSON.stringify(agent)));
  agent['cmpname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.cmpname'));
  agent['name'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.name'));
  agent['addr1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1'));
  agent['addr2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2'));
  agent['city'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city'));
  agent['state'] = null;
  agent['zip'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip'));
  agent['phone'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone'));
  agent['phone_mobile'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone_mobile'));
  agent['email'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email'));
  console.log(String('Agent AFTER=') + String(JSON.stringify(agent)));
  agent = (await Backendless.Data.of('Agents').save( agent ));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5'), 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
  ___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5')['addr2'] = addr2;
}


  console.log('========== BUTTON CLICK ==========');
  await Address2Cleanup();
  console.log('==Get Agent record');
  agent = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentid')))).setPageSize(10)))[0];
  console.log(String('agent from table=') + String(JSON.stringify(agent)));
  await updAgent();
  console.log('==update Agent with state info');
  await Backendless.Data.of('Agents').setRelation(({ [`objectId`]: (getObjectProperty(agent, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aff_profile/components/e3e7f951e18cddf2a8c440410c9454c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`agentid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentid')),[`active`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active')),[`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.cmpname')),[`name`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.name')),[`firstname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.firstname')),[`lastname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.lastname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1')),[`addr2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city')),[`state`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.state')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email')),[`phone`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone')),[`phone_mobile`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone_mobile')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/aff_trx_activity/components/047db4ddebd1c6686b2a359546647e53/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  console.log(String('Whole Record=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/affiliate_profile/components/d6b563979c7cfdf787d9265655d7f057/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  ___arguments.context.appData['selectedState'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2 like \'',(getObjectProperty(___arguments.selectedRecord, 'state')),'%\''].join(''))).setPageSize(10)))[0]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4e4142bc4e462bb95edc9543f775edfc');
  console.log(String('Whole Record=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/affiliate_profile/components/2c56ff01398fbb7da01ac5925bbf8935/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('811498610ffada5fe4c9d987d50378f7');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/affiliate_profile/components/1c7d832e50b4314f0454ca01eef3565f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var agent, addr2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updAgent() {
  console.log('==update Agent record from screen');
  console.log(String('Agent before=') + String(JSON.stringify(agent)));
  agent['cmpname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.cmpname'));
  agent['name'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.name'));
  agent['addr1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1'));
  agent['addr2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2'));
  agent['city'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city'));
  agent['state'] = null;
  agent['zip'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip'));
  agent['phone'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone'));
  agent['phone_mobile'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone_mobile'));
  agent['email'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email'));
  console.log(String('Agent AFTER=') + String(JSON.stringify(agent)));
  agent = (await Backendless.Data.of('Agents').save( agent ));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('811498610ffada5fe4c9d987d50378f7'), 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
  ___arguments.context.getComponentDataStoreByUid('811498610ffada5fe4c9d987d50378f7')['addr2'] = addr2;
}


  console.log('========== BUTTON CLICK ==========');
  await Address2Cleanup();
  console.log('==Get Agent record');
  agent = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentid')))).setPageSize(10)))[0];
  console.log(String('agent from table=') + String(JSON.stringify(agent)));
  await updAgent();
  console.log('==update Agent with state info');
  await Backendless.Data.of('Agents').setRelation(({ [`objectId`]: (getObjectProperty(agent, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/affiliate_profile/components/811498610ffada5fe4c9d987d50378f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.cmpname')),[`fname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.fname')),[`lname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.lname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1')),[`addr2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city')),[`selectState`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.state')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip_postalcode')),[`phone`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email')),[`selectAgent`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentid')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/affiliate_profile/components/1f33bd06996da623fb46f9db479258f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.cmpname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/1fc82b7da757fe7b82caa3cd9ebf7f42/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.fname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/53b5862374eb0a711ffca8d27b438cf2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/0d73cd83d37e97e943628e46a86d1755/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/da92246d5bd2649838ca2edf12481311/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.fname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/ff1ad6ae5c3497fa070aac3904690612/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/829cf7bedbfb917e82b67ead6e29d5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/73d5c9229ef517fe6cf436450b27cb3f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/a1fa6b334d334579a8a33e7b3c0601d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone_mobile'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/affiliate_profile/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/bo-sendach/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
    ___arguments.context.pageData['BillingMethod'] = 'ALL';
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/bo-sendach/components/34e55cfbf4d3fcda4356d8c63b85cdf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var gridtrx, TRX, selectedGridTrx, forteCustomer, achResult, prodSecureKey, prodAccessId, testSecureKey, testAccessId, headers, INV, ccResult, selectedTrxClient, selectedTrxCMP, authid, orgid, qstring, locid, baseuri, cmpid, ZohoCustomer, clientid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateACH() {
  console.log('=00=  send to ACH API (FORTE)');
  await createHeaderValues();
  forteCustomer = (await Backendless.Request.get(`${Backendless.appPath}/services/ForteNet/organizations/org_450076/customers`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...headers, ...{ 'user-token': (false ? ({ [`Username`]: testAccessId,[`Password`]: testSecureKey }) : ({ [`Username`]: prodAccessId,[`Password`]: prodSecureKey })) }})).query({ 'filter': JSON.stringify('first_name eq Domingo'),'test': false }).send());
  achResult = (await Backendless.Request.post(`${Backendless.appPath}/services/ForteNet/organizations/org_450076/locations/loc_333121/`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'trx_amount': '55','billaddr_firstname': 'Rick','billaddr_lastname': 'Munger','echeck_rout': '211170101','echeck_acct': '51100061343','echeck_acctholder': 'Richard Munger','test': true }));
  console.log(String('achResult=') + String(JSON.stringify(forteCustomer)));
}

/**
 * Describe this function...
 */
async function GetSelectedTrxList() {
  selectedGridTrx = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('3c55195d4ee32c51494a6f6a0153244b'));
  if (selectedGridTrx.length > 0) {
    for (var gridtrx_index in selectedGridTrx) {
      gridtrx = selectedGridTrx[gridtrx_index];
      await GetSelectedTrxCMP((getObjectProperty(gridtrx, 'billingCmpID')));
      gridtrx['CMP'] = selectedTrxCMP;
      await GetSelectedTrxClient((getObjectProperty(gridtrx, 'clientid')));
      gridtrx['CLI'] = selectedTrxClient;
    }
  } else {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('eb4dba37f703a989a9c40cd8ba9e1489', true, false, undefined, 'No items selected for Send', 'error');
  }
}

/**
 * Describe this function...
 */
async function CreateInvoice(TRX) {
  console.log('=00= send to ZohoBooks');
}

/**
 * Describe this function...
 */
async function GetZohoCustomer() {
}

/**
 * Describe this function...
 */
async function CreateZelle() {
}

/**
 * Describe this function...
 */
async function GetSelectedTrxCMP(cmpid) {
  if (typeof (getObjectProperty(gridtrx, 'billingCmpID')) === 'undefined') {
    selectedTrxCMP = [];
  } else {
    selectedTrxCMP = (await Backendless.Data.of('Company').find(Backendless.DataQueryBuilder.create().setWhereClause((['CmpID=\'',cmpid,'\''].join(''))).setPageSize(10)))[0];
  }
}

/**
 * Describe this function...
 */
async function CreateOther() {
}

/**
 * Describe this function...
 */
async function CreateCC() {
  console.log('=00= send to CC (Authorize.Net)');
  ccResult = (await Backendless.Request.post(`${Backendless.appPath}/services/AuthorizeNet/request`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'test': true,'invoiceNumber': (getObjectProperty(INV, 'invoice_number')),'customerEmail': (getObjectProperty(INV, 'invoice_number')) }));
}

function convertDataFromTo(data, from, to) {
  if (from === to) { return data }

  if (typeof Buffer !== 'undefined') {
    const buffer = from === 'bytes' ? data : Buffer.from(data, from)
    return (to === 'base64' || to === 'utf8') ? buffer.toString(to) : buffer
  }

  if (typeof atob === 'undefined' || typeof btoa === 'undefined' || typeof TextDecoder === 'undefined' || typeof TextEncoder === 'undefined') {
    throw new Error('Data converter is not allowed in the env, it requires [atob, btoa, TextDecoder]')
  }

  if (from === 'base64') { data = atob(data) }
  if (from === 'bytes') { data = (new TextDecoder('utf8')).decode(data) }
  if (to === 'utf8') { return data }
  if (to === 'base64') { return btoa(data) }
  if (to === 'bytes') { return (new TextEncoder()).encode(data).buffer }}

/**
 * Describe this function...
 */
async function createHeaderValues() {
  baseuri = false ? 'https://sandbox.forte.net/api/v3' : 'https://api.forte.net/api/v3';
  prodAccessId = '0d37eb8eb475bf33549ebdf1f5a1e24c';
  prodSecureKey = 'b1d199df256dbbd4714691888f895a52';
  testAccessId = '524742031ae34952c2e9b60c9c5ce217';
  testSecureKey = '4ce95584ba06a7a1cae49b688b300f75';
  authid = ['Authorization=Basic',' ',(convertDataFromTo((false ? [testAccessId,':',testSecureKey].join('') : [prodAccessId,':',prodSecureKey].join('')), 'utf8', 'base64'))].join('');
  locid = String('loc_') + String('333121');
  orgid = String('org_') + String('450076');
  qstring = ['/organizations/',orgid,'/customers'].join('');
  headers = ({ [`Accept`]: 'application/json',[`Authorization`]: authid,[`X-Forte-Auth-Organization-Id`]: orgid });
  console.log(String('authid=') + String(JSON.stringify(authid)));
}

/**
 * Describe this function...
 */
async function GetSelectedTrxClient(clientid) {
  selectedTrxClient = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause((String('clientid=') + String(clientid))).setPageSize(10)))[0];
}


  console.log('1) collect all selected trx');
  await GetSelectedTrxList();
  for (var TRX_index in selectedGridTrx) {
    TRX = selectedGridTrx[TRX_index];
    await CreateInvoice(TRX);
    if ((getObjectProperty(gridtrx, 'billingmethod')) == 'A') {
      await CreateACH();
    } else if ((getObjectProperty(gridtrx, 'billingmethod')) == 'C') {
      await CreateCC();
    } else if ((getObjectProperty(gridtrx, 'billingmethod')) == 'O') {
      await CreateOther();
    } else if ((getObjectProperty(gridtrx, 'billingmethod')) == 'Z') {
      await CreateZelle();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bo-sendach/components/caf35252504c32a86d8f373656ddb933/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['BillingMethod'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendach/components/3c55195d4ee32c51494a6f6a0153244b/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`field`]: 'select',[`headerCheckboxSelection`]: true,[`checkboxSelection`]: true,[`width`]: 60 }), ({ [`field`]: 'clientname',[`sortable`]: true,[`width`]: 200 }), ({ [`field`]: 'clientcmpname',[`sortable`]: true,[`width`]: 200 }), ({ [`field`]: 'vendorname',[`sortable`]: true,[`width`]: 200 }), ({ [`field`]: 'billaccountnumber',[`sortable`]: true,[`width`]: 150 }), ({ [`field`]: 'billdate',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billbaseamt',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billamount',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billdiscount',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billsavings',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billingmethod',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billingCmpID',[`sortable`]: true,[`width`]: 100 }), ({ [`field`]: 'inv-status',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'inv-number',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'trxid',[`sortable`]: false,[`width`]: 100 }), ({ [`field`]: 'clientid',[`sortable`]: false,[`width`]: 100 })]

  },
  /* handler:columnDefsLogic */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var trxlist, trx, whereclause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getRowData() {
  if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'ALL') {
    whereclause = '';
  } else {
    whereclause = ['billingmethod=\'',(getObjectProperty(___arguments.context.pageData, 'BillingMethod')),'\''].join('');
  }
  console.log(String('Where Clause=') + String(whereclause));
  trxlist = [];
  trxlist = (await Backendless.Data.of('vwClientTrx').find(Backendless.DataQueryBuilder.create().setWhereClause(whereclause).setSortBy('clientcmpname, vendorname').setPageSize(100)));
  for (var trx_index in trxlist) {
    trx = trxlist[trx_index];
    trx['billdate'] = (await BackendlessUI.Functions.Custom['fn_40a4b1ce5bb12cc3ab9d535404cdb19d']((getObjectProperty(trx, 'billdate'))));
    trx['inv-date'] = (await BackendlessUI.Functions.Custom['fn_40a4b1ce5bb12cc3ab9d535404cdb19d']((getObjectProperty(trx, 'inv-date'))));
  }
  console.log(String('trxlist=') + String(JSON.stringify(trxlist)));
}


  await getRowData();

  return trxlist

  },
  /* handler:rowsDataLogic */
  /* handler:widthLogic */
  ['widthLogic'](___arguments) {
      return ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac1fd3f258811707fda954916c63266c'))))

  },
  /* handler:widthLogic */
  /* content */
}))

define('./pages/bo-sendbilling/components/513451f381bec312d8c4398ccaa7c58e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.contactname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/29064a0e68bb04be23953574bf5ef057/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.vendorname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/10c81e8d7368930ac57d57b8e89558f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/a7d929754a543632484ac6c93338d9af/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/a03e7657ee042ee726d9e7cf0f0cb93a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/600596583c0f8c133e5982fa637e2e58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.city'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/a4550ddd18c60368069b23c3241240dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/41b7f8b93736cf3c8c3afd12b3e979a4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/025113c2649aa09a4efd081e750e0875/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/601343a6fb9a94a381cb43e90f1fc15d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e3e7f951e18cddf2a8c440410c9454c5');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bo-sendbilling/components/3db451cfadc949192f486d71905fb5b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vendor, addr2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updVendor() {
  console.log('==update Vendor record from screen');
  console.log(String('Vendor B4=') + String(JSON.stringify(vendor)));
  vendor['vendorname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorname'));
  vendor['addr1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1'));
  vendor['addr2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2'));
  vendor['city'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city'));
  vendor['state'] = null;
  vendor['zip'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip'));
  vendor['phone1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone1'));
  vendor['phone2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone2'));
  vendor['email'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email'));
  vendor['contactname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.contactname'));
  vendor['active'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active'));
  vendor['catid'] = null;
  console.log(String('vendor AF=') + String(JSON.stringify(vendor)));
  vendor = (await Backendless.Data.of('Vendors').save( vendor ));
  console.log('==update Vendor with state info');
  await Backendless.Data.of('Vendors').setRelation(({ [`objectId`]: (getObjectProperty(vendor, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]);
  console.log('==update Vendor with category');
  await Backendless.Data.of('Vendors').setRelation(({ [`objectId`]: (getObjectProperty(vendor, 'objectId')) }), 'catid', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord.catid')), 'objectId'))]);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5'), 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
  ___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5')['addr2'] = addr2;
}


  console.log('========== BUTTON CLICK ==========');
  await Address2Cleanup();
  console.log('==Get Vendor record');
  vendor = (await Backendless.Data.of('Vendors').find(Backendless.DataQueryBuilder.create().setWhereClause((String('vendorid=') + String(getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorid')))).setPageSize(10)))[0];
  console.log(String('vendor from table=') + String(JSON.stringify(vendor)));
  await updVendor();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bo-sendbilling/components/e3e7f951e18cddf2a8c440410c9454c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`active`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active')),[`vendorid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorid')),[`vendorname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1')),[`addr2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city')),[`state`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.state')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip')),[`contactname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.contactname')),[`phone1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone1')),[`phone2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone2')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email')),[`vendortype`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendortype')),[`catid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.catid')),[`catname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.catname')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/bo-sendbilling/components/d6cf47245836b42f723ad349229d9065/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(String('Changed Value=') + String(___arguments.value));
  ___arguments.context.pageData['selectedRecord.vendortype'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/7dd90d0a79df87a5b7c2a13eb851a85c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
      return (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setProperties('catname as label, catid as value').setSortBy('catname').setPageSize(100)))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('changed value=') + String(___arguments.value));
  list = (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setWhereClause((['catid like \'',___arguments.value,'%\''].join(''))).setPageSize(10)))[0];
  console.log(String('list=') + String(JSON.stringify(list)));
  ___arguments.context.pageData['selectedRecord.catid'] = (getObjectProperty(list, 'catid'));
  ___arguments.context.pageData['selectedRecord.catname'] = (getObjectProperty(list, 'catname'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/0541e49c37efb81fdbbe959147614e88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.active'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/9cf936fc9ae812086fc89de8f51d30f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['BillingMethod'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-sendbilling/components/69bbe2f3224805d18e9851887ad8a128/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var gridtrx, TRX, selectedGridTrx, forteCustomer, achResult, prodSecureKey, prodAccessId, testSecureKey, testAccessId, headers, INV, selectedTrxClient, selectedTrxCMP, ZohoCustomer, cmpid, authid, orgid, qstring, locid, baseuri, ccResult, clientid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateAM() {
  console.log('=00=  send to ACH API (MX)');
  await createForteHdr();
  forteCustomer = (await Backendless.Request.get(`${Backendless.appPath}/services/ForteNet/organizations/org_450076/customers`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...headers, ...{ 'user-token': (false ? ({ [`Username`]: testAccessId,[`Password`]: testSecureKey }) : ({ [`Username`]: prodAccessId,[`Password`]: prodSecureKey })) }})).query({ 'filter': JSON.stringify('first_name eq Domingo'),'test': false }).send());
  achResult = (await Backendless.Request.post(`${Backendless.appPath}/services/ForteNet/organizations/org_450076/locations/loc_333121/`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'trx_amount': '55','billaddr_firstname': 'Rick','billaddr_lastname': 'Munger','echeck_rout': '211170101','echeck_acct': '51100061343','echeck_acctholder': 'Richard Munger','test': true }));
  console.log(String('achResult=') + String(JSON.stringify(forteCustomer)));
}

/**
 * Describe this function...
 */
async function CreateAF() {
  console.log('=00=  send to ACH API (FORTE)');
  await createForteHdr();
  forteCustomer = (await Backendless.Request.get(`${Backendless.appPath}/services/ForteNet/organizations/org_450076/customers`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...headers, ...{ 'user-token': (false ? ({ [`Username`]: testAccessId,[`Password`]: testSecureKey }) : ({ [`Username`]: prodAccessId,[`Password`]: prodSecureKey })) }})).query({ 'filter': JSON.stringify('first_name eq Domingo'),'test': false }).send());
  achResult = (await Backendless.Request.post(`${Backendless.appPath}/services/ForteNet/organizations/org_450076/locations/loc_333121/`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'trx_amount': '55','billaddr_firstname': 'Rick','billaddr_lastname': 'Munger','echeck_rout': '211170101','echeck_acct': '51100061343','echeck_acctholder': 'Richard Munger','test': true }));
  console.log(String('achResult=') + String(JSON.stringify(forteCustomer)));
}

/**
 * Describe this function...
 */
async function CreateInvoice(TRX) {
  console.log('=00= send to ZohoBooks');
}

/**
 * Describe this function...
 */
async function GetSelectedTrxList() {
  selectedGridTrx = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('79ffd5b87878de38297ea9188b91a388'));
  if (selectedGridTrx.length > 0) {
    for (var gridtrx_index in selectedGridTrx) {
      gridtrx = selectedGridTrx[gridtrx_index];
      await GetSelectedTrxCMP((getObjectProperty(gridtrx, 'billingCmpID')));
      gridtrx['CMP'] = selectedTrxCMP;
      await GetSelectedTrxClient((getObjectProperty(gridtrx, 'clientid')));
      gridtrx['CLI'] = selectedTrxClient;
    }
  } else {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('d838cabbc8c85748cfa151787c04a768', true, false, undefined, 'No items selected for Send', 'error');
  }
}

/**
 * Describe this function...
 */
async function GetZohoCustomer() {
}

/**
 * Describe this function...
 */
async function CreateZelle() {
}

/**
 * Describe this function...
 */
async function GetSelectedTrxCMP(cmpid) {
  if (typeof (getObjectProperty(gridtrx, 'billingCmpID')) === 'undefined') {
    selectedTrxCMP = [];
  } else {
    selectedTrxCMP = (await Backendless.Data.of('Company').find(Backendless.DataQueryBuilder.create().setWhereClause((['CmpID=\'',cmpid,'\''].join(''))).setPageSize(10)))[0];
  }
}

/**
 * Describe this function...
 */
async function CreateOther() {
}

function convertDataFromTo(data, from, to) {
  if (from === to) { return data }

  if (typeof Buffer !== 'undefined') {
    const buffer = from === 'bytes' ? data : Buffer.from(data, from)
    return (to === 'base64' || to === 'utf8') ? buffer.toString(to) : buffer
  }

  if (typeof atob === 'undefined' || typeof btoa === 'undefined' || typeof TextDecoder === 'undefined' || typeof TextEncoder === 'undefined') {
    throw new Error('Data converter is not allowed in the env, it requires [atob, btoa, TextDecoder]')
  }

  if (from === 'base64') { data = atob(data) }
  if (from === 'bytes') { data = (new TextDecoder('utf8')).decode(data) }
  if (to === 'utf8') { return data }
  if (to === 'base64') { return btoa(data) }
  if (to === 'bytes') { return (new TextEncoder()).encode(data).buffer }}

/**
 * Describe this function...
 */
async function createMxHdr() {
  baseuri = false ? 'https://sandbox.forte.net/api/v3' : 'https://api.forte.net/api/v3';
  prodAccessId = '0d37eb8eb475bf33549ebdf1f5a1e24c';
  prodSecureKey = 'b1d199df256dbbd4714691888f895a52';
  testAccessId = '524742031ae34952c2e9b60c9c5ce217';
  testSecureKey = '4ce95584ba06a7a1cae49b688b300f75';
  authid = ['Authorization=Basic',' ',(convertDataFromTo((false ? [testAccessId,':',testSecureKey].join('') : [prodAccessId,':',prodSecureKey].join('')), 'utf8', 'base64'))].join('');
  locid = String('loc_') + String('333121');
  orgid = String('org_') + String('450076');
  qstring = ['/organizations/',orgid,'/customers'].join('');
  headers = ({ [`Accept`]: 'application/json',[`Authorization`]: authid,[`X-Forte-Auth-Organization-Id`]: orgid });
  console.log(String('authid=') + String(JSON.stringify(authid)));
}

/**
 * Describe this function...
 */
async function CreateCC() {
  console.log('=00= send to CC (Authorize.Net)');
  ccResult = (await Backendless.Request.post(`${Backendless.appPath}/services/AuthorizeNet/request`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'test': true,'invoiceNumber': (getObjectProperty(INV, 'invoice_number')),'customerEmail': (getObjectProperty(INV, 'invoice_number')) }));
}

/**
 * Describe this function...
 */
async function createForteHdr() {
  baseuri = false ? 'https://sandbox.forte.net/api/v3' : 'https://api.forte.net/api/v3';
  prodAccessId = '0d37eb8eb475bf33549ebdf1f5a1e24c';
  prodSecureKey = 'b1d199df256dbbd4714691888f895a52';
  testAccessId = '524742031ae34952c2e9b60c9c5ce217';
  testSecureKey = '4ce95584ba06a7a1cae49b688b300f75';
  authid = ['Authorization=Basic',' ',(convertDataFromTo((false ? [testAccessId,':',testSecureKey].join('') : [prodAccessId,':',prodSecureKey].join('')), 'utf8', 'base64'))].join('');
  locid = String('loc_') + String('333121');
  orgid = String('org_') + String('450076');
  qstring = ['/organizations/',orgid,'/customers'].join('');
  headers = ({ [`Accept`]: 'application/json',[`Authorization`]: authid,[`X-Forte-Auth-Organization-Id`]: orgid });
  console.log(String('authid=') + String(JSON.stringify(authid)));
}

/**
 * Describe this function...
 */
async function GetSelectedTrxClient(clientid) {
  selectedTrxClient = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause((String('clientid=') + String(clientid))).setPageSize(10)))[0];
}


  console.log('1) collect all selected trx');
  await GetSelectedTrxList();
  for (var TRX_index in selectedGridTrx) {
    TRX = selectedGridTrx[TRX_index];
    await CreateInvoice(TRX);
    if ((getObjectProperty(gridtrx, 'billingmethod')) == 'AF') {
      await CreateAF();
    } else if ((getObjectProperty(gridtrx, 'billingmethod')) == 'AM') {
      await CreateAF();
    } else if ((getObjectProperty(gridtrx, 'billingmethod')) == 'C') {
      await CreateCC();
    } else if ((getObjectProperty(gridtrx, 'billingmethod')) == 'O') {
      await CreateOther();
    } else if ((getObjectProperty(gridtrx, 'billingmethod')) == 'Z') {
      await CreateZelle();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bo-sendbilling/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
    ___arguments.context.pageData['BillingMethod'] = 'ALL';
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/bo-sendbilling/components/79ffd5b87878de38297ea9188b91a388/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`field`]: 'select',[`headerCheckboxSelection`]: true,[`checkboxSelection`]: true,[`width`]: 60 }), ({ [`field`]: 'clientname',[`sortable`]: true,[`width`]: 200 }), ({ [`field`]: 'clientcmpname',[`sortable`]: true,[`width`]: 200 }), ({ [`field`]: 'vendorname',[`sortable`]: true,[`width`]: 200 }), ({ [`field`]: 'billaccountnumber',[`sortable`]: true,[`width`]: 150 }), ({ [`field`]: 'billdate',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billbaseamt',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billamount',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billdiscount',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billsavings',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billingmethod',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'billingCmpID',[`sortable`]: true,[`width`]: 100 }), ({ [`field`]: 'inv-status',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'inv-number',[`sortable`]: true,[`width`]: 120 }), ({ [`field`]: 'trxid',[`sortable`]: false,[`width`]: 100 }), ({ [`field`]: 'clientid',[`sortable`]: false,[`width`]: 100 })]

  },
  /* handler:columnDefsLogic */
  /* handler:widthLogic */
  ['widthLogic'](___arguments) {
      return ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c04eb0dd30b1ac82d02031c964185a7'))))

  },
  /* handler:widthLogic */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var trx, trxlist, whereclause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getRowData() {
  if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'ALL') {
    whereclause = '';
  } else {
    whereclause = ['billingmethod=\'',(getObjectProperty(___arguments.context.pageData, 'BillingMethod')),'\''].join('');
  }
  console.log(String('Where Clause=') + String(whereclause));
  trxlist = [];
  trxlist = (await Backendless.Data.of('vwClientTrx').find(Backendless.DataQueryBuilder.create().setWhereClause(whereclause).setSortBy('clientcmpname, vendorname').setPageSize(100)));
  for (var trx_index in trxlist) {
    trx = trxlist[trx_index];
    trx['billdate'] = (await BackendlessUI.Functions.Custom['fn_40a4b1ce5bb12cc3ab9d535404cdb19d']((getObjectProperty(trx, 'billdate'))));
    trx['inv-date'] = (await BackendlessUI.Functions.Custom['fn_40a4b1ce5bb12cc3ab9d535404cdb19d']((getObjectProperty(trx, 'inv-date'))));
  }
  console.log(String('trxlist=') + String(JSON.stringify(trxlist)));
}


  await getRowData();

  return trxlist

  },
  /* handler:rowsDataLogic */
  /* content */
}))

define('./pages/bo-sendinv/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/bo-sendinv/components/e057c40eb092b1d21ccee3dcae31b63c/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var trxlist, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  trxlist = (await Backendless.Data.of('vwClientTrx').find(Backendless.DataQueryBuilder.create().setWhereClause((String('billingmethod=\'A\''))).setPageSize(100)));
  for (var j_index in trxlist) {
    j = trxlist[j_index];
    j['billdate'] = (await BackendlessUI.Functions.Custom['fn_40a4b1ce5bb12cc3ab9d535404cdb19d']((getObjectProperty(j, 'billdate'))));
  }

  return trxlist

  },
  /* handler:rowsDataLogic */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`field`]: 'select',[`headerCheckboxSelection`]: true,[`checkboxSelection`]: true,[`width`]: 70 }), ({ [`field`]: 'clientname',[`sortable`]: true,[`width`]: 250 }), ({ [`field`]: 'clientcmpname',[`sortable`]: true,[`width`]: 250 }), ({ [`field`]: 'vendorname',[`sortable`]: true,[`width`]: 250 }), ({ [`field`]: 'billaccountnumber',[`sortable`]: true,[`width`]: 200 }), ({ [`field`]: 'billdate',[`sortable`]: true,[`width`]: 150 }), ({ [`field`]: 'billamount',[`sortable`]: true,[`width`]: 150 }), ({ [`field`]: 'billdiscount',[`sortable`]: true,[`width`]: 150 }), ({ [`field`]: 'billsavings',[`sortable`]: true,[`width`]: 150 })]

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/bo-trello/components/73c99918e838a6d825e8ef580e389a32/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['listSelectedCMP'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'listBRD')), async (item) => {


   return ((getObjectProperty(item, 'companyId')).match(___arguments.value));
  }));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('1f5bcaf89b1f9328932ce9e9d93baa41', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'listSelectedCMP')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'boardName')),[`value`]: (getObjectProperty(item, 'boardId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-trello/components/1f5bcaf89b1f9328932ce9e9d93baa41/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['listSelectedBRD'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'listSelectedCMP')), async (item) => {


   return ((getObjectProperty(item, 'boardId')).match(___arguments.value));
  }));
  ___arguments.context.pageData['listSelectedBRD'] = ((getObjectProperty(___arguments.context.pageData, 'listSelectedBRD'))[0]);
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0d384288e3952558ceeffd3c9998bf57', (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'listSelectedBRD')), 'boardLists')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'listName')),[`value`]: (getObjectProperty(item, 'listId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-trello/components/0d384288e3952558ceeffd3c9998bf57/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, list, card, cardList, listid, listCardAct, cardActivity, error, cardid, cardAttachments;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function getCards(listid) {
  cardList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.trello.com/1/lists/',listid,'/cards'].join('')))).query(({ [`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());
  console.log(String('===cardList quantity=') + String(cardList.length));
  list = [];
  for (var card_index in cardList) {
    card = cardList[card_index];
    console.log(String('===card name=') + String(getObjectProperty(card, 'name')));
    console.log(String('===card=') + String(JSON.stringify(card)));
    addItemToList(list, ({ [`card`]: card,[`cardActivity`]: await getCardActivity((getObjectProperty(card, 'id'))),[`cardAttachments`]: await getCardAttachments((getObjectProperty(card, 'id'))) }));
    break;
  }
  console.log(String('cardList=') + String(JSON.stringify(list)));
  ___arguments.context.pageData['cardList'] = list;
  return list
}

/**
 * Describe this function...
 */
async function getCardActivity(cardid) {
  try {
    cardActivity = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.trello.com/1/cards/',cardid,'/actions'].join('')))).query(({ [`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());
    console.log(String('===cardActivity quantity=') + String(cardActivity.length));

  } catch (error) {

  }
  listCardAct = [];
  if (!(typeof cardActivity === 'undefined')) {
    for (var card_index2 in cardActivity) {
      card = cardActivity[card_index2];
      if ((getObjectProperty(card, 'type')) == 'commentCard') {
        addItemToList(listCardAct, ({ [`id`]: (getObjectProperty(card, 'id')),[`date`]: (new Date((getObjectProperty(card, 'date')))),[`text`]: (getObjectProperty((getObjectProperty(card, 'data')), 'text')),[`memberId`]: (getObjectProperty((getObjectProperty(card, 'memberCreator')), 'id')),[`memberName`]: (getObjectProperty((getObjectProperty(card, 'memberCreator')), 'fullName')) }));
      }
    }
  }
  return list
}

/**
 * Describe this function...
 */
async function getCardAttachments(cardid) {
  cardAttachments = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.trello.com/1/cards/',cardid,'/attachments'].join('')))).query(({ [`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());
  console.log(String('===cardAttachment quantity=') + String(cardAttachments.length));
  list = [];
  if (!(typeof cardAttachments === 'undefined')) {
    for (var card_index3 in cardAttachments) {
      card = cardAttachments[card_index3];
      addItemToList(list, ({ [`id`]: (getObjectProperty(cardAttachments, 'id')),[`date`]: (new Date((getObjectProperty(cardAttachments, 'date')))),[`fileName`]: (getObjectProperty(cardAttachments, 'name')),[`url`]: (getObjectProperty(cardAttachments, 'url')),[`memberId`]: (getObjectProperty(cardAttachments, 'idMember')) }));
    }
  }
  return list
}


  ___arguments.context.pageData['listSelectedLST'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'listSelectedBRD')), 'boardLists')), async (item) => {


   return ((getObjectProperty(item, 'listId')).match(___arguments.value));
  }));
  ___arguments.context.pageData['listSelectedLST'] = ((getObjectProperty(___arguments.context.pageData, 'listSelectedLST'))[0]);
  ___arguments.context.pageData['listSelectedCards'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'listSelectedLST')), 'cards'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/bo-trello/components/b6184a6e622d6276a258f6983fa879b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var objClientTrx, dgRow, selectedRows, clientOBJ, selectedClient, listobj, fndBillDate, listitem, fndCmpname, fndCustnumber, fndTimezone, fndEmail, fndPhone, fndZip, fndState, fndCity, fndAddr, fndFirstname, fndLastname, fndAcct, fndAgent, list, item_list, item_value, item_label, parsedItem, miscCount, parsedDesc, desc, selectedState, inputState, inState, client, j, listkey, listCardAtt, card, cardAttachments, error, cardid, x, selectedCommPct, selectedAgent, selectedVendor, inEmail, x_start, text, x_end, descObj;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateClient(clientOBJ) {
  console.log('=00= START Create New Client');
  selectedClient = ({ [`cmpname`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'cmpname')),[`lastname`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'lastname')),[`firstname`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'firstname')),[`addr1`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'addr1')),[`addr2`]: '',[`city`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'city')),[`state`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'state')),[`zip_postalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'phone1')),[`phone2`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'phone2')),[`phone3`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'phone3')),[`email`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'email')),[`agentid`]: undefined,[`agentemail`]: undefined,[`clientType`]: undefined,[`AgrDocDate`]: undefined,[`AgrDocLink`]: undefined,[`AgrSigDate`]: undefined,[`AgrSigLink`]: undefined,[`isAGRcomplete`]: false,[`isACHcomplete`]: false,[`ACHcompleteDate`]: undefined,[`CSAactive`]: 0,[`CSApending`]: 0,[`isClient`]: true,[`lastBilledDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'dateLastAct')),[`billingentity`]: (getObjectProperty(___arguments.context.pageData, 'Select-Cmp')),[`billingmethod`]: undefined,[`accountholdername`]: undefined,[`achrout`]: undefined,[`achacct`]: undefined,[`achauth`]: false,[`ccacct`]: undefined,[`ccexpdt`]: undefined,[`cccvc`]: undefined,[`ccauth`]: false,[`ccfeeauth`]: false,[`zelleid`]: undefined,[`othClientid`]: undefined,[`othPO`]: undefined,[`approvalcode`]: 'trello',[`approvaldate`]: (new Date()) });
  console.log(String('selectedClient B4 add/upd=') + String(JSON.stringify(selectedClient)));
  ___arguments.context.pageData['selectedClient'] = (await Backendless.Data.of('Clients').save( selectedClient ));
  console.log(String('selectedClient AF=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedClient')))));
  await SetStateRelations((getObjectProperty((getObjectProperty(clientOBJ, 'desc')), 'state')));
  await SetClientType();
  console.log(String('=00= selected client=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedClient')))));
  console.log('=00= END Create New Client');
}

/**
 * Describe this function...
 */
async function CreateDescObject(list) {
  console.log('== CreateDescObject START');
  ___arguments.context.pageData['descObj'] = ({ [`clientid`]: undefined,[`custnumber`]: undefined,[`cmpname`]: undefined,[`firstname`]: undefined,[`lastname`]: undefined,[`address`]: undefined,[`city`]: undefined,[`state`]: undefined,[`zip`]: undefined,[`country`]: undefined,[`phone1`]: undefined,[`phone2`]: undefined,[`phone3`]: undefined,[`email`]: undefined,[`timezone`]: undefined,[`billingentity`]: undefined,[`agentid`]: undefined,[`agentemail`]: undefined,[`agentSplit`]: [],[`vendorAccountNumber`]: undefined,[`vendorName`]: undefined,[`vendorAuthorizations`]: [],[`vendorBillSchedule`]: undefined,[`dateLastAct`]: undefined,[`dateDue`]: undefined,[`trelloLink`]: undefined,[`attachments`]: [] });
  for (var listitem_index in list) {
    listitem = list[listitem_index];
    console.log(String('listitem=') + String(JSON.stringify(listitem)));
    if (fndAgent != true) {
      listobj = await FindValue(({ [`listkey`]: 'agents',[`listitem`]: listitem,[`listsw`]: fndAgent,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['agentSplit'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndAcct != true) {
      listobj = await FindValue(({ [`listkey`]: 'acct',[`listitem`]: listitem,[`listsw`]: fndAcct,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['vendorAccountNumber'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndLastname != true) {
      listobj = await FindValue(({ [`listkey`]: 'lastname',[`listitem`]: listitem,[`listsw`]: fndLastname,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['lastname'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndFirstname != true) {
      listobj = await FindValue(({ [`listkey`]: 'firstname',[`listitem`]: listitem,[`listsw`]: fndFirstname,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['firstname'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndAddr != true) {
      listobj = await FindValue(({ [`listkey`]: 'address',[`listitem`]: listitem,[`listsw`]: fndAddr,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['address'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndCity != true) {
      listobj = await FindValue(({ [`listkey`]: 'city',[`listitem`]: listitem,[`listsw`]: fndCity,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['city'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndState != true) {
      listobj = await FindValue(({ [`listkey`]: 'state',[`listitem`]: listitem,[`listsw`]: fndState,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['state'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndZip != true) {
      listobj = await FindValue(({ [`listkey`]: 'zip',[`listitem`]: listitem,[`listsw`]: fndZip,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['zip'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndZip != true) {
      listobj = await FindValue(({ [`listkey`]: 'zip',[`listitem`]: listitem,[`listsw`]: fndZip,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['zip'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndPhone != true) {
      listobj = await FindValue(({ [`listkey`]: 'phone',[`listitem`]: listitem,[`listsw`]: fndPhone,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['phone'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndEmail != true) {
      listobj = await FindValue(({ [`listkey`]: 'email',[`listitem`]: listitem,[`listsw`]: fndEmail,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['email'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndTimezone != true) {
      listobj = await FindValue(({ [`listkey`]: 'timezone',[`listitem`]: listitem,[`listsw`]: fndTimezone,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['timezone'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndCustnumber != true) {
      listobj = await FindValue(({ [`listkey`]: 'custnumber',[`listitem`]: listitem,[`listsw`]: fndCustnumber,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['custnumber'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndCmpname != true) {
      listobj = await FindValue(({ [`listkey`]: 'cmpname',[`listitem`]: listitem,[`listsw`]: fndCmpname,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['cmpname'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
    if (fndBillDate != true) {
      listobj = await FindValue(({ [`listkey`]: 'billdate',[`listitem`]: listitem,[`listsw`]: fndBillDate,[`listvalue`]: null }));
      if ((getObjectProperty(listobj, 'listsw')) == true) {
        (getObjectProperty(___arguments.context.pageData, 'descObj'))['billdate'] = ((getObjectProperty(listobj, 'listvalue')).split(',', 100));
      }
    }
  }
  await FillDescobjExtras();
  console.log(String('descObj=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'descObj')))));
  console.log('== CreateDescObject END');
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function ParseDesc(desc) {
  console.log('== ParseDesc START');
  console.log(String('inputDesc=') + String(JSON.stringify(desc)));
  desc = (desc.replace('\t', ''));
  parsedDesc = (desc.split('\n', 100));
  miscCount = 0;
  item_list = [];
  for (var parsedItem_index in parsedDesc) {
    parsedItem = parsedDesc[parsedItem_index];
    if (!(typeof parsedItem === 'undefined') && getValueLength(parsedItem) > 0) {
      if (parsedItem.indexOf(':') + 1 > 0) {
        item_label = parsedItem.slice(0, (parsedItem.indexOf(':') + 1) - 1);
        item_value = parsedItem.slice(((parsedItem.indexOf(':') + 1 + 1) - 1), parsedItem.length).trim();
      } else {
        miscCount = (typeof miscCount == 'number' ? miscCount : 0) + 1;
        item_label = String('misc-') + String(miscCount);
        item_value = parsedItem.trim();
      }
      addItemToList(item_list, ({ [`item-label`]: item_label,[`item-value`]: item_value }));
    }
  }
  console.log(String('item-list=') + String(JSON.stringify(item_list)));
  console.log('==ParseDesc END');
  return item_list
}

/**
 * Describe this function...
 */
async function GetStateOBJ(inputState) {
  selectedState = (await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2=\'',inputState,'\''].join(''))).setRelationsDepth(1).setPageSize(10)))[0];
  console.log('=END GetStateOBJ =');
  return selectedState
}

/**
 * Describe this function...
 */
async function SetStateRelations(inState) {
  console.log('=00= START set state relations');
  console.log(String('Incoming State=') + String(inState));
  console.log(String('=00= set state relations - DB Updates=') + String((await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'objectId')) }), 'state', [await GetStateOBJ(inState)]))));
  (getObjectProperty(___arguments.context.pageData, 'selectedClient'))['state'] = inState;
  console.log('=00= END set state relations');
}

/**
 * Describe this function...
 */
async function DoesClientExist() {
  ___arguments.context.pageData['DCEwhereClause'] = undefined;
  client = (await Backendless.Data.of('Clients').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'DCEwhereClause'))).setRelationsDepth(1).setPageSize(10)))[0];
}

/**
 * Describe this function...
 */
async function SetClientType() {
  console.log('=00= START set client type');
  ___arguments.context.pageData['ClientType'] = ((await Backendless.Data.of('ClientType').find(Backendless.DataQueryBuilder.create().setWhereClause((((getObjectProperty(selectedClient, 'cmpname')) === null) || getValueLength((getObjectProperty(selectedClient, 'cmpname'))) == 0 ? 'clientTypeId=2' : 'clientTypeId=1')).setPageSize(10)))[0]);
  (getObjectProperty(___arguments.context.pageData, 'selectedClient'))['clientType'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'objectId')) }), 'clientType', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'ClientType')), 'objectId'))]));
  console.log('=00= END set client type');
}

/**
 * Describe this function...
 */
async function FindValue(listobj) {
  if (listkey == 'acct') {
    list = ['acct#'.toLowerCase(), 'Account Number:'.toLowerCase(), 'Account:'.toLowerCase()];
  } else if (listkey == 'lastname') {
    list = ['last name:'.toLowerCase(), 'lastname'.toLowerCase(), 'owner'.toLowerCase(), 'administrator last name'.toLowerCase()];
  } else if (listkey == 'firstname') {
    list = ['first name:'.toLowerCase(), 'firstname'.toLowerCase(), 'owner'.toLowerCase(), 'administrator first name'.toLowerCase()];
  } else if (listkey == 'address') {
    list = ['addr'.toLowerCase(), 'address'.toLowerCase(), 'service address'.toLowerCase()];
  } else if (listkey == 'city') {
    list = ['City'.toLowerCase()];
  } else if (listkey == 'state') {
    list = ['State'.toLowerCase()];
  } else if (listkey == 'zip') {
    list = ['zip'.toLowerCase(), 'zip code'.toLowerCase(), 'zipcode'.toLowerCase(), 'postal code'.toLowerCase(), 'postalcode'.toLowerCase()];
  } else if (listkey == 'phone') {
    list = ['phone'.toLowerCase(), 'Registered Phone:'.toLowerCase()];
  } else if (listkey == 'email') {
    list = ['email'.toLowerCase(), 'email address'.toLowerCase()];
  } else if (listkey == 'timezone') {
    list = ['timezone'.toLowerCase()];
  } else if (listkey == 'agents') {
    list = ['agents'.toLowerCase()];
  } else if (listkey == 'cmpname') {
    list = ['business name'.toLowerCase(), 'company'.toLowerCase(), 'company name'.toLowerCase(), null];
  } else if (listkey == 'vndname') {
    list = ['vendor name'.toLowerCase(), 'vendor'.toLowerCase(), 'vendorname'.toLowerCase()];
  } else if (listkey == 'pin') {
    list = ['pin'.toLowerCase(), 'cpni'.toLowerCase(), 'cpin'.toLowerCase()];
  }
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty(listitem, 'item-label')).toLowerCase() == j) {
      listobj['listvalue'] = (getObjectProperty(listitem, 'item-value'));
      listobj['listsw'] = true;
      break;
    }
  }
  return listobj
}

/**
 * Describe this function...
 */
async function SetAgentRelations() {
  console.log('=00= set agent relations');
  ___arguments.context.pageData['agent'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agent')), 'objectId'))]));
  console.log('=00= set agent relations END');
}

/**
 * Describe this function...
 */
async function getCardAttachments(cardid) {
  cardAttachments = [];
  if (0 > 0) {
  }
  try {
    cardAttachments = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.trello.com/1/cards/',cardid,'/attachments'].join('')))).query(({ [`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());

  } catch (error) {

  }
  listCardAtt = [];
  if (!(typeof cardAttachments === 'undefined')) {
    for (var card_index in cardAttachments) {
      card = cardAttachments[card_index];
      addItemToList(listCardAtt, ({ [`id`]: (getObjectProperty(card, 'id')),[`date`]: (new Date((getObjectProperty(card, 'date')))),[`name`]: (getObjectProperty(card, 'name')),[`fileName`]: (getObjectProperty(card, 'fileName')),[`url`]: (getObjectProperty(card, 'url')) }));
    }
  }
  return listCardAtt
}

/**
 * Describe this function...
 */
async function FillDescobjExtras() {
  if ((getObjectProperty(dgRow, 'name')).indexOf(' - ') + 1 > 0) {
    x = ((getObjectProperty(dgRow, 'name')).split(' - ', 100));
    if (x[0].trim().indexOf(' ') + 1 > 0) {
      j = ((x[0].trim()).split(' ', 100));
      x = [j[0].trim(), j.slice(-1)[0].trim(), x.slice(-1)[0].trim()];
    } else {
      x = [x[0].trim(), '', x.slice(-1)[0].trim()];
    }
  } else {
    x = ['', '', (getObjectProperty(dgRow, 'name'))];
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'vendorName')) == '') {
    (getObjectProperty(___arguments.context.pageData, 'descObj'))['vendorName'] = (x.slice(-1)[0].trim());
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'lastname')) == '') {
    (getObjectProperty(___arguments.context.pageData, 'descObj'))['lastname'] = (x[1].trim());
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'descObj')), 'firstname')) == '') {
    (getObjectProperty(___arguments.context.pageData, 'descObj'))['firstname'] = (x[0].trim());
  }
  (getObjectProperty(___arguments.context.pageData, 'descObj'))['dateLastAct'] = ((getObjectProperty(dgRow, 'dateLastActivity')).valueOf());
  (getObjectProperty(___arguments.context.pageData, 'descObj'))['dateDue'] = (((getObjectProperty(dgRow, 'due')) === null) || (typeof (getObjectProperty(dgRow, 'due')) === 'undefined') ? '' : ((getObjectProperty(dgRow, 'due')).valueOf()));
  (getObjectProperty(___arguments.context.pageData, 'descObj'))['trelloLink'] = (getObjectProperty(dgRow, 'url'));
  (getObjectProperty(___arguments.context.pageData, 'descObj'))['attachments'] = (getObjectProperty(dgRow, 'url'));
}

/**
 * Describe this function...
 */
async function CreateCommPct() {
  console.log('=00= START CreateCommPct');
  selectedCommPct = ({ [`clientid`]: (getObjectProperty(selectedClient, 'clientid')),[`vendorid`]: (getObjectProperty(selectedVendor, 'vendorid')),[`vendorAccountNumber`]: (getObjectProperty(selectedClient, 'vendorAccountNumber')),[`commPercentage`]: (getObjectProperty(selectedVendor, 'commPercentage')),[`agentid`]: (getObjectProperty(selectedAgent, 'agentid')) });
  console.log(String('selectedCommPct B4 add/upd=') + String(JSON.stringify(selectedCommPct)));
  ___arguments.context.pageData['selectedCommPct'] = (await Backendless.Data.of('CommissionMaster').save( selectedCommPct ));
  console.log(String('selectedCommPct AF=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedCommPct')))));
  console.log('=00= END CreateCommPct');
}

/**
 * Describe this function...
 */
async function CreateVendor() {
  console.log('=00= START Create Vendor');
  selectedVendor = ({ [`vendorname`]: (getObjectProperty((getObjectProperty(descObj, 'desc')), 'vendorname')),[`catid`]: undefined,[`addr1`]: undefined,[`addr2`]: undefined,[`city`]: undefined,[`state`]: undefined,[`zip_postalcode`]: undefined,[`contactname`]: undefined,[`contactemail`]: undefined,[`contactphone`]: undefined });
  console.log(String('selectedVendor B4 add/upd=') + String(JSON.stringify(selectedVendor)));
  ___arguments.context.pageData['selectedVendor'] = (await Backendless.Data.of('Vendors').save( selectedVendor ));
  console.log(String('selectedClient AF=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedVendor')))));
  console.log('=00= END Create Vendor');
}

/**
 * Describe this function...
 */
async function CleanupEmail(inEmail) {
  if (inEmail.indexOf('[') + 1 > 0) {
    x_start = inEmail.indexOf('[') + 1 + 1;
    x_end = (inEmail.indexOf(']') + 1) - 1;
    x = inEmail.slice((x_start - 1), x_end);
  } else if (inEmail.indexOf('mailto:') + 1 > 0) {
    x_start = inEmail.indexOf('mailto:') + 1 + 1;
    x = ((text.slice((x_start - 1), text.length)).replace('\"', '')).trim();
  } else {
    x = inEmail;
  }
  return x
}


  selectedRows = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('7c6b7fb8735805b5f882c4538d68c4f8'));
  for (var dgRow_index in selectedRows) {
    dgRow = selectedRows[dgRow_index];
    console.log(String('dgRow=') + String(JSON.stringify(dgRow)));
    await CreateDescObject(await ParseDesc((getObjectProperty(dgRow, 'desc'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bo-trello/components/7c6b7fb8735805b5f882c4538d68c4f8/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`field`]: 'select',[`headerCheckboxSelection`]: true,[`checkboxSelection`]: true,[`width`]: 60 }), ({ [`field`]: 'name',[`sortable`]: true,[`width`]: 240 }), ({ [`field`]: 'dateLastActivity',[`sortable`]: true,[`width`]: 150 }), ({ [`field`]: 'due',[`sortable`]: true,[`width`]: 150 }), ({ [`field`]: 'desc',[`sortable`]: true,[`width`]: 500 })]

  },
  /* handler:columnDefsLogic */
  /* handler:heightLogic */
  ['heightLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(120 + (getObjectProperty(___arguments.context.pageData, 'listSelectedCards')).length * 50) + String('px'))

  },
  /* handler:heightLogic */
  /* content */
}))

define('./pages/bo-trello/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var apiResults, apiResultsObject, board, card, cardActivity, cardAttachments, cardid, cardList, cmp, error, item, list, listBoards, listCardAct, listCardAtt, listCards, listid, listLists, lst;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function getBoards() {
  listBoards = [];
  var cmp_list = (getObjectProperty(___arguments.context.pageData, 'listCMP'));
  for (var cmp_index in cmp_list) {
    cmp = cmp_list[cmp_index];
    for (var board_index in apiResults) {
      board = apiResults[board_index];
      if ((getObjectProperty(board, 'name')).indexOf(getObjectProperty(cmp, 'value')) + 1 > 0) {
        listLists = [];
        var lst_list = (getObjectProperty(board, 'lists'));
        for (var lst_index in lst_list) {
          lst = lst_list[lst_index];
          if ((getObjectProperty(lst, 'closed')) == false) {
            addItemToList(listLists, ({ [`listId`]: (getObjectProperty(lst, 'id')),[`listName`]: (getObjectProperty(lst, 'name')),[`cards`]: await getCards((getObjectProperty(lst, 'id'))) }));
          }
        }
        addItemToList(listBoards, ({ [`companyId`]: (getObjectProperty(cmp, 'value')),[`boardId`]: (typeof (getObjectProperty(board, 'id')) === 'undefined') ? 'invalid ID' : (getObjectProperty(board, 'id')),[`boardName`]: (typeof (getObjectProperty(board, 'name')) === 'undefined') ? 'invalid NAME' : (getObjectProperty(board, 'name')),[`boardLists`]: listLists }));
      }
    }
  }
  ___arguments.context.pageData['listBRD'] = listBoards;
}

/**
 * Describe this function...
 */
async function getCompany() {
  ___arguments.context.pageData['listCMP'] = [];
  addItemToList((getObjectProperty(___arguments.context.pageData, 'listCMP')), ({ [`label`]: 'GPR',[`value`]: 'GPR' }));
  addItemToList((getObjectProperty(___arguments.context.pageData, 'listCMP')), ({ [`label`]: 'BRS',[`value`]: 'BRS' }));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('73c99918e838a6d825e8ef580e389a32', (getObjectProperty(___arguments.context.pageData, 'listCMP')));
}

/**
 * Describe this function...
 */
async function getCardActivity(cardid) {
  cardActivity = [];
  try {
    cardActivity = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.trello.com/1/cards/',cardid,'/actions'].join('')))).query(({ [`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());
    console.log(String('===cardActivity quantity=') + String(cardActivity.length));

  } catch (error) {

  }
  listCardAct = [];
  if (!(typeof cardActivity === 'undefined')) {
    for (var card_index in cardActivity) {
      card = cardActivity[card_index];
      if ((getObjectProperty(card, 'type')) == 'commentCard') {
        addItemToList(listCardAct, ({ [`id`]: (getObjectProperty(card, 'id')),[`date`]: (new Date((getObjectProperty(card, 'date')))),[`text`]: (getObjectProperty((getObjectProperty(card, 'data')), 'text')),[`memberId`]: (getObjectProperty((getObjectProperty(card, 'memberCreator')), 'id')),[`memberName`]: (getObjectProperty((getObjectProperty(card, 'memberCreator')), 'fullName')) }));
      }
    }
  }
  return listCardAct
}

/**
 * Describe this function...
 */
async function getCards(listid) {
  try {
    cardList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.trello.com/1/lists/',listid,'/cards/attachments=true'].join('')))).query(({ [`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());

  } catch (error) {

  }
  listCards = [];
  for (var card_index2 in cardList) {
    card = cardList[card_index2];
    addItemToList(listCards, ({ [`card`]: card,[`Activity`]: undefined,[`Attachments`]: undefined }));
  }
  ___arguments.context.pageData['cardList'] = listCards;
  return listCards
}

/**
 * Describe this function...
 */
async function getApiData() {
  try {
    apiResults = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.trello.com/1/members/me/boards')).query(({ [`lists`]: 'all',[`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());
    console.log(String('apiResults count=') + String(apiResults.length));
    console.log(String('apiResults=') + String(JSON.stringify(apiResults)));
    ___arguments.context.pageData['listBRD'] = (await Promise.all(apiResults.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'name')),[`value`]: (getObjectProperty(item, 'id')) });})));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function getCardAttachments(cardid) {
  cardAttachments = [];
  try {
    cardAttachments = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://api.trello.com/1/cards/',cardid,'/attachments'].join('')))).query(({ [`key`]: (getObjectProperty(___arguments.context.pageData, 'trelloKey')),[`token`]: (getObjectProperty(___arguments.context.pageData, 'trelloToken')) })).set(({ [`Accept`]: 'application/json' })).setEncoding('utf8').send());

  } catch (error) {

  }
  listCardAtt = [];
  if (!(typeof cardAttachments === 'undefined')) {
    for (var card_index3 in cardAttachments) {
      card = cardAttachments[card_index3];
      addItemToList(listCardAtt, ({ [`id`]: (getObjectProperty(card, 'id')),[`date`]: (new Date((getObjectProperty(card, 'date')))),[`name`]: (getObjectProperty(card, 'name')),[`fileName`]: (getObjectProperty(card, 'fileName')),[`url`]: (getObjectProperty(card, 'url')) }));
    }
  }
  return listCardAtt
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
    ___arguments.context.pageData['BillingMethod'] = 'ALL';
  }
  ___arguments.context.pageData['trelloKey'] = '2e1eeea35f7797988f21da97b5fb88af';
  ___arguments.context.pageData['trelloToken'] = 'ATTAbe91b24313d7c23b484567e8e1fb0a7f0aa5dea300bb4e7b6a674abed849ef08721009A0';
  ___arguments.context.pageData['listSelectedCards'] = [];
  ___arguments.context.pageData['showSpinner1'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45188a2b9b9ed2c138483d48fda832a8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73c99918e838a6d825e8ef580e389a32', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f5bcaf89b1f9328932ce9e9d93baa41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d384288e3952558ceeffd3c9998bf57', false);
  console.log('=PG= getCompany START');
  await getCompany();
  console.log('=PG= getApiData START');
  await getApiData();
  console.log('=PG= getBoards START');
  await getBoards();
  console.log('=PG= getBoards END');
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['showSpinner1'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45188a2b9b9ed2c138483d48fda832a8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73c99918e838a6d825e8ef580e389a32', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f5bcaf89b1f9328932ce9e9d93baa41', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d384288e3952558ceeffd3c9998bf57', true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/cli_data_import/components/2e289d0c1259b2288d882a9123ccd137/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showDtClientProfile'] = false;
  ___arguments.context.pageData['showDtClientBills'] = false;
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'formFields')), 'form-U1-UG')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_data_import/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formFields'] = ({ [`d1-UG`]: '/documents/ClientDataTemplate_UserGuide.pdf',[`d1-DT`]: '/documents/ClientDataTemplate.csv',[`d2-UG`]: '/documents/ClientBillsTemplate_UserGuide.pdf',[`d2-DT`]: '/documents/ClientBillsTemplate.csv',[`img`]: '/images/btn_dn_green.png',[`exportDomain`]: 'https://perkycollar.backendless.app/api/files',[`btnImage`]: '',[`formURL1`]: '',[`formURL2`]: '' });
  (getObjectProperty(___arguments.context.pageData, 'formFields'))['form-U1-UG'] = (String(getObjectProperty(___arguments.context.pageData, 'formFields.exportDomain')) + String(getObjectProperty(___arguments.context.pageData, 'formFields.d1-UG')));
  (getObjectProperty(___arguments.context.pageData, 'formFields'))['form-U1-DT'] = (String(getObjectProperty(___arguments.context.pageData, 'formFields.exportDomain')) + String(getObjectProperty(___arguments.context.pageData, 'formFields.d1-DT')));
  (getObjectProperty(___arguments.context.pageData, 'formFields'))['form-U2-UG'] = (String(getObjectProperty(___arguments.context.pageData, 'formFields.exportDomain')) + String(getObjectProperty(___arguments.context.pageData, 'formFields.d2-UG')));
  (getObjectProperty(___arguments.context.pageData, 'formFields'))['form-U2-DT'] = (String(getObjectProperty(___arguments.context.pageData, 'formFields.exportDomain')) + String(getObjectProperty(___arguments.context.pageData, 'formFields.d2-DT')));
  (getObjectProperty(___arguments.context.pageData, 'formFields'))['btnImage'] = (String(getObjectProperty(___arguments.context.pageData, 'formFields.exportDomain')) + String(getObjectProperty(___arguments.context.pageData, 'formFields.img')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/cli_data_import/components/53a6360a9e03375db695f0290ba7cc81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showDtClientProfile'] = false;
  ___arguments.context.pageData['showDtClientBills'] = false;
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'formFields')), 'form-U1-DT')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_data_import/components/a624cfdd3436a5fc9deaaae98d2aafc2/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['client-upload-FN'] = (['1','-',((new Date()).valueOf()),'-',(getObjectProperty(___arguments.file, 'name'))].join(''));

  return (getObjectProperty(___arguments.context.pageData, 'client-upload-FN'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var icnt, i, client, file1, clientagent, clientstate, clientobj, searchtext, inAgent, inState;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function addClient() {
  console.log('==START addUpdClient ==');
  client = (await Backendless.Data.of('Clients').deepSave( (await CreateClientObject()) ));
  console.log(String('==client saved = ') + String(JSON.stringify(client)));
  if (!((getObjectProperty(___arguments.context.pageData, 'state')) === null)) {
    clientstate = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'state')), 'objectId'))]));
  }
  if (!((getObjectProperty(___arguments.context.pageData, 'agent')) === null)) {
    clientagent = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agent')), 'objectId'))]));
  }
  console.log('==END addUpdClient ==');
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function CreateClientObject() {
  clientobj = ({ [`active`]: i[0] == '' || (typeof (i[0]) === 'undefined') ? false : (i[0] == 'Y' ? true : false),[`clientid`]: (Number((i[1]))),[`lastname`]: i[2],[`firstname`]: i[3],[`cmpname`]: i[4],[`addr1`]: i[5],[`addr2`]: i[6],[`city`]: i[7],[`state`]: undefined,[`zip_postalcode`]: getValueLength(i[9]) == 4 ? String(0) + String(i[9]) : i[9],[`country`]: i[10],[`phone1`]: i[11] == '' || (typeof (i[11]) === 'undefined') ? null : i[11],[`phone2`]: i[12] == '' || (typeof (i[12]) === 'undefined') ? null : i[12],[`phone3`]: i[13] == '' || (typeof (i[13]) === 'undefined') ? null : i[13],[`email`]: i[14] == '' || (typeof (i[14]) === 'undefined') ? null : i[14],[`custnumber`]: i[15] == '' || (typeof (i[15]) === 'undefined') ? 0 : (Number((i[15]))),[`billingentity`]: i[16],[`agentid`]: undefined,[`clienttype`]: i[18],[`agrdocdate`]: i[19] == '' || (typeof (i[19]) === 'undefined') || ((i[19]) === null) ? (new Date('01/01/1900')) : (new Date((i[19]))),[`agrsigdate`]: i[20] == '' || (typeof (i[20]) === 'undefined') || ((i[20]) === null) ? (new Date('01/01/1900')) : (new Date((i[20]))),[`isagrcomplete`]: i[21] == '' || (typeof (i[21]) === 'undefined') ? false : (i[21] == 'Y' ? true : false),[`billingmethod`]: i[22],[`achrout`]: i[23],[`achacct`]: i[24],[`achauth`]: i[25] == '' || (typeof (i[25]) === 'undefined') ? false : (i[25] == 'Y' ? true : false),[`isachcomplete`]: i[26] == '' || (typeof (i[26]) === 'undefined') ? false : (i[26] == 'Y' ? true : false),[`achcompletedate`]: i[27] == '' || (typeof (i[27]) === 'undefined') ? (new Date('01/01/1900')) : i[27],[`accountholdername`]: i[28],[`ccacct`]: i[29],[`ccexpdt`]: i[30],[`cccvc`]: i[31],[`ccauth`]: i[32] == '' || (typeof (i[32]) === 'undefined') ? false : (i[32] == 'Y' ? true : false),[`ccfeeauth`]: i[33] == '' || (typeof (i[33]) === 'undefined') ? false : (i[33] == 'Y' ? true : false),[`zelleid`]: i[34],[`othpo`]: i[35],[`othclientid`]: i[37] == '' || (typeof (i[37]) === 'undefined') ? 0 : (Number((i[36]))),[`approvaldate`]: i[37] == '' || (typeof (i[37]) === 'undefined') || ((i[37]) === null) ? (new Date()) : (new Date((i[37]))),[`approvalcode`]: i[38],[`isClient`]: true });
  ___arguments.context.pageData['ClientObj'] = clientobj;
  return clientobj
}

/**
 * Describe this function...
 */
async function UpdClient() {
  console.log('==START UpdClient ==');
  client = (await Backendless.Data.of('Clients').save( (await CreateClientObject()) ));
  console.log(String('==client saved = ') + String(JSON.stringify(client)));
  if (!((getObjectProperty(___arguments.context.pageData, 'state')) === null)) {
    clientstate = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'state')), 'objectId'))]));
  }
  if (!((getObjectProperty(___arguments.context.pageData, 'agent')) === null)) {
    clientagent = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agent')), 'objectId'))]));
  }
  console.log('==END addUpdClient ==');
}

/**
 * Describe this function...
 */
async function DoesClientExist() {
  client = (await Backendless.Data.of('Clients').find(Backendless.DataQueryBuilder.create().setPageSize(10)))[0];
  console.log(String('DCE client result=') + String(JSON.stringify((getObjectProperty(client, 'clientid')))));
}

/**
 * Describe this function...
 */
async function GetStateRecord(inState) {
  ___arguments.context.pageData['state'] = ((typeof inState === 'undefined') || (inState === null) ? null : (await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2=\'',inState,'\''].join(''))).setPageSize(10)))[0]);
}

/**
 * Describe this function...
 */
async function GetAgentRecord(inAgent) {
  if (inAgent == '' || (typeof inAgent === 'undefined') || (inAgent === null)) {
    searchtext = String('agentid=') + String('1');
  } else {
    searchtext = String('agentid=') + String(inAgent);
  }
  ___arguments.context.pageData['agent'] = ((await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause(searchtext).setPageSize(10)))[0]);
}


  ___arguments.context.pageData['showDtClientProfile'] = true;
  ___arguments.context.pageData['showDtClientBills'] = false;
  console.log('=====read each uploaded file');
  console.log(String('UploadFiles=') + String(___arguments.uploadedFiles));
  file1 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/csv2list`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...true, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'csvURL': ___arguments.uploadedFiles }));
  icnt = 1;
  for (var i_index in file1) {
    i = file1[i_index];
    if (icnt == 1) {
      icnt = (typeof icnt == 'number' ? icnt : 0) + 1;
    } else {
      console.log(['REC ','cmpname=',i[4],' / lastname=',i[2]].join(''));
      await DoesClientExist();
      await GetStateRecord(i[8]);
      await GetAgentRecord(i[17]);
      if (typeof client === 'undefined') {
        console.log(String('ADD client=') + String(JSON.stringify(i)));
        await addClient();
      } else {
        console.log(String('UPD client=') + String(JSON.stringify(i)));
        await UpdClient();
      }
      icnt = (typeof icnt == 'number' ? icnt : 0) + 1;
    }
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      console.log(___arguments.error);
  console.log(String('pagedata=') + String(JSON.stringify(___arguments.context.pageData)));
  console.log(String('appdata=') + String(JSON.stringify(___arguments.context.appData)));

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/cli_data_import/components/25922367c7a7c651155f24b510aa3f28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showDtClientProfile'] = false;
  ___arguments.context.pageData['showDtClientBills'] = false;
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'formFields')), 'form-U2-UG')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_data_import/components/e99bcd7fd68b7255b473f84e26a7801f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showDtClientProfile'] = false;
  ___arguments.context.pageData['showDtClientBills'] = false;
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'formFields')), 'form-U2-DT')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_data_import/components/3417dd45581960a79fab5fac067eef3f/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var filename;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  filename = ['2','-',((new Date()).valueOf()),'-',(getObjectProperty(___arguments.file, 'name'))].join('');
  console.log(String('filename=') + String(JSON.stringify(filename)));

  return (JSON.stringify(filename))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      console.log(___arguments.error);
  console.log(String('pagedata=') + String(JSON.stringify(___arguments.context.pageData)));
  console.log(String('appdata=') + String(JSON.stringify(___arguments.context.appData)));

  },
  /* handler:onUploadFail */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var icnt, agent, i, vendor, client, file1, activityagent, clientactivity, activityvendor, activityclient, baselinerec, clientSearchString, vendorSearchString, fieldname, fieldpos, fieldnum, batchtype, logdatarow, batchid, batchdate, vendname, rptData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetAgentRecord() {
  if ((typeof (i[14]) === 'undefined') || !i[14].length) {
    ___arguments.context.pageData['agentcss'] = (String('agentid=') + String(getObjectProperty(client, 'agentid.agentid')));
  } else {
    ___arguments.context.pageData['agentcss'] = (String('agentid=') + String(i[14]));
  }
  agent = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'agentcss'))).setPageSize(10)))[0];
}

/**
 * Describe this function...
 */
async function DoesClientExist() {
  ___arguments.context.pageData['DCEwhereClause'] = (await ClientSearchString());
  client = (await Backendless.Data.of('Clients').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'DCEwhereClause'))).setRelationsDepth(1).setPageSize(10)))[0];
}

/**
 * Describe this function...
 */
async function CreateCAO() {
  baselinerec = (await BackendlessUI.Functions.Custom['fn_a31cc1e78e8181c26dea68480a76ff51']((getObjectProperty(client, 'clientid')), (getObjectProperty(vendor, 'vendorid')), (i[10])));
  ___arguments.context.pageData['ClientActivityObj'] = ({ [`clientid`]: null,[`vendorid`]: null,[`billaccountnumber`]: i[10],[`billdate`]: ((new Date((i[11]))).valueOf()),[`billamount`]: i[12],[`billbaseline`]: i[13] == 'Y' ? true : false,[`billprocessed`]: false,[`billbaseamt`]: i[13] == 'Y' ? i[12] : (getObjectProperty(baselinerec, 'billamount')),[`billsavingsTOT`]: i[13] == 'Y' ? 0 : (getObjectProperty(baselinerec, 'billamount')) - i[12],[`billsavingsGPR`]: i[13] == 'Y' ? 0 : ((getObjectProperty(baselinerec, 'billamount')) - i[12]) / 2,[`agentid`]: null });
  clientactivity = (await Backendless.Data.of('ClientTrx').save( (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj')) ));
  activityclient = (await Backendless.Data.of('ClientActivity').setRelation(({ [`objectId`]: (getObjectProperty(clientactivity, 'objectId')) }), 'clientid', [(getObjectProperty(client, 'objectId'))]));
  activityvendor = (await Backendless.Data.of('ClientActivity').setRelation(({ [`objectId`]: (getObjectProperty(clientactivity, 'objectId')) }), 'vendorid', [(getObjectProperty(vendor, 'objectId'))]));
  activityagent = (await Backendless.Data.of('ClientActivity').setRelation(({ [`objectId`]: (getObjectProperty(clientactivity, 'objectId')) }), 'agentid', [(getObjectProperty(agent, 'objectId'))]));
}

/**
 * Describe this function...
 */
async function ClientSearchString() {
  await GetParam('clientid', 1, true);
  await GetParam('lastname', 2, false);
  await GetParam('cmpname', 4, false);
  await GetParam('addr1', 5, false);
  await GetParam('city', 7, false);
  await GetParam('state', 8, false);
  clientSearchString = '';
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'clientid')) === 'undefined')) {
    if (!!(getObjectProperty(___arguments.context.pageData, 'clientid')).length) {
      clientSearchString = (getObjectProperty(___arguments.context.pageData, 'clientid'));
    }
  }
  if (!clientSearchString.length) {
    await FormClientCSS('state');
    await FormClientCSS('city');
    await FormClientCSS('cmpname');
    await FormClientCSS('lastname');
    await FormClientCSS('addr1');
  }
  return clientSearchString
}

/**
 * Describe this function...
 */
async function VendorSearchString() {
  await GetParam('vendorname', 10, false);
  vendorSearchString = '';
  await FormVendorCSS('vendorid');
  await FormVendorCSS('vendorname');
  return vendorSearchString
}

/**
 * Describe this function...
 */
async function GetParam(fieldname, fieldpos, fieldnum) {
  if (typeof (i[(fieldpos - 1)]) === 'undefined') {
    ___arguments.context.pageData[fieldname] = '';
  } else if (!i[(fieldpos - 1)].length) {
    ___arguments.context.pageData[fieldname] = '';
  } else {
    if (fieldname == 'state') {
      ___arguments.context.pageData[fieldname] = (fieldnum == true ? [String(fieldname) + String('.code_2'),'=',i[(fieldpos - 1)].toLowerCase()].join('') : [String(fieldname) + String('.code_2'),'=\'',i[(fieldpos - 1)].toLowerCase(),'\''].join(''));
    } else {
      ___arguments.context.pageData[fieldname] = (fieldnum == true ? [fieldname,'=',i[(fieldpos - 1)].toLowerCase()].join('') : [fieldname,'=\'',i[(fieldpos - 1)].toLowerCase(),'\''].join(''));
    }
  }
}

/**
 * Describe this function...
 */
async function FormVendorCSS(fieldname) {
  if (typeof (getObjectProperty(___arguments.context.pageData, fieldname)) === 'undefined') {
    ___arguments.context.pageData[fieldname] = '';
  }
  if (!!(getObjectProperty(___arguments.context.pageData, fieldname)).length) {
    if (!!vendorSearchString.length) {
      vendorSearchString = String(vendorSearchString) + String(' AND ');
    }
    vendorSearchString = String(vendorSearchString) + String(getObjectProperty(___arguments.context.pageData, fieldname));
  }
}

/**
 * Describe this function...
 */
async function DoesVendorExist() {
  ___arguments.context.pageData['VSS'] = (await VendorSearchString());
  vendor = (await Backendless.Data.of('Vendors').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'VSS'))).setPageSize(10)))[0];
  if (typeof vendor === 'undefined') {
    if (!(typeof (i[10]) === 'undefined')) {
      if (!!i[10].length) {
        vendor = await DynamicVendorAdd(i[9]);
      }
    }
  }
}

/**
 * Describe this function...
 */
async function LogIt(logdatarow) {
  ___arguments.context.pageData['LogDataUploadRec'] = (await Backendless.Data.of('LogDataUpload').save( ({ [`batchdate`]: batchdate,[`batchid`]: batchid,[`batchtype`]: null,[`lineid`]: (getObjectProperty(logdatarow, 'lineid')),[`linedata`]: (getObjectProperty(logdatarow, 'linedata')) }) ));
  await Backendless.Data.of('LogDataUpload').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LogDataUploadRec')), 'objectId')) }), 'batchtype', [(getObjectProperty(((await Backendless.Data.of('LogDataTypes').find(Backendless.DataQueryBuilder.create().setWhereClause((['typecode=\'',batchtype,'\''].join(''))).setPageSize(10)))[0]), 'objectId'))]);
}

/**
 * Describe this function...
 */
async function FormClientCSS(fieldname) {
  if (typeof (getObjectProperty(___arguments.context.pageData, fieldname)) === 'undefined') {
    ___arguments.context.pageData[fieldname] = '';
  }
  if (!!(getObjectProperty(___arguments.context.pageData, fieldname)).length) {
    if (!!clientSearchString.length) {
      clientSearchString = String(clientSearchString) + String(' AND ');
    }
    clientSearchString = String(clientSearchString) + String(getObjectProperty(___arguments.context.pageData, fieldname));
  }
}

/**
 * Describe this function...
 */
async function DoesActivityExist() {
  ___arguments.context.pageData['DAEwhereClause'] = (['clientid.clientid=',(getObjectProperty(client, 'clientid')),' AND ','vendorid.vendorid=',(getObjectProperty(vendor, 'vendorid')),' AND ','(billaccountnumber=\'',i[10],'\')',' AND ','(billdate>=\'',((new Date((String(i[11]) + String(' 00:00:00')))).valueOf()),'\' AND billdate<=\'',((new Date((String(i[11]) + String(' 23:59:59')))).valueOf()),'\')'].join(''));
  console.log(String('DAEwhereClause = ') + String(getObjectProperty(___arguments.context.pageData, 'DAEwhereClause')));
  ___arguments.context.pageData['ClientActivityObj'] = ((await Backendless.Data.of('ClientActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'DAEwhereClause'))).setRelationsDepth(1).setPageSize(10)))[0]);
  console.log(String('DAE result=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'ClientActivityObj')))));
}

/**
 * Describe this function...
 */
async function DynamicVendorAdd(vendname) {
}

/**
 * Describe this function...
 */
async function ReportIt(rptData) {
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'rptData')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'rptData')).length) {
    batchtype = 'cbb';
    batchdate = ((new Date()).valueOf());
    ___arguments.context.pageData['rptData'] = ({ [`lineid`]: icnt,[`linedata`]: ['Client Activity Upload Report','Upload Date ',(new Date())].join('') });
    await LogIt((getObjectProperty(___arguments.context.pageData, 'rptData')));
  } else {
    await LogIt((getObjectProperty(___arguments.context.pageData, 'rptData')));
  }
}

/**
 * Describe this function...
 */
async function UpdateCAO() {
  console.log('==UpdateCAO==');
  baselinerec = (await BackendlessUI.Functions.Custom['fn_a31cc1e78e8181c26dea68480a76ff51']((getObjectProperty(client, 'clientid')), (getObjectProperty(vendor, 'vendorid')), (i[10])));
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['clientid'] = null;
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['vendorid'] = null;
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['agentid'] = null;
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['billaccountnumber'] = (i[10]);
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['billdate'] = ((new Date((i[11]))).valueOf());
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['billamount'] = (i[12]);
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['billbaseline'] = (i[13] == 'Y' ? true : false);
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['billbaseamt'] = (i[13] == 'Y' ? i[12] : (getObjectProperty(baselinerec, 'billamount')));
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['billsavingsTOT'] = (i[13] == 'Y' ? 0 : (getObjectProperty(baselinerec, 'billamount')) - i[12]);
  (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['billsavingsGPR'] = (i[13] == 'Y' ? 0 : ((getObjectProperty(baselinerec, 'billamount')) - i[12]) / 2);
  delete (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['created'];
  delete (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['___class'];
  delete (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['ownerId'];
  delete (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj'))['updated'];
  console.log(String('CAO UPD B4=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'ClientActivityObj')))));
  clientactivity = (await Backendless.Data.of('ClientActivity').deepSave( (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj')) ));
}

/**
 * Describe this function...
 */
async function ProcessActivity() {
  await DoesActivityExist();
  if (typeof (getObjectProperty(___arguments.context.pageData, 'ClientActivityObj')) === 'undefined') {
    console.log('==Create the New Activity Record==');
    ___arguments.context.pageData['CAOtype'] = 'ADD';
    await CreateCAO();
  } else {
    console.log('==Update the existing Activity Record==');
    ___arguments.context.pageData['CAOtype'] = 'UPD';
    await UpdateCAO();
  }
  await ReportIt(({ [`lineid`]: icnt,[`linedata`]: ['Line ',icnt,' - ','activity accepted for Clientid=',(getObjectProperty(client, 'clientid')),' / Vendorid=',(getObjectProperty(vendor, 'vendorid')),' / BillDate=',(new Date((getObjectProperty(clientactivity, 'billdate'))))].join('') }));
}


  ___arguments.context.pageData['showDtClientProfile'] = false;
  ___arguments.context.pageData['showDtClientBills'] = true;
  console.log(String('Uploaded File=') + String(___arguments.uploadedFiles));
  file1 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/csv2list`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'csvURL': ___arguments.uploadedFiles }));
  icnt = 1;
  await ReportIt('');
  for (var i_index in file1) {
    i = file1[i_index];
    console.log(String('Data IN[i]=') + String(JSON.stringify(i)));
    if (icnt == 1) {
      icnt = (typeof icnt == 'number' ? icnt : 0) + 1;
    } else {
      await DoesClientExist();
      await DoesVendorExist();
      if (typeof client === 'undefined') {
        await ReportIt(({ [`lineid`]: icnt,[`linedata`]: ['Line ',icnt,' - ','activity submitted for unknown CLIENT--rejected'].join('') }));
      } else if (typeof vendor === 'undefined') {
        await ReportIt(({ [`lineid`]: icnt,[`linedata`]: ['Line ',icnt,' - ','activity submitted for unknown VENDOR--rejected'].join('') }));
      } else if ((typeof (i[10]) === 'undefined') || !i[10].length) {
        await ReportIt(({ [`lineid`]: icnt,[`linedata`]: ['Line ',icnt,' - ','activity submitted for BILLACCOUNT--rejected'].join('') }));
      } else if ((typeof (i[11]) === 'undefined') || !i[11].length) {
        await ReportIt(({ [`lineid`]: icnt,[`linedata`]: ['Line ',icnt,' - ','activity submitted for unknown BILLDATE--rejected'].join('') }));
      } else if ((typeof (i[12]) === 'undefined') || !i[12].length) {
        await ReportIt(({ [`lineid`]: icnt,[`linedata`]: ['Line ',icnt,' - ','activity submitted for unknown BILLAMOUNT--rejected'].join('') }));
      } else {
        await GetAgentRecord();
        if (typeof agent === 'undefined') {
          await ReportIt(({ [`lineid`]: icnt,[`linedata`]: ['Line ',icnt,' - ','activity submitted for unknown AGENT--rejected'].join('') }));
        } else {
          await ProcessActivity();
          console.log('====================');
        }
      }
      icnt = (typeof icnt == 'number' ? icnt : 0) + 1;
    }
  }

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/cli_fin_data/components/047db4ddebd1c6686b2a359546647e53/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'selectedRecord.accountholdername')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.accoutholdername')) === null)) {
    ___arguments.context.pageData['selectedRecord.accountholdername'] = '';
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f3846a1fde61ceb04bbbd4465551f14');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/cli_fin_data/components/462b3781ff1376676fbdb76f504ffa34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('Checked Value=') + String(JSON.stringify(___arguments.checkedValue)));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_fin_data/components/38134e380be85904b6215ab95eac74c9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['achrout'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['achrout'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_fin_data/components/c0b7f45b72b36eb71dfe03f47115c5f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['achacct'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['achacct'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_fin_data/components/8f4820c5c46590da3b549749fdecb128/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['achauth'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_fin_data/components/8266e17f98498868fcc4052c27b846fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`billingentity`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingentity')),[`cmpname`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cmpname')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cmpname')),[`lastname`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'lastname')),[`firstname`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'firstname')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`achrout`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')),[`achacct`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')),[`achauth`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achauth')) === 'undefined') ? false : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achauth')),[`ccacct`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')),[`ccexpdt`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')),[`cccvc`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')),[`ccauth`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccauth')) === 'undefined') ? false : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccauth')),[`ccfeeauth`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccfeeauth')) === 'undefined') ? false : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccfeeauth')),[`othClientid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')),[`othPO`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')) })

  },
  /* handler:onContainerDataAssignment */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var clientBilling, clientobj, isOKstatusOTH, isOKstatusACH, isOKstatusCC, cardobj, cardobj_07dc, isOKstatusZ;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function OnclickA() {
  console.log('== enter onclickA =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'billingmethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'achAccountholderName'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achrout'] = (getObjectProperty(___arguments.context.pageData, 'achrout'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achacct'] = (getObjectProperty(___arguments.context.pageData, 'achacct'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['achauth'] = (getObjectProperty(___arguments.context.pageData, 'achauth'));
  console.log(['screen=',(getObjectProperty(___arguments.context.pageData, 'achrout')),'  SR=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout'))].join(''));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`achrout`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achrout')),[`achacct`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achacct')),[`achauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'achauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`iaACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}

/**
 * Describe this function...
 */
async function OnclickC() {
  console.log('== enter onclickC =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'billingmethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cardholderName'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccacct'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cardNumber'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccexpdt'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'expiry'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['cccvc'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-07dc')), 'cvc'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccauth'] = (getObjectProperty(___arguments.context.pageData, 'ccAuth'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ccfeeauth'] = (getObjectProperty(___arguments.context.pageData, 'ccFeeAuth'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`ccacct`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccacct')),[`ccexpdt`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccexpdt')),[`cccvc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cccvc')),[`ccauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccauth')),[`ccfeeauth`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ccfeeauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}

/**
 * Describe this function...
 */
async function OnclickO() {
  console.log('== enter onclickO =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'billingmethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['othClientid'] = (getObjectProperty(___arguments.context.pageData, 'othClientid'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['othPO'] = (getObjectProperty(___arguments.context.pageData, 'othPO'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`othClientid`]: (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othClientid')))),[`othPO`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'othPO')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}

/**
 * Describe this function...
 */
async function OnclickZ() {
  console.log('== enter onclickZ =');
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-873d')), 'cardholderName'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['zelleid'] = (getObjectProperty(___arguments.context.pageData, 'zelleid'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'accountholdername')),[`zelleid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'zelleid')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'ACHcompleteDate')) }));
}

/**
 * Describe this function...
 */
async function ClientUpdate(clientobj) {
  ___arguments.context.pageData['selectedRecord'] = (await Backendless.Data.of('Clients').save(clientobj, true));
  console.log(String('selectedRecord Result=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));
}

/**
 * Describe this function...
 */
async function statusZ() {
  isOKstatusZ = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'zelleid')) === 'undefined') {
    isOKstatusZ = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('94fd78136605eda2992e165a70970673', undefined, undefined, undefined, 'Zelle ID missing or invalid.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'zelleid')));
  }
}

/**
 * Describe this function...
 */
async function statusO() {
  isOKstatusOTH = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'othClientid')) === 'undefined') {
    ___arguments.context.pageData['othClientid'] = '';
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'othPO')) === 'undefined') {
    isOKstatusOTH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'PO Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf')));
  }
}

/**
 * Describe this function...
 */
async function statusA() {
  isOKstatusACH = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'achrout')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'Routing Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38134e380be85904b6215ab95eac74c9')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achacct')) === 'undefined') {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'achacct')) === 'undefined') {
      isOKstatusACH = false;
      await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'Account Number missing or invalid.', 'error');
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c0b7f45b72b36eb71dfe03f47115c5f5')));
    } else {
      ___arguments.context.pageData['achacct'] = (getObjectProperty(___arguments.context.dataModel, 'achacct'));
    }
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achauth')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'ACH Billing Authority must be granted to proceed.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8f4820c5c46590da3b549749fdecb128')));
  }
}

/**
 * Describe this function...
 */
async function statusC() {
  isOKstatusCC = true;
  console.log(String('FD=') + String(JSON.stringify(___arguments.context.dataModel)));
  console.log(String('PD=') + String(JSON.stringify(___arguments.context.pageData)));
  console.log(String('CC cardNumber=') + String(getObjectProperty(___arguments.context.pageData, 'cardNumber')));
  console.log(String('CC cardholderName=') + String(getObjectProperty(___arguments.context.pageData, 'cardholderName')));
  console.log(String('CC expiry=') + String(getObjectProperty(___arguments.context.pageData, 'expiry')));
  console.log(String('CC cvc=') + String(getObjectProperty(___arguments.context.pageData, 'cvc')));
  cardobj = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf'));
  console.log(cardobj);
  cardobj_07dc = (getObjectProperty(___arguments.context.pageData, 'Credit Card-10e5'));
  console.log(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'Credit Card-10e5'))));
  if (typeof (getObjectProperty(cardobj, 'cardNumber')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'Card Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf')));
  } else if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-10e5')), 'cardholderName')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'Cardholder Name missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf')));
  } else if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-10e5')), 'expiry')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'CC Expire Date missing or invalid', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf')));
  } else if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-10e5')), 'cvc')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'CVC Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccauth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'You must authorize charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccfeeauth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('fe57f4dd1dfd1397c622b74e0ada9fc9', true, false, undefined, 'You must authorize the CC Fee charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee58b6f48c5e36d4da5a43f88b0f11cf')));
  }
}


  console.log('========== BUTTON CLICK ==========');
  console.log('=Form Submit =');
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'A') {
    await statusA();
    if (isOKstatusACH) {
      await OnclickA();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');
    }
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'C') {
    await statusC();
    if (isOKstatusCC) {
      await OnclickC();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');
    }
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'O') {
    await statusO();
    if (isOKstatusOTH) {
      await OnclickO();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');
    }
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'billingmethod')) == 'Z') {
    await statusZ();
    if (isOKstatusZ) {
      await OnclickZ();
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');
    }
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/cli_fin_data/components/4b0d630fe067cd5e4dc974469662abae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd'), 'billingmethod')) == 'A' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/cli_fin_data/components/d6c36e21440e5971257fd26b9493f13e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd'), 'billingmethod')) == 'C' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/cli_fin_data/components/ed01d877ceadd1c1c8de09524ebcd86a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd'), 'billingmethod')) == 'O' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/cli_fin_data/components/82c4527eeec1eea8fab86ed9f7331c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_fin_data/components/985f9dcfb247e2b13181ecb8a426fa81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var agentBilling;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updAgentBilling() {
  agentBilling = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'selectedRecord.objectId')),'\''].join(''))).setPageSize(10)))[0];
  console.log('===screen updates ===');
  if ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'A') {
    await getUpdatesACH();
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'Z') {
    await getUpdatesZelle();
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectedRecord.billingmethod')) == 'P') {
    await getUpdatesPaperCheck();
  }
}

/**
 * Describe this function...
 */
async function getUpdatesACH() {
  agentBilling['achrout'] = (getObjectProperty(___arguments.context.pageData, 'achrout'));
  agentBilling['achacct'] = (getObjectProperty(___arguments.context.pageData, 'achacct'));
  agentBilling['achauth'] = (getObjectProperty(___arguments.context.pageData, 'achauth'));
  agentBilling['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  agentBilling['approvaldate'] = ((new Date()).toDateString());
  console.log((await Backendless.Data.of('Agents').deepSave( ({ [`agentid`]: (getObjectProperty(agentBilling, 'agentid')),[`billingmethod`]: (getObjectProperty(agentBilling, 'billingmethod')),[`accountholdername`]: (getObjectProperty(agentBilling, 'accountholdername')),[`achrout`]: (getObjectProperty(agentBilling, 'achrout')),[`achacct`]: (getObjectProperty(agentBilling, 'achacct')),[`achauth`]: (getObjectProperty(agentBilling, 'achauth')),[`approvaldate`]: (getObjectProperty(agentBilling, 'approvaldate')),[`objectId`]: (getObjectProperty(agentBilling, 'objectId')) }) )));
}

/**
 * Describe this function...
 */
async function getUpdatesZelle() {
  agentBilling['zelleid'] = (getObjectProperty(___arguments.context.pageData, 'zelleid'));
  agentBilling['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  agentBilling['approvaldate'] = ((new Date()).toDateString());
  console.log((await Backendless.Data.of('Agents').deepSave( ({ [`agentid`]: (getObjectProperty(agentBilling, 'agentid')),[`billingmethod`]: (getObjectProperty(agentBilling, 'billingmethod')),[`accountholdername`]: (getObjectProperty(agentBilling, 'accountholdername')),[`zelleid`]: (getObjectProperty(agentBilling, 'zelleid')),[`approvaldate`]: (getObjectProperty(agentBilling, 'approvaldate')),[`objectId`]: (getObjectProperty(agentBilling, 'objectId')) }) )));
}

/**
 * Describe this function...
 */
async function getUpdatesPaperCheck() {
  agentBilling['checkname'] = (getObjectProperty(___arguments.context.pageData, 'checkname'));
  agentBilling['checkaddr1'] = (getObjectProperty(___arguments.context.pageData, 'checkaddr1'));
  agentBilling['checkaddr2'] = (getObjectProperty(___arguments.context.pageData, 'checkaddr2'));
  agentBilling['checkcity'] = (getObjectProperty(___arguments.context.pageData, 'checkcity'));
  agentBilling['checkstate'] = (getObjectProperty(___arguments.context.pageData, 'checkstate'));
  agentBilling['checkzip'] = (getObjectProperty(___arguments.context.pageData, 'checkzip'));
  agentBilling['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'accountholdername'));
  agentBilling['approvaldate'] = ((new Date()).toDateString());
  console.log((await Backendless.Data.of('Agents').deepSave( ({ [`agentid`]: (getObjectProperty(agentBilling, 'agentid')),[`billingmethod`]: (getObjectProperty(agentBilling, 'billingmethod')),[`accountholdername`]: (getObjectProperty(agentBilling, 'accountholdername')),[`checkname`]: (getObjectProperty(agentBilling, 'checkname')),[`checkaddr1`]: (getObjectProperty(agentBilling, 'checkaddr1')),[`checkaddr2`]: (getObjectProperty(agentBilling, 'checkaddr2')),[`checkcity`]: (getObjectProperty(agentBilling, 'checkcity')),[`checkstate`]: (getObjectProperty(agentBilling, 'checkstate')),[`checkzip`]: (getObjectProperty(agentBilling, 'checkzip')),[`approvaldate`]: (getObjectProperty(agentBilling, 'approvaldate')),[`objectId`]: (getObjectProperty(agentBilling, 'objectId')) }) )));
}


  console.log('========== BUTTON CLICK ==========');
  await updAgentBilling();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f3846a1fde61ceb04bbbd4465551f14');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_fin_data/components/97e8bf34f99dd1ee8f88c19a4c8c8c51/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ccfeeauth'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd')['ccfeeauth'] = (getObjectProperty(___arguments.context.pageData, 'ccfeeauth'));
  console.log(String('FD ccfeeauth=') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8266e17f98498868fcc4052c27b846fd'), 'ccfeeauth')));
  console.log(String('PD ccfeeauth=') + String(getObjectProperty(___arguments.context.pageData, 'ccfeeauth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_fin_data/components/76f55bb8963e8f151abc65a21553f561/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['ccauth'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_fin_data/components/ee58b6f48c5e36d4da5a43f88b0f11cf/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      console.log(String('card details=') + String(JSON.stringify(___arguments['cardDetails'])));
  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateNumber() })('ee58b6f48c5e36d4da5a43f88b0f11cf')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateExpiry() })('ee58b6f48c5e36d4da5a43f88b0f11cf')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateCVC() })('ee58b6f48c5e36d4da5a43f88b0f11cf')) == false) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onSubmit */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      console.log(String('ONBLUR - card details=') + String(JSON.stringify(___arguments['formData'])));

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/cli_fin_data/components/adc846887117ddbd6bd973dd1edc553d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['othClientid'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'othClientid')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'clientid')) : (getObjectProperty(___arguments.context.pageData, 'othClientid')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/cli_fin_data/components/04c7817f894d62cfde0f886b64933ecf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['othPO'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_fin_data/components/ab935d5349f6a78ee0c7ec0f295210d4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
      return (await Backendless.Data.of('Company').find(Backendless.DataQueryBuilder.create().setProperties('CmpID as label, CmpID as value').setSortBy('CmpID').setPageSize(100)))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/cli_profile/components/29064a0e68bb04be23953574bf5ef057/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.cmpname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/10c81e8d7368930ac57d57b8e89558f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.lastname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/a7d929754a543632484ac6c93338d9af/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/a03e7657ee042ee726d9e7cf0f0cb93a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/600596583c0f8c133e5982fa637e2e58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.city'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/a4550ddd18c60368069b23c3241240dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/41b7f8b93736cf3c8c3afd12b3e979a4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/025113c2649aa09a4efd081e750e0875/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/601343a6fb9a94a381cb43e90f1fc15d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_profile/components/e3e7f951e18cddf2a8c440410c9454c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`agentid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentid')),[`agentname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.agentname')),[`active`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active')),[`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.cmpname')),[`firstname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.firstname')),[`lastname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.lastname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1')),[`addr2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city')),[`state`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.state')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email')),[`phone`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone')),[`phone2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone2')) })

  },
  /* handler:onContainerDataAssignment */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var addr2, client, clientagent, clientobj, clientstate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function SaveToSelectedRecord() {
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['cmpname'] = ((typeof (getObjectProperty(client, 'cmpname')) === 'undefined') || ((getObjectProperty(client, 'cmpname')) === null) ? '' : (getObjectProperty(client, 'cmpname')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['lastname'] = ((typeof (getObjectProperty(client, 'lastname')) === 'undefined') || ((getObjectProperty(client, 'lastname')) === null) ? '' : (getObjectProperty(client, 'lastname')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['firstname'] = ((typeof (getObjectProperty(client, 'firstname')) === 'undefined') || ((getObjectProperty(client, 'firstname')) === null) ? '' : (getObjectProperty(client, 'firstname')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['addr1'] = ((typeof (getObjectProperty(client, 'addr1')) === 'undefined') || ((getObjectProperty(client, 'addr1')) === null) ? '' : (getObjectProperty(client, 'addr1')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['addr2'] = ((typeof (getObjectProperty(client, 'addr2')) === 'undefined') || ((getObjectProperty(client, 'addr2')) === null) ? '' : (getObjectProperty(client, 'addr2')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['city'] = ((typeof (getObjectProperty(client, 'city')) === 'undefined') || ((getObjectProperty(client, 'city')) === null) ? '' : (getObjectProperty(client, 'city')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['state'] = (getObjectProperty(client, 'state'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['zip_postalcode'] = ((typeof (getObjectProperty(client, 'zip_postalcode')) === 'undefined') || ((getObjectProperty(client, 'zip_postalcode')) === null) ? '' : (getObjectProperty(client, 'zip_postalcode')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['phone'] = ((typeof (getObjectProperty(client, 'phone')) === 'undefined') || ((getObjectProperty(client, 'phone')) === null) ? '' : (getObjectProperty(client, 'phone')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['email'] = ((typeof (getObjectProperty(client, 'email')) === 'undefined') || ((getObjectProperty(client, 'email')) === null) ? '' : (getObjectProperty(client, 'email')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['agentid'] = (getObjectProperty(client, 'agentid'));
}

/**
 * UPDCLIENT
 * function to update the client record
 */
async function updClientFromScreen() {
  console.log('==update Client record from screen');
  console.log(String('AD=') + String(JSON.stringify(___arguments.context.appData)));
  console.log(String('PD=') + String(JSON.stringify(___arguments.context.pageData)));
  console.log(String('FD=') + String(JSON.stringify(___arguments.context.dataModel)));
  await State_Get();
  await Agent_Get();
  clientobj = ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')),[`clientid`]: (getObjectProperty(___arguments.context.dataModel, 'clientid')),[`active`]: (getObjectProperty(___arguments.context.dataModel, 'active')),[`firstname`]: (getObjectProperty(___arguments.context.dataModel, 'firstname')),[`lastname`]: (getObjectProperty(___arguments.context.dataModel, 'lastname')),[`cmpname`]: (getObjectProperty(___arguments.context.dataModel, 'cmpname')),[`addr1`]: (getObjectProperty(___arguments.context.dataModel, 'addr1')),[`addr2`]: (getObjectProperty(___arguments.context.dataModel, 'addr2')),[`city`]: (getObjectProperty(___arguments.context.dataModel, 'city')),[`state`]: undefined,[`zip_postalcode`]: (getObjectProperty(___arguments.context.dataModel, 'zip')),[`phone`]: (getObjectProperty(___arguments.context.dataModel, 'phone')),[`phone2`]: (getObjectProperty(___arguments.context.dataModel, 'phone2')),[`email`]: (getObjectProperty(___arguments.context.dataModel, 'email')),[`agentid`]: undefined,[`agentemail`]: (getObjectProperty(___arguments.context.dataModel, 'agentemail')) });
  console.log(String('clientobj=') + String(JSON.stringify(clientobj)));
  client = (await Backendless.Data.of('Clients').save( clientobj ));
  await State_Update();
  await Agent_Update();
  console.log(String('client AF=') + String(JSON.stringify(client)));
}

/**
 * Describe this function...
 */
async function State_Get() {
  console.log('==BEGIN State-Get==');
  console.log(String('FD state=') + String(getObjectProperty(___arguments.context.dataModel, 'state')));
  ___arguments.context.pageData['selectedState'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2=\'',(getObjectProperty(___arguments.context.dataModel, 'state')),'\''].join(''))).setPageSize(10)))[0]);
  console.log(String('selectedState=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedState')))));
  console.log('==END State-Get==');
}

/**
 * Describe this function...
 */
async function State_Update() {
  console.log('==BEGIN State-Update==');
  clientstate = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedState')), 'objectId'))]));
  console.log(String('clientstate=') + String(JSON.stringify(clientstate)));
  console.log('==END State-Update==');
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * ADDR2CLEANUP
 * function to cleanup the contents of ADDR2
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['addr2'] = addr2;
}

/**
 * Describe this function...
 */
async function Agent_Update() {
  console.log('==BEGIN Agent-Update==');
  clientagent = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedAgent')), 'objectId'))]));
  console.log(String('clientagent=') + String(JSON.stringify(clientagent)));
  console.log('==END Agent-Update==');
}

/**
 * Describe this function...
 */
async function Agent_Get() {
  console.log('==BEGIN Agent-Get==');
  console.log(String('FD agent=') + String(getObjectProperty(___arguments.context.dataModel, 'agent')));
  ___arguments.context.pageData['selectedAgent'] = ((await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(getObjectProperty(___arguments.context.dataModel, 'agentid')))).setPageSize(10)))[0]);
  console.log(String('selectedAgent=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedAgent')))));
  console.log('==END Agent-Get==');
}


  console.log('========== BUTTON CLICK ==========');
  await Address2Cleanup();
  await updClientFromScreen();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/cli_profile/components/0bfddd8819ce858615e67e1b539cbe9e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.active'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/513451f381bec312d8c4398ccaa7c58e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.firstname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_profile/components/047db4ddebd1c6686b2a359546647e53/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  ___arguments.context.pageData['selectedState'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2 like \'',(getObjectProperty(___arguments.selectedRecord, 'state')),'%\''].join(''))).setPageSize(10)))[0]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('5db144f869bd266f4948c13495f4cd15');
  console.log(String('selectedRecord=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/cli_trx_activity/components/047db4ddebd1c6686b2a359546647e53/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  ___arguments.context.appData['selectedState'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2 like \'',(getObjectProperty(___arguments.selectedRecord, 'state')),'%\''].join(''))).setPageSize(10)))[0]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('5db144f869bd266f4948c13495f4cd15');
  console.log(String('Whole Record=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/cli_trx_activity/components/513451f381bec312d8c4398ccaa7c58e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.contactname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/29064a0e68bb04be23953574bf5ef057/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.vendorname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/10c81e8d7368930ac57d57b8e89558f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/a7d929754a543632484ac6c93338d9af/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/a03e7657ee042ee726d9e7cf0f0cb93a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/600596583c0f8c133e5982fa637e2e58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.city'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/a4550ddd18c60368069b23c3241240dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/41b7f8b93736cf3c8c3afd12b3e979a4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/025113c2649aa09a4efd081e750e0875/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/601343a6fb9a94a381cb43e90f1fc15d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e3e7f951e18cddf2a8c440410c9454c5');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_trx_activity/components/3db451cfadc949192f486d71905fb5b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vendor, addr2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updVendor() {
  console.log('==update Vendor record from screen');
  console.log(String('Vendor B4=') + String(JSON.stringify(vendor)));
  vendor['vendorname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorname'));
  vendor['addr1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1'));
  vendor['addr2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2'));
  vendor['city'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city'));
  vendor['state'] = null;
  vendor['zip'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip'));
  vendor['phone1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone1'));
  vendor['phone2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone2'));
  vendor['email'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email'));
  vendor['contactname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.contactname'));
  vendor['active'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active'));
  vendor['catid'] = null;
  console.log(String('vendor AF=') + String(JSON.stringify(vendor)));
  vendor = (await Backendless.Data.of('Vendors').save( vendor ));
  console.log('==update Vendor with state info');
  await Backendless.Data.of('Vendors').setRelation(({ [`objectId`]: (getObjectProperty(vendor, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]);
  console.log('==update Vendor with category');
  await Backendless.Data.of('Vendors').setRelation(({ [`objectId`]: (getObjectProperty(vendor, 'objectId')) }), 'catid', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord.catid')), 'objectId'))]);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5'), 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
  ___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5')['addr2'] = addr2;
}


  console.log('========== BUTTON CLICK ==========');
  await Address2Cleanup();
  console.log('==Get Vendor record');
  vendor = (await Backendless.Data.of('Vendors').find(Backendless.DataQueryBuilder.create().setWhereClause((String('vendorid=') + String(getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorid')))).setPageSize(10)))[0];
  console.log(String('vendor from table=') + String(JSON.stringify(vendor)));
  await updVendor();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/cli_trx_activity/components/e3e7f951e18cddf2a8c440410c9454c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`active`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active')),[`vendorid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorid')),[`vendorname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1')),[`addr2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city')),[`state`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.state')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip')),[`contactname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.contactname')),[`phone1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone1')),[`phone2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone2')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email')),[`vendortype`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendortype')),[`catid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.catid')),[`catname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.catname')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/cli_trx_activity/components/d6cf47245836b42f723ad349229d9065/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(String('Changed Value=') + String(___arguments.value));
  ___arguments.context.pageData['selectedRecord.vendortype'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/7dd90d0a79df87a5b7c2a13eb851a85c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
      return (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setProperties('catname as label, catid as value').setSortBy('catname').setPageSize(100)))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('changed value=') + String(___arguments.value));
  list = (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setWhereClause((['catid like \'',___arguments.value,'%\''].join(''))).setPageSize(10)))[0];
  console.log(String('list=') + String(JSON.stringify(list)));
  ___arguments.context.pageData['selectedRecord.catid'] = (getObjectProperty(list, 'catid'));
  ___arguments.context.pageData['selectedRecord.catname'] = (getObjectProperty(list, 'catname'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/cli_trx_activity/components/0541e49c37efb81fdbbe959147614e88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.active'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/client_profile/components/d6b563979c7cfdf787d9265655d7f057/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  ___arguments.context.pageData['updFunction'] = 'UPD';
  console.log(['selectedRecord(',(getObjectProperty(___arguments.context.pageData, 'updFunction')),')=',(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord'))))].join(''));
  ___arguments.context.pageData['selectedState'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2 like \'',(getObjectProperty(___arguments.selectedRecord, 'selectState')),'%\''].join(''))).setPageSize(10)))[0]);
  ___arguments.context.pageData['selectedAgent'] = ((await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(getObjectProperty(___arguments.selectedRecord, 'agentid')))).setPageSize(10)))[0]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('bfa1479f96cdf423c8fb725e3e6aa5f9');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/client_profile/components/2c56ff01398fbb7da01ac5925bbf8935/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('811498610ffada5fe4c9d987d50378f7');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/client_profile/components/811498610ffada5fe4c9d987d50378f7/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var client, clientBilling, CSS, clientSearchString, fieldname, fieldpos, fieldnum, addr2, clientagent, clientstate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function SaveToSelectedRecord() {
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['cmpname'] = ((typeof (getObjectProperty(client, 'cmpname')) === 'undefined') || ((getObjectProperty(client, 'cmpname')) === null) ? '' : (getObjectProperty(client, 'cmpname')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['lastname'] = ((typeof (getObjectProperty(client, 'lastname')) === 'undefined') || ((getObjectProperty(client, 'lastname')) === null) ? '' : (getObjectProperty(client, 'lastname')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['firstname'] = ((typeof (getObjectProperty(client, 'firstname')) === 'undefined') || ((getObjectProperty(client, 'firstname')) === null) ? '' : (getObjectProperty(client, 'firstname')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['addr1'] = ((typeof (getObjectProperty(client, 'addr1')) === 'undefined') || ((getObjectProperty(client, 'addr1')) === null) ? '' : (getObjectProperty(client, 'addr1')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['addr2'] = ((typeof (getObjectProperty(client, 'addr2')) === 'undefined') || ((getObjectProperty(client, 'addr2')) === null) ? '' : (getObjectProperty(client, 'addr2')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['city'] = ((typeof (getObjectProperty(client, 'city')) === 'undefined') || ((getObjectProperty(client, 'city')) === null) ? '' : (getObjectProperty(client, 'city')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['state'] = (getObjectProperty(client, 'state'));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['zip_postalcode'] = ((typeof (getObjectProperty(client, 'zip_postalcode')) === 'undefined') || ((getObjectProperty(client, 'zip_postalcode')) === null) ? '' : (getObjectProperty(client, 'zip_postalcode')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['phone'] = ((typeof (getObjectProperty(client, 'phone')) === 'undefined') || ((getObjectProperty(client, 'phone')) === null) ? '' : (getObjectProperty(client, 'phone')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['email'] = ((typeof (getObjectProperty(client, 'email')) === 'undefined') || ((getObjectProperty(client, 'email')) === null) ? '' : (getObjectProperty(client, 'email')));
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['agentid'] = (getObjectProperty(client, 'agentid'));
}

/**
 * Describe this function...
 */
async function GetPriorClientProfile() {
  console.log(String('selectedRecord B4=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));
  console.log(String('Page Data=') + String(JSON.stringify(___arguments.context.pageData)));
  CSS = await ClientSearchString();
  if ((getObjectProperty(___arguments.context.pageData, 'updFunction')) == 'UPD') {
    CSS = ['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'objectId')),'\''].join('');
  }
  clientBilling = (await Backendless.Data.of('Clients').find(Backendless.DataQueryBuilder.create().setWhereClause(CSS).setRelationsDepth(1).setPageSize(10)))[0];
}

/**
 * CLIENTSEARCHSTRING
 * function to process selected data fields into SQL WHERE parms
 */
async function ClientSearchString() {
  await GetParam('clientid', 1, true);
  await GetParam('lastname', 4, false);
  await GetParam('cmpname', 5, false);
  await GetParam('addr1', 6, false);
  await GetParam('city', 8, false);
  await GetParam('state', 9, false);
  clientSearchString = '';
  fieldname = 'clientid';
  if (!(typeof (getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))) === 'undefined')) {
    if (!!(getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))).length) {
      clientSearchString = (getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname))));
    }
  }
  if (!clientSearchString.length) {
    await FormClientCSS('state');
    await FormClientCSS('city');
    await FormClientCSS('cmpname');
    await FormClientCSS('lastname');
    await FormClientCSS('addr1');
  }
  console.log(String('CSS(result)=') + String(JSON.stringify(clientSearchString)));
  return clientSearchString
}

/**
 * GETPARAM
 * function to capture the content of specified input data and save to page data.
 */
async function GetParam(fieldname, fieldpos, fieldnum) {
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)) === 'undefined') {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)) === null) {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  } else if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).length) {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  } else {
    if (fieldname == 'state') {
      ___arguments.context.pageData[(String('search') + String(fieldname))] = (fieldnum == true ? [String(fieldname) + String('.code_2'),'=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase()].join('') : [String(fieldname) + String('.code_2'),'=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase(),'\''].join(''));
    } else {
      ___arguments.context.pageData[(String('search') + String(fieldname))] = (fieldnum == true ? [fieldname,'=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase()].join('') : [fieldname,'=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase(),'\''].join(''));
    }
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * ADDR2CLEANUP
 * function to cleanup the contents of ADDR2
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
  (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['addr2'] = addr2;
}

/**
 * UPDCLIENT
 * function to update the client record
 */
async function updClientFromScreen() {
  console.log('==update Client record from screen');
  if ((getObjectProperty(___arguments.context.pageData, 'updFunction')) == 'UPD') {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['state'] = null;
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['agentid'] = null;
  }
  if (getValueLength((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'zip_postalcode'))) < 5) {
    (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['zip_postalcode'] = (String(0) + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'zip_postalcode')));
  }
  await GetStateRecord();
  await GetAgentRecord();
  delete (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['name'];
  delete (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['agentemail'];
  delete (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['CSAactive'];
  delete (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['CSApending'];
  delete (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isACHcomplete'];
  delete (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isAGRcomplete'];
  delete (getObjectProperty(___arguments.context.pageData, 'selectedRecord'))['isClient'];
}

/**
 * Describe this function...
 */
async function GetAgentRecord() {
}

/**
 * Describe this function...
 */
async function addUpdClient() {
  if ((getObjectProperty(___arguments.context.pageData, 'updFunction')) == 'ADD') {
    client = (await Backendless.Data.of('Clients').save( (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) ));
  } else {
    client = (await Backendless.Data.of('Clients').save( (getObjectProperty(___arguments.context.pageData, 'selectedRecord')) ));
  }
  clientstate = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]));
  clientagent = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty(client, 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAgent')), 'objectId'))]));
}

/**
 * FORMCLIENTCSS
 * function to create search string for SQL WHERE
 */
async function FormClientCSS(fieldname) {
  if (typeof (getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))) === 'undefined') {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  }
  if (!!(getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))).length) {
    if (!!clientSearchString.length) {
      clientSearchString = String(clientSearchString) + String(' AND ');
    }
    clientSearchString = String(clientSearchString) + String(getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname))));
  }
}

/**
 * Describe this function...
 */
async function GetStateRecord() {
}


  console.log('========== BUTTON CLICK ==========');
  await Address2Cleanup();
  await GetPriorClientProfile();
  if ((getObjectProperty(___arguments.context.pageData, 'updFunction')) == 'ADD') {
    console.log('==truly new record, do the update');
    if (typeof client === 'undefined') {
      client = (getObjectProperty(___arguments.context.pageData, 'selectedRecord'));
    }
  }
  await updClientFromScreen();
  await addUpdClient();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4e4142bc4e462bb95edc9543f775edfc');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['cmpname'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'cmpname'));
  ___arguments.context.pageData['firstname'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'firstname'));
  ___arguments.context.pageData['lastname'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'lastname'));
  ___arguments.context.pageData['addr1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'addr1'));
  ___arguments.context.pageData['addr2'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'addr2'));
  ___arguments.context.pageData['city'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'city'));
  ___arguments.context.pageData['state'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'state'));
  ___arguments.context.pageData['zip_postalcode'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'zip_postalcode'));
  ___arguments.context.pageData['phone'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'phone'));
  ___arguments.context.pageData['email'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'email'));
  ___arguments.context.pageData['agentid'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), 'agentid'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/client_profile/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function () { return BackendlessUI.isProd })()) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    }
  } else {
    console.log('skip security for testing mode');
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/client_profile/components/860b4e2d2807a75d79d61149ee39c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['updFunction'] = 'ADD';
  console.log(String('updFunction=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'updFunction')))));
  ___arguments.context.pageData['selectedRecord'] = ({ [`clientid`]: undefined,[`cmpname`]: '',[`lastname`]: '',[`firstname`]: '',[`addr1`]: '',[`addr2`]: '',[`city`]: '',[`state`]: undefined,[`zip_postalcode`]: '',[`country`]: '',[`email`]: '',[`phone`]: '',[`isClient`]: false,[`isAGRcomplete`]: false,[`isACHcomplete`]: false,[`CSAactive`]: 0,[`CSApending`]: 0,[`objectId`]: undefined,[`agentid`]: undefined,[`agentemail`]: '',[`name`]: '' });
  ___arguments.context.pageData['chgData'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4e4142bc4e462bb95edc9543f775edfc');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/client_profile/components/11fc7a18435a1f2bafeb01c4e1d56c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('bfa1479f96cdf423c8fb725e3e6aa5f9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/client_trx_activity/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    
  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var CardObj;


  CardObj = (await Backendless.Request.get(`${Backendless.appPath}/services/Trello/GetBoardActions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'boardid': JSON.stringify('64619a455f7d9e70302c4808') }).send());
  console.log(String('PageEnter CardObj=') + String(JSON.stringify(CardObj)));
  ___arguments.context.pageData['CardObj'] = CardObj;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/client_trx_activity/components/860b4e2d2807a75d79d61149ee39c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientSearchString, fieldname, j, fieldnum, fieldpos, inrec;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function get_record_key(inrec) {
  return [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'inrec')), 'clientid')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'inrec')), 'vendorid')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'inrec')), 'trxkey'))].join('')
}

/**
 * CLIENTSEARCHSTRING
 * function to process selected data fields into SQL WHERE parms
 */
async function ClientSearchString() {
  await GetParam('clientid', 1, true);
  await GetParam('lastname', 4, false);
  await GetParam('cmpname', 5, false);
  await GetParam('addr1', 6, false);
  await GetParam('city', 8, false);
  await GetParam('state', 9, false);
  clientSearchString = '';
  fieldname = 'clientid';
  if (!(typeof (getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))) === 'undefined')) {
    if (!!(getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))).length) {
      clientSearchString = (getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname))));
    }
  }
  if (!clientSearchString.length) {
  }
  console.log(String('CSS(result)=') + String(JSON.stringify(clientSearchString)));
  return clientSearchString
}

/**
 * Describe this function...
 */
async function get_record_dup_count() {
  console.log('look for matching prior record');
  console.log('client/vendor/v-acct/v-bill date');
  console.log('==================');
  console.log('does curr rec match a prior record');
  console.log('== dup YES == prior rec already processed = NO');
  console.log('---- REPLACE OLD REC with new rec');
  console.log('== dup YES == prior rec already processed = YES');
  console.log('---- ERROR -- reject this record');
  console.log('==================');
  console.log('== dup NO == prior rec already processed?');
}

/**
 * GETPARAM
 * function to capture the content of specified input data and save to page data.
 */
async function GetParam(fieldname, fieldpos, fieldnum) {
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)) === 'undefined') {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)) === null) {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  } else if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).length) {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  } else {
    if (fieldname == 'state') {
      ___arguments.context.pageData[(String('search') + String(fieldname))] = (fieldnum == true ? [String(fieldname) + String('.code_2'),'=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase()].join('') : [String(fieldname) + String('.code_2'),'=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase(),'\''].join(''));
    } else {
      ___arguments.context.pageData[(String('search') + String(fieldname))] = (fieldnum == true ? [fieldname,'=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase()].join('') : [fieldname,'=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord')), fieldname)).toLowerCase(),'\''].join(''));
    }
  }
}

/**
 * Describe this function...
 */
async function Get_Account_Baseline() {
  console.log('does curr rec matches prior record');
  if (0 == true) {
    console.log('if already processed, mark new reord as error');
  }
}

/**
 * FORMCLIENTCSS
 * function to create search string for SQL WHERE
 */
async function FormClientCSS(fieldname) {
  if (typeof (getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))) === 'undefined') {
    ___arguments.context.pageData[(String('search') + String(fieldname))] = '';
  }
  if (!!(getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname)))).length) {
    if (!!clientSearchString.length) {
      clientSearchString = String(clientSearchString) + String(' AND ');
    }
    clientSearchString = String(clientSearchString) + String(getObjectProperty(___arguments.context.pageData, (String('search') + String(fieldname))));
  }
}


  console.log('Get list of currentActivity');
  ___arguments.context.pageData['CurrentTrxList'] = [(await Backendless.Data.of('ClientTransactions').find(Backendless.DataQueryBuilder.create().setWhereClause('billprocessed=false').setPageSize(10)))];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'CurrentTrxList'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData['currKey'] = (await get_record_key(j));
    console.log('find possible matching record');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/client_trx_activity/components/04dd8641857955216d2c1e6e95c3f36b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/234512b19f0abf5a90082f583cf7d00d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/bd06c0b7260efd07ae911d6fbea1901a/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['link', 'nav__link', 'nav__link_active'];
  }

  return ['link', 'nav__link']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var width, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')) == (getObjectProperty(___arguments.context.dataModel, 'textLink'))) {
      item['active'] = true;
    } else {
      item['active'] = false;
    }
  ; return item;}))));
  width = (await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'));
  if (width <= 768) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('aff3d05702623d21c1db6f68783a6dfc'))['height'] = 0;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('56bb5ad18369a267faba1c35a58c78f6'))['width'] = 28;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3faebff5e17b9b88716551b588eb8dea'))['transform'] = 'rotate(0deg)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('67d693ca8329b83c4fa116e862519492'))['transform'] = 'rotate(0deg)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('67d693ca8329b83c4fa116e862519492'))['top'] = 18;
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'textLink')) == 'Home') {
    await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')));
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'textLink')) == 'Features') {
    await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bc3c048ebe5108b3f78d9c4402d1b37c')));
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'textLink')) == 'Testimonials') {
    await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c2d38132e0adac3985b2b0d37a9d0ff5')));
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'textLink')) == 'Gallery') {
    await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('27ea19a472ea83b6e71e29392f019ea5')));
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'textLink')) == 'Team') {
    await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ba691033b23fd0b9bb63ebcc5d48f993')));
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'textLink')) == 'Download') {
    await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('083537e287d9815486d5800b0d7f0976')));
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'textLink')) == 'Contact') {
    await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('93a68efa5875daff076d7cebb90b43c8')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/aff3d05702623d21c1db6f68783a6dfc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', [({ 'textLink': 'Home','urlLink': '#home','active': true }), ({ 'textLink': 'Features','active': false }), ({ 'textLink': 'Testimonials','active': false }), ({ 'textLink': 'Gallery','active': false }), ({ 'textLink': 'Team','active': false }), ({ 'textLink': 'Download','active': false }), ({ 'textLink': 'Contact','active': false })]);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/contactthanks/components/16e2283a12a4284106930f2c9c884495/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('aff3d05702623d21c1db6f68783a6dfc')), 'height')) == 225) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('aff3d05702623d21c1db6f68783a6dfc'))['height'] = 0;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('56bb5ad18369a267faba1c35a58c78f6'))['width'] = 28;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3faebff5e17b9b88716551b588eb8dea'))['transform'] = 'rotate(0deg)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('67d693ca8329b83c4fa116e862519492'))['transform'] = 'rotate(0deg)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('67d693ca8329b83c4fa116e862519492'))['top'] = 18;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('aff3d05702623d21c1db6f68783a6dfc'))['height'] = 225;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('56bb5ad18369a267faba1c35a58c78f6'))['width'] = 0;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3faebff5e17b9b88716551b588eb8dea'))['transform'] = 'rotate(45deg)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('67d693ca8329b83c4fa116e862519492'))['transform'] = 'rotate(135deg)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('67d693ca8329b83c4fa116e862519492'))['top'] = 12;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/fa03dfd6edebcdea52ebd3e382ae3e94/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async onMouseOver(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['counterFItem'] = (getObjectProperty(___arguments.context.dataModel, 'id'));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0875e5b21a8bb4c1a57b4af94b7e763a', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0875e5b21a8bb4c1a57b4af94b7e763a')).map(async item => {  if ((getObjectProperty(___arguments.context.pageData, 'counterFItem')) == (getObjectProperty(item, 'id'))) {
      item['active'] = true;
    } else {
      item['active'] = false;
    }
  ; return item;}))));

  },
  /* handler:onMouseOver */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['f-item', 'features__item', 'f-item_active'];
  }

  return ['f-item', 'features__item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/0875e5b21a8bb4c1a57b4af94b7e763a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    var features, item, counter, data;


  ___arguments.context.pageData['counterFItem'] = 1;
  ___arguments.context.pageData['active'] = false;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/contactthanks/components/970df8ce20ad10c4c28936f16be5994e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    var listLength, testimonials, item, counter, data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function setIdItem(data) {
  counter = 1;
  return await Promise.all(data.map(async item => {  item['id'] = counter;
  counter = (typeof counter == 'number' ? counter : 0) + 1;
; return item;}))
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.appData['counterSlide'] = 1;
  testimonials = (getObjectProperty(___arguments.context.appData, 'testimonialsList'));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6d47979354380d07c018dc8396a90f57', (await setIdItem(testimonials)));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6ddd82353ddae7bce5b72a7410822944', (await setIdItem(testimonials)));
  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6d47979354380d07c018dc8396a90f57')).length;

  ;(function() {
    const callback = async () => {
        if ((getObjectProperty(___arguments.context.appData, 'counterSlide')) < listLength) {
      ___arguments.context.appData['counterSlide'] = ((getObjectProperty(___arguments.context.appData, 'counterSlide')) + 1);
    } else {
      ___arguments.context.appData['counterSlide'] = 1;
    }
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6d47979354380d07c018dc8396a90f57', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6d47979354380d07c018dc8396a90f57')));
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6ddd82353ddae7bce5b72a7410822944', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6ddd82353ddae7bce5b72a7410822944')));

    };

    const timerId = '1';
    const timerDelay = 4000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/contactthanks/components/9a33e38b04a8604eeb77523308f16bef/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'counterSlide')) == (getObjectProperty(___arguments.context.dataModel, 'id'))) {
    return ['t-slider__item', 't-slider__item_active'];
  }

  return ['t-slider__item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/2578270ff54f12882d9a6fa970a8e999/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'id')) == (getObjectProperty(___arguments.context.appData, 'counterSlide'))) {
    return ['t-slider__dot-item', 't-slider__dot-item_active'];
  }

  return ['t-slider__dot-item']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['counterSlide'] = (getObjectProperty(___arguments.context.dataModel, 'id'));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6d47979354380d07c018dc8396a90f57', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6d47979354380d07c018dc8396a90f57')));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6ddd82353ddae7bce5b72a7410822944', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6ddd82353ddae7bce5b72a7410822944')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/d45bf717bf26eaff3b35e2d8ff2911c9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    var team;


  ___arguments.context.pageData['active'] = true;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/contactthanks/components/b989eeb9f8b8fab437f671114a097828/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, nameSocial;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['t-card__link'];
  nameSocial = (getObjectProperty(___arguments.context.dataModel, 'name'));
  if ((getObjectProperty(___arguments.context.dataModel, 'url')) == '') {
    addItemToList(classes, 't-card__link_hide');
  }
  if (nameSocial == 'facebook') {
    addItemToList(classes, 'icofont-facebook');
  }
  if (nameSocial == 'github') {
    addItemToList(classes, 'icofont-github');
  }
  if (nameSocial == 'linkedin') {
    addItemToList(classes, 'icofont-linkedin');
  }
  if (nameSocial == 'twitter') {
    addItemToList(classes, 'icofont-twitter');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/a748ef2413b8883680614f27f3eebb1e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a748ef2413b8883680614f27f3eebb1e', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69454eabe3b54b3b9996498d5a8ff29a'), 'socialMedia')), 'social')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/contactthanks/components/9ddc4897b0a9d658f76b74e111db7048/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var name2, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'name'));
  regExp = (new RegExp('.{2,}', 'g'));
  if (name2.length <= 50) {
    ___arguments.context.pageData['nameValue'] = name2;
  } else if (name2.length > 50) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['name'] = ' ';
    await new Promise(r => setTimeout(r, 1 || 0));
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['name'] = (subsequenceFirstFromEnd((getObjectProperty(___arguments.context.pageData, 'nameValue')), 0));
  }
  if ((regExp.test(name2)) == false && name2 != '' || name2.length != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'name')).length && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'name')).length < 2 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'name')).length != 0) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintName'] = true;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertName'] = false;
  } else if ((regExp.test(name2)) == false && name2 == '' || name2 != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'name')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'name')).length == 0) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintName'] = false;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertName'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintName'] = false;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertName'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/contactthanks/components/0ad8d1e9d1d143aaa6433df4ef44c48e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var email, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'email'));
  regExp = (new RegExp('[a-zA-Z0-9.\\-_+]{1,}@[^\\W\\.][a-zA-Z0-9\\-]{0,}\\.[a-zA-Z]{1,}', 'g'));
  if (email.length <= 50) {
    ___arguments.context.pageData['emailValue'] = email;
  } else if (email.length > 50) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['email'] = ' ';
    await new Promise(r => setTimeout(r, 1 || 0));
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['email'] = (subsequenceFirstFromEnd((getObjectProperty(___arguments.context.pageData, 'emailValue')), 0));
  }
  if ((regExp.test(email)) == false && email != '') {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintEmail'] = true;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertEmail'] = false;
  } else if ((regExp.test(email)) == false && email == '') {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintEmail'] = false;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertEmail'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintEmail'] = false;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertEmail'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/contactthanks/components/2e1aae5a7f9baa269dc2f96ebdba2dae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var subject, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  subject = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'subject'));
  regExp = (new RegExp('.{4,}', 'g'));
  if (subject.length <= 50) {
    ___arguments.context.pageData['subjectValue'] = subject;
  } else if (subject.length > 50) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['subject'] = ' ';
    await new Promise(r => setTimeout(r, 1 || 0));
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['subject'] = (subsequenceFirstFromEnd((getObjectProperty(___arguments.context.pageData, 'subjectValue')), 0));
  }
  if ((regExp.test(subject)) == false && subject != '' || subject.length != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'subject')).length && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'subject')).length < 4 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'subject')).length != 0) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintSubject'] = true;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertSubject'] = false;
  } else if ((regExp.test(subject)) == false && subject == '' || subject != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'subject')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'subject')).length == 0) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintSubject'] = false;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertSubject'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintSubject'] = false;
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertSubject'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/contactthanks/components/62b8d2c93d55f72d1532be36ea93f7ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var number, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  number = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'number'));
  regExp = (new RegExp('^[0-9+\\(\\)\\-\\s]+$', 'g'));
  if ((regExp.test(___arguments.value)) && ___arguments.value.length >= 5) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintNumber'] = false;
  } else if (___arguments.value == '') {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintNumber'] = false;
  } else {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintNumber'] = true;
  }
  if (number && ___arguments.value.length <= 50) {
    ___arguments.context.pageData['numberValue'] = number;
  } else if (number && ___arguments.value.length > 50) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['number'] = '';
    await new Promise(r => setTimeout(r, 1 || 0));
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['number'] = (subsequenceFirstFromEnd((getObjectProperty(___arguments.context.pageData, 'numberValue')), 0));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/contactthanks/components/cbcd55f2dc661a25b98d419e39a3633f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var message, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  message = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'message'));
  regExp = (new RegExp('.{1,}', 'g'));
  if (message.length <= 249) {
    ___arguments.context.pageData['messageValue'] = message;
  } else if (message.length > 249) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['message'] = '';
    await new Promise(r => setTimeout(r, 1 || 0));
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['message'] = (subsequenceFirstFromEnd((getObjectProperty(___arguments.context.pageData, 'messageValue')), 0));
  }
  if ((regExp.test(message)) == false) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertMessage'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertMessage'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/contactthanks/components/8ea773dc8cb58841c64de58f25457792/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, message, number, subject, email, name2, checkStatusNumber, chekStatusMessage, checkStatusSubject, checkStatusEmail, checkStatusName, statusMessage, statusNumber, statusSubject, statusEmail, statusName, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function nameValidation() {
  regExp = (new RegExp('.{2,}', 'g'));
  if ((regExp.test(name2)) == false || name2 == '' || name2 == null) {
    return ({ 'status': false });
  }
  return { 'status': true }
}

/**
 * Describe this function...
 */
async function checkStatusName2() {
  if ((getObjectProperty(statusName, 'status')) == false) {
    await ( async function (component) { component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9ddc4897b0a9d658f76b74e111db7048')));
    if (name2 == '' || name2 == null) {
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertName'] = true;
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintName'] = false;
      return false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertName'] = false;
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintName'] = true;
      return false;
    }
  }
  return true
}

/**
 * Describe this function...
 */
async function checkStatusEmail2() {
  if ((getObjectProperty(statusEmail, 'status')) == false) {
    await ( async function (component) { component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0ad8d1e9d1d143aaa6433df4ef44c48e')));
    if (email == '' || email == null) {
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertEmail'] = true;
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintEmail'] = false;
      return false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertEmail'] = false;
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintEmail'] = true;
      return false;
    }
  }
  return true
}

/**
 * Describe this function...
 */
async function checkStatusSubject2() {
  if ((getObjectProperty(statusSubject, 'status')) == false) {
    await ( async function (component) { component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2e1aae5a7f9baa269dc2f96ebdba2dae')));
    if (subject == '' || subject == null) {
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertSubject'] = true;
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintSubject'] = false;
      return false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertSubject'] = false;
      ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintSubject'] = true;
      return false;
    }
  }
  return true
}

/**
 * Describe this function...
 */
async function checkStatusNumber2() {
  if ((getObjectProperty(statusNumber, 'status')) == false) {
    await ( async function (component) { component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('62b8d2c93d55f72d1532be36ea93f7ee')));
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintNumber'] = true;
    return false;
  }
  return true
}

/**
 * Describe this function...
 */
async function checkStatusMessage() {
  if ((getObjectProperty(statusMessage, 'status')) == false) {
    ___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertMessage'] = true;
    return false;
  }
  return true
}

/**
 * Describe this function...
 */
async function emailValidation() {
  regExp = (new RegExp('[a-zA-Z0-9.\\-_+]{1,}@[^\\W\\.][a-zA-Z0-9\\-]{0,}\\.[a-zA-Z]{1,}', 'g'));
  if ((regExp.test(email)) == false || email == '' || email == null) {
    return ({ 'status': false });
  }
  return { 'status': true }
}

/**
 * Describe this function...
 */
async function subjectValidation() {
  regExp = (new RegExp('.{4,}', 'g'));
  if ((regExp.test(subject)) == false || subject == '' || subject == null) {
    return ({ 'status': false });
  }
  return { 'status': true }
}

/**
 * Describe this function...
 */
async function numberValidation() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'hintNumber')) == true) {
    return ({ 'status': false });
  }
  return { 'status': true }
}

/**
 * Describe this function...
 */
async function messageValidation() {
  if (message == null || message == '') {
    return ({ 'status': false });
  }
  return { 'status': true }
}


  name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'name'));
  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'email'));
  subject = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'subject'));
  message = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'message'));
  number = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'number'));
  statusName = await nameValidation();
  statusEmail = await emailValidation();
  statusSubject = await subjectValidation();
  statusNumber = await numberValidation();
  statusMessage = await messageValidation();
  chekStatusMessage = await checkStatusMessage();
  checkStatusNumber = await checkStatusNumber2();
  checkStatusSubject = await checkStatusSubject2();
  checkStatusEmail = await checkStatusEmail2();
  checkStatusName = await checkStatusName2();
  if (checkStatusName != false && checkStatusEmail != false && checkStatusSubject != false && chekStatusMessage != false && checkStatusNumber != false) {
    await Backendless.Data.of('Subscriber').save( ({ 'name': name2,'email': email,'subject': subject,'number': number,'message': message }) );
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('243ee92ab8aa9dd974dc954f5f46955d', false);
    try {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3fff9ae65199eac88899a9ab395312c', true);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6bd8d046c8ac5a23a7209087c5357bd', false);

    } catch (error) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3fff9ae65199eac88899a9ab395312c', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6bd8d046c8ac5a23a7209087c5357bd', true);
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/2d12a1e521b80b0ccec66164314663bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'counterSlide2')) == (getObjectProperty(___arguments.context.dataModel, 'id'))) {
    return ['modal__slider-item', 'active'];
  }

  return ['modal__slider-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/cb17f98d8075cc75fa4c3f1c0e4271bb/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    var listLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')).length;
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('40d3de691f98337ca967cdc86308965c', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')));
  if ((getObjectProperty(___arguments.context.pageData, 'counterSlide2')) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cb17f98d8075cc75fa4c3f1c0e4271bb'))['opacity'] = '0';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cb17f98d8075cc75fa4c3f1c0e4271bb'))['opacity'] = '1';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    var listLength;


  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')).length;
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('40d3de691f98337ca967cdc86308965c', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cb17f98d8075cc75fa4c3f1c0e4271bb'))['opacity'] = '0';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  onClick(___arguments) {
    var listLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')).length;
  if ((getObjectProperty(___arguments.context.pageData, 'counterSlide2')) > 1) {
    ___arguments.context.pageData['counterSlide2'] = ((getObjectProperty(___arguments.context.pageData, 'counterSlide2')) == 1 ? listLength : (getObjectProperty(___arguments.context.pageData, 'counterSlide2')) - 1);
  }
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('40d3de691f98337ca967cdc86308965c', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')));
  ___arguments.context.pageData['currentSlide'] = (getObjectProperty(___arguments.context.pageData, 'counterSlide2'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/42a34151880a40284a835e4d22762292/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    var listLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')).length;
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('40d3de691f98337ca967cdc86308965c', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')));
  if ((getObjectProperty(___arguments.context.pageData, 'counterSlide2')) == listLength) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('42a34151880a40284a835e4d22762292'))['opacity'] = '0';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('42a34151880a40284a835e4d22762292'))['opacity'] = '1';
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    var listLength;


  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')).length;
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('40d3de691f98337ca967cdc86308965c', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('42a34151880a40284a835e4d22762292'))['opacity'] = '0';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  onClick(___arguments) {
    var listLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')).length;
  if ((getObjectProperty(___arguments.context.pageData, 'counterSlide2')) < listLength) {
    ___arguments.context.pageData['counterSlide2'] = ((getObjectProperty(___arguments.context.pageData, 'counterSlide2')) == listLength ? 1 : (getObjectProperty(___arguments.context.pageData, 'counterSlide2')) + 1);
  }
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('40d3de691f98337ca967cdc86308965c', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')));
  ___arguments.context.pageData['currentSlide'] = (getObjectProperty(___arguments.context.pageData, 'counterSlide2'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/e5cb14817aa6357b1ce290a91de93006/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/285e194a17cc5c8df056de4742a6b2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listLength, galleryList, teamList, featureList, mapList, appData, testimonials, item, counter, data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setIdItem(data) {
  counter = 1;
  return await Promise.all(data.map(async item => {  item['id'] = counter;
  counter = (typeof counter == 'number' ? counter : 0) + 1;
; return item;}))
}


  ___arguments.context.pageData['isOpenModal'] = false;
  appData = (await (async function() {
  	const data = {
  	  "features": [
  	    {
  	      "id": "f1",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-1.jpg",
  	      "title": "Simple & Light",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    },
  	    {
  	      "id": "f2",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-2.jpg",
  	      "title": "Super Fast",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    },
  	    {
  	      "id": "f3",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-3.jpg",
  	      "title": "Stunning Design",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    },
  	    {
  	      "id": "f4",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-4.jpg",
  	      "title": "Frequent Updates",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    },
  	    {
  	      "id": "f5",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-5.jpg",
  	      "title": "Super Responsive",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    },
  	    {
  	      "id": "f6",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-6.jpg",
  	      "title": "100% Clean Code",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    },
  	    {
  	      "id": "f7",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-7.jpg",
  	      "title": "Awesome Graphics",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    },
  	    {
  	      "id": "f8",
  	      "icon": "https://backendless.com/images/Elegant/dbImg/icons/feature-8.jpg",
  	      "title": "Retina Ready",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  	    }
  	  ],
  	  "gallery": [
  	    {
  	      "id": "g1",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item1.jpg"
  	    },
  	    {
  	      "id": "g2",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item2.jpg"
  	    },
  	    {
  	      "id": "g3",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item3.jpg"
  	    },
  	    {
  	      "id": "g4",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item4.jpg"
  	    },
  	    {
  	      "id": "g5",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item5.jpg"
  	    },
  	    {
  	      "id": "g6",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item6.jpg"
  	    },
  	    {
  	      "id": "g7",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item7.jpg"
  	    },
  	    {
  	      "id": "g8",
  	      "image": "https://backendless.com/images/Elegant/dbImg/g-slider/g-item8.jpg"
  	    },
  	  ],
  	  "team": [
  	    {
  	      "id": "t1",
  	      "name": "John Doe",
  	      "position": "Founder & CEO",
  	      "photo": "https://backendless.com/images/Elegant/dbImg/team/person1.jpg",
  	      "socialMedia": {
  	        "social": [
  	          {
  	            "url": "#",
  	            "name": "facebook"
  	          },
  	          {
  	            "url": "#",
  	            "name": "github"
  	          },
  	          {
  	            "url": "#",
  	            "name": "linkedin"
  	          },
  	          {
  	            "url": "",
  	            "name": "twitter"
  	          }
  	        ]
  	      }
  	    },
  	    {
  	      "id": "t2",
  	      "name": "Joan Doe",
  	      "position": "Co-founder",
  	      "photo": "https://backendless.com/images/Elegant/dbImg/team/person2.jpg",
  	      "socialMedia": {
  	        "social": [
  	          {
  	            "url": "#",
  	            "name": "facebook"
  	          },
  	          {
  	            "url": "",
  	            "name": "github"
  	          },
  	          {
  	            "url": "",
  	            "name": "linkedin"
  	          },
  	          {
  	            "url": "#",
  	            "name": "twitter"
  	          }
  	        ]
  	      }
  	    },
  	    {
  	      "id": "t3",
  	      "name": "John Doe",
  	      "position": "Financial Manager",
  	      "photo": "https://backendless.com/images/Elegant/dbImg/team/person3.jpg",
  	      "socialMedia": {
  	        "social": [
  	          {
  	            "url": "#",
  	            "name": "facebook"
  	          },
  	          {
  	            "url": "",
  	            "name": "github"
  	          },
  	          {
  	            "url": "",
  	            "name": "linkedin"
  	          },
  	          {
  	            "url": "#",
  	            "name": "twitter"
  	          }
  	        ]
  	      }
  	    },
  	    {
  	      "id": "t4",
  	      "name": "Joan Doe",
  	      "position": "Co-founder",
  	      "photo": "https://backendless.com/images/Elegant/dbImg/team/person4.jpg",
  	      "socialMedia": {
  	        "social": [
  	          {
  	            "url": "#",
  	            "name": "facebook"
  	          },
  	          {
  	            "url": "",
  	            "name": "github"
  	          },
  	          {
  	            "url": "",
  	            "name": "linkedin"
  	          },
  	          {
  	            "url": "#",
  	            "name": "twitter"
  	          }
  	        ]
  	      }
  	    }
  	  ],
  	  "testimonials": [
  	    {
  	      "id": "tm1",
  	      "name": "Joan Doe",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
  	      "photo": "https://backendless.com/images/Elegant/dbImg/testimonials/auth1.jpg"
  	    },
  	    {
  	      "id": "tm2",
  	      "name": "John Doe",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
  	      "photo": "https://backendless.com/images/Elegant/dbImg/testimonials/auth2.jpg"
  	    },
  	    {
  	      "id": "tm3",
  	      "name": "Joan Doe",
  	      "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
  	      "photo": "https://backendless.com/images/Elegant/dbImg/testimonials/auth3.jpg"
  	    }
  	  ],
  	}

  	return data
  })());
  featureList = (getObjectProperty(appData, 'features'));
  galleryList = (getObjectProperty(appData, 'gallery'));
  ___arguments.context.appData['galleryList'] = galleryList;
  testimonials = (getObjectProperty(appData, 'testimonials'));
  ___arguments.context.appData['testimonialsList'] = testimonials;
  teamList = (getObjectProperty(appData, 'team'));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0875e5b21a8bb4c1a57b4af94b7e763a', (await setIdItem(featureList)));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d45bf717bf26eaff3b35e2d8ff2911c9', teamList);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('40d3de691f98337ca967cdc86308965c', (await setIdItem(galleryList)));
  listLength = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('40d3de691f98337ca967cdc86308965c')).length;
  ___arguments.context.pageData['totalSlide'] = listLength;
  ___arguments.context.pageData['currentSlide'] = 1;

  },
  /* handler:onEnter */
  /* handler:onScroll */
  async onScroll(___arguments) {
    var topOnViewport, header, elem, item, download, features, testimonials, team, gallery, home2, contact;

/**
 * Describe this function...
 */
async function topOnViewport2(elem, header) {
  topOnViewport = ((await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', elem)) - (await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientHeight'))) + ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientHeight')) - (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', header)));
  return topOnViewport
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  contact = await topOnViewport2(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('882be1f601f98778b25cf7bacef9265a')), ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')));
  download = await topOnViewport2(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d1bf935e1bab02980678013a2763e511')), ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')));
  team = await topOnViewport2(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aa0f285ad5df49b70c0bfe029845a312')), ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')));
  gallery = await topOnViewport2(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2aa6f4d557658523b67b45e8f87c00e4')), ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')));
  testimonials = await topOnViewport2(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9a2858573fd8924367d342144d4edac5')), ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')));
  features = await topOnViewport2(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c0337ae1f14b7fd20497817f545a8751')), ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')));
  home2 = await topOnViewport2(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')), ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')));
  if (___arguments.scrollTop - (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')))) < home2) {
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')).toLowerCase() == (getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')), 'anchor'))) {
        item['active'] = true;
      } else {
        item['active'] = false;
      }
    ; return item;}))));
  }
  if (___arguments.scrollTop - ((await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278'))))) < features && ___arguments.scrollTop >= home2) {
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')).toLowerCase() == (getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c0337ae1f14b7fd20497817f545a8751')), 'anchor'))) {
        item['active'] = true;
      } else {
        item['active'] = false;
      }
    ; return item;}))));
  }
  if (___arguments.scrollTop - ((await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c0337ae1f14b7fd20497817f545a8751'))))) < testimonials && ___arguments.scrollTop > home2 + features) {
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')).toLowerCase() == (getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9a2858573fd8924367d342144d4edac5')), 'anchor'))) {
        item['active'] = true;
      } else {
        item['active'] = false;
      }
    ; return item;}))));
  }
  if (___arguments.scrollTop - ((await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9a2858573fd8924367d342144d4edac5')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c0337ae1f14b7fd20497817f545a8751'))))) < gallery && ___arguments.scrollTop > home2 + testimonials + features) {
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')).toLowerCase() == (getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2aa6f4d557658523b67b45e8f87c00e4')), 'anchor'))) {
        item['active'] = true;
      } else {
        item['active'] = false;
      }
    ; return item;}))));
  }
  if (___arguments.scrollTop - ((await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9a2858573fd8924367d342144d4edac5')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c0337ae1f14b7fd20497817f545a8751')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2aa6f4d557658523b67b45e8f87c00e4'))))) < team && ___arguments.scrollTop > home2 + gallery + testimonials + features) {
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')).toLowerCase() == (getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aa0f285ad5df49b70c0bfe029845a312')), 'anchor'))) {
        item['active'] = true;
      } else {
        item['active'] = false;
      }
    ; return item;}))));
  }
  if (___arguments.scrollTop - ((await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9a2858573fd8924367d342144d4edac5')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aa0f285ad5df49b70c0bfe029845a312')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c0337ae1f14b7fd20497817f545a8751')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2aa6f4d557658523b67b45e8f87c00e4'))))) < download && ___arguments.scrollTop > home2 + gallery + team + testimonials + features) {
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')).toLowerCase() == (getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d1bf935e1bab02980678013a2763e511')), 'anchor'))) {
        item['active'] = true;
      } else {
        item['active'] = false;
      }
    ; return item;}))));
  }
  if (___arguments.scrollTop - ((await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9a2858573fd8924367d342144d4edac5')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d1bf935e1bab02980678013a2763e511')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aa0f285ad5df49b70c0bfe029845a312')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c0337ae1f14b7fd20497817f545a8751')))) + (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2aa6f4d557658523b67b45e8f87c00e4'))))) < contact && ___arguments.scrollTop > home2 + gallery + team + testimonials + features + download * 2) {
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aff3d05702623d21c1db6f68783a6dfc', (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aff3d05702623d21c1db6f68783a6dfc')).map(async item => {  if ((getObjectProperty(item, 'textLink')).toLowerCase() == (getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('882be1f601f98778b25cf7bacef9265a')), 'anchor'))) {
        item['active'] = true;
      } else {
        item['active'] = false;
      }
    ; return item;}))));
  }
  if (Math.round(___arguments.scrollTop) > (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683'))))) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683'))['background-color'] = 'rgb(255, 255, 255)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683'))['box-shadow'] = '0 0 4px 0 rgba(0, 0, 0, 0.2)';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683'))['border-bottom'] = '0';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683'))['background-color'] = '#f6f6f6';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683'))['box-shadow'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fc133deb21ead499969abdb9ef0a1683'))['border-bottom'] = '2px solid #ffffff';
  }
  if (___arguments.scrollTop >= (await ( async function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('91156d2355c5751d74514948ded36278')))) / 2) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('46fc2afb18d67d579661877362631f97'))['visibility'] = 'visible';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('46fc2afb18d67d579661877362631f97'))['visibility'] = 'hidden';
  }

  },
  /* handler:onScroll */
  /* handler:onResize */
  async onResize(___arguments) {
    var leftSlideBy, left, j, half, galleryList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('aff3d05702623d21c1db6f68783a6dfc'))['height'] = 'auto';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('aff3d05702623d21c1db6f68783a6dfc'))['height'] = '0';
  }
  galleryList = (getObjectProperty(___arguments.context.appData, 'galleryList'));
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 1200) {
    ___arguments.context.appData['leftSlideBy'] = 228;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1199) {
    ___arguments.context.appData['leftSlideBy'] = 192;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 990) {
    ___arguments.context.appData['leftSlideBy'] = 240;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ___arguments.context.appData['leftSlideBy'] = 270;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 576) {
    ___arguments.context.appData['leftSlideBy'] = 251;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 480) {
    ___arguments.context.appData['leftSlideBy'] = 100;
  }
  leftSlideBy = (getObjectProperty(___arguments.context.appData, 'leftSlideBy'));
  half = Math.floor(galleryList.length / 2);
  ___arguments.context.pageData['leftStart'] = (0 - half * leftSlideBy);
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768 && (await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 576) {
    ___arguments.context.pageData['leftStart'] = ((getObjectProperty(___arguments.context.pageData, 'leftStart')) + 135);
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 576 && (await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 480) {
    ___arguments.context.pageData['leftStart'] = ((getObjectProperty(___arguments.context.pageData, 'leftStart')) + 85);
  }
  left = (getObjectProperty(___arguments.context.pageData, 'leftStart'));
  var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('30c68e35b1bba5b59e93ae77986a1e9d'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['opacity'] = 1;
    j['left'] = left;
    if (left == leftSlideBy * 2 && leftSlideBy == 228 || left == leftSlideBy * 2 && leftSlideBy == 192) {
      j['active'] = true;
    } else if (left == leftSlideBy && leftSlideBy == 240) {
      j['active'] = true;
    } else if (left == 85 && leftSlideBy == 251 || left == 135 && leftSlideBy == 270) {
      j['active'] = true;
    } else if (left == 0 && leftSlideBy == 100) {
      j['active'] = true;
    } else {
      j['active'] = false;
    }
    left = (typeof left == 'number' ? left : 0) + leftSlideBy;
  }

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/contactthanks/components/62393ad21e379cc7dc4be0b21e42bdde/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    return ['modal', 'open'];
  }

  return ['modal']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/0d95afee086dc43f53072178252ad52b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModal'] = true;
  ___arguments.context.pageData['counterSlide2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dfb482b870313814d16c183c561cfd95'), 'id'));
  ___arguments.context.pageData['currentSlide'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dfb482b870313814d16c183c561cfd95'), 'id'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/4cd8dbaf86c1da424f6cdfa7eb6f2598/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var leftSlideBy, minValue, card, left, j, maxValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  maxValue = 0;
  minValue = 0;
  leftSlideBy = (getObjectProperty(___arguments.context.appData, 'leftSlideBy'));
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'stopClick')) === 'undefined') || ((new Date()).valueOf()) > (getObjectProperty(___arguments.context.pageData, 'stopClick')) + 300) {
    ___arguments.context.pageData['stopClick'] = ((new Date()).valueOf());
    var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('30c68e35b1bba5b59e93ae77986a1e9d'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['opacity'] = 1;
      j['left'] = ((getObjectProperty(j, 'left')) + leftSlideBy);
      left = (getObjectProperty(j, 'left'));
      if (left == leftSlideBy * 2 && leftSlideBy == 228 || left == leftSlideBy * 2 && leftSlideBy == 192) {
        j['active'] = true;
      } else if (left == leftSlideBy && leftSlideBy == 240) {
        j['active'] = true;
      } else if (left == 85 && leftSlideBy == 251 || left == 135 && leftSlideBy == 270) {
        j['active'] = true;
      } else if (left == 0 && leftSlideBy == 100) {
        j['active'] = true;
      } else {
        j['active'] = false;
      }
      if (maxValue < left) {
        maxValue = left;
        card = j;
      }
      if (minValue > left) {
        minValue = left;
      }
    }
    card['opacity'] = 0;
    card['left'] = (minValue - leftSlideBy);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/50619c631c859d79bd988633061ad14e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var leftSlideBy, maxValue, card, left, j, minValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  maxValue = 0;
  minValue = 0;
  leftSlideBy = (getObjectProperty(___arguments.context.appData, 'leftSlideBy'));
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'stopClick')) === 'undefined') || ((new Date()).valueOf()) > (getObjectProperty(___arguments.context.pageData, 'stopClick')) + 300) {
    ___arguments.context.pageData['stopClick'] = ((new Date()).valueOf());
    var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('30c68e35b1bba5b59e93ae77986a1e9d'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['left'] = ((getObjectProperty(j, 'left')) - leftSlideBy);
      left = (getObjectProperty(j, 'left'));
      j['opacity'] = 1;
      if (left == leftSlideBy * 2 && leftSlideBy == 228 || left == leftSlideBy * 2 && leftSlideBy == 192) {
        j['active'] = true;
      } else if (left == leftSlideBy && leftSlideBy == 240) {
        j['active'] = true;
      } else if (left == 85 && leftSlideBy == 251 || left == 135 && leftSlideBy == 270) {
        j['active'] = true;
      } else if (left == 0 && leftSlideBy == 100) {
        j['active'] = true;
      } else {
        j['active'] = false;
      }
      if (minValue > left) {
        minValue = left;
        card = j;
      }
      if (maxValue < left) {
        maxValue = left;
      }
    }
    card['opacity'] = 0;
    card['left'] = (maxValue + leftSlideBy);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/contactthanks/components/dfb482b870313814d16c183c561cfd95/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 480) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('dfb482b870313814d16c183c561cfd95'))['left'] = (String(getObjectProperty(___arguments.context.dataModel, 'left')) + String('px'));
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('dfb482b870313814d16c183c561cfd95'))['left'] = (String(getObjectProperty(___arguments.context.dataModel, 'left')) + String('%'));
  }
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('dfb482b870313814d16c183c561cfd95'))['opacity'] = (getObjectProperty(___arguments.context.dataModel, 'opacity'));
  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['g-slider__item', 'g-slider__item_center'];
  }

  return ['g-slider__item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/aa2f478c6836c0440f9d99acb3b985df/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    var item, mapPin, lng, lat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lat = 33.099735;
  lng = -96.824961;
  mapPin = (await (async function() {
  	const myLatLng = {
  	  "points": [
  	    {
  	      "lat": 33.099735,
  	      "lng": -96.824961
  	    }
  	  ]
  	}
  	return myLatLng
  })());
  ;(function (componentUid, lat, lng){ ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('aa2f478c6836c0440f9d99acb3b985df', lat, lng);
  ;(function (componentUid, points){ ___arguments.context.getComponentByUid(componentUid).points = points })('aa2f478c6836c0440f9d99acb3b985df', (await Promise.all((getObjectProperty(mapPin, 'points')).map(async item => {; return item;}))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/contactthanks/components/7fccba1dda5667efe4ffd83b67c9f272/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['c-form__label', 'c-form__label-name'];
  if ((___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['alertName']) == true) {
    addItemToList(classes, 'c-form__label_alert');
  } else if ((___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08')['hintName']) == true) {
    addItemToList(classes, 'c-form__label_hint');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/6e787161ccd763e62ee36bcb895e40c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['c-form__label', 'c-form__label-email'];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'alertEmail')) == true) {
    addItemToList(classes, 'c-form__label_alert');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'hintEmail')) == true) {
    addItemToList(classes, 'c-form__label_hint');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/ef6a70ad44db658cafe9e61d9ea4e02f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['c-form__label', 'c-form__label-subject'];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'alertSubject')) == true) {
    addItemToList(classes, 'c-form__label_alert');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'hintSubject')) == true) {
    addItemToList(classes, 'c-form__label_hint');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/a975c83c0e469ebe4c5bbb878d83bf66/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['c-form__label', 'c-form__label-number'];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'hintNumber')) == true) {
    addItemToList(classes, 'c-form__label_hint');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/54cd993c0af8e2d2b7f698c3b0f45ff5/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['c-form__label', 'c-form__label-message'];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b29dc885912eda7779b5616bd6ef4c08'), 'alertMessage')) == true) {
    addItemToList(classes, 'c-form__label_alert');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/contactthanks/components/30c68e35b1bba5b59e93ae77986a1e9d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    var item, leftSlideBy, left, newGalleryList, half, firstList, galleryList, lastList, idGalleryItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await new Promise(r => setTimeout(r, 1000 || 0));
  galleryList = (getObjectProperty(___arguments.context.appData, 'galleryList'));
  idGalleryItem = 1;
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('30c68e35b1bba5b59e93ae77986a1e9d', (await Promise.all(galleryList.map(async item => {  item['id'] = idGalleryItem;
    idGalleryItem = (typeof idGalleryItem == 'number' ? idGalleryItem : 0) + 1;
  ; return item;}))));
  ___arguments.context.appData['leftSlideBy'] = 228;
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1199) {
    ___arguments.context.appData['leftSlideBy'] = 192;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 990) {
    ___arguments.context.appData['leftSlideBy'] = 240;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ___arguments.context.appData['leftSlideBy'] = 270;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 576) {
    ___arguments.context.appData['leftSlideBy'] = 251;
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 480) {
    ___arguments.context.appData['leftSlideBy'] = 100;
  }
  half = Math.floor(galleryList.length / 2);
  lastList = galleryList.slice(((half + 1) - 1), galleryList.length);
  firstList = galleryList.slice(0, half);
  newGalleryList = (JSON.parse((JSON.stringify(((addItemToList(lastList, galleryList)).concat(firstList))))));
  leftSlideBy = (getObjectProperty(___arguments.context.appData, 'leftSlideBy'));
  ___arguments.context.pageData['leftStart'] = (0 - half * leftSlideBy);
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768 && (await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 576) {
    ___arguments.context.pageData['leftStart'] = ((getObjectProperty(___arguments.context.pageData, 'leftStart')) + 135);
  }
  if ((await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 576 && (await ( async function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 480) {
    ___arguments.context.pageData['leftStart'] = ((getObjectProperty(___arguments.context.pageData, 'leftStart')) + 85);
  }
  left = (getObjectProperty(___arguments.context.pageData, 'leftStart'));
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('30c68e35b1bba5b59e93ae77986a1e9d', (await Promise.all(newGalleryList.map(async item => {  item['opacity'] = 1;
    item['left'] = left;
    if (left == leftSlideBy * 2 && leftSlideBy == 228 || left == leftSlideBy * 2 && leftSlideBy == 192) {
      item['active'] = true;
    } else if (left == leftSlideBy && leftSlideBy == 240) {
      item['active'] = true;
    } else if (left == 85 && leftSlideBy == 251 || left == 135 && leftSlideBy == 270) {
      item['active'] = true;
    } else if (left == 0 && leftSlideBy == 100) {
      item['active'] = true;
    } else {
      item['active'] = false;
    }
    left = (typeof left == 'number' ? left : 0) + leftSlideBy;
  ; return item;}))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/contactthanks/components/b29dc885912eda7779b5616bd6ef4c08/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['nameValue'] = '';
  ___arguments.context.pageData['emailValue'] = '';
  ___arguments.context.pageData['subjectValue'] = '';
  ___arguments.context.pageData['numberValue'] = '';
  ___arguments.context.pageData['messageValue'] = '';

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/dashboard/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('cli_profile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var savings, clientTrxListY, savingsO, savingsM, savingsList, CurrentTrx, clientTrxList, clientList2, j, ClientObj, ClientList, ClientListCount, rptr_name, dirlist, savingsGPR, savingsTotal, currentMonthTrx, CurrClientBase, clientTrxListM, AgentRes2, AgentRes1, list, agid, clientTrxListD, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Calc_Yearly() {
  savings = await getTrxTotals(clientTrxListY);
  ___arguments.context.pageData['savingsYearlyM'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (savings[0])));
  ___arguments.context.pageData['savingsYearlyO'] = (savings.slice(-1)[0]);
}

/**
 * Describe this function...
 */
async function getTrxTotals(clientTrxList) {
  savingsM = 0;
  savingsO = 0;
  for (var CurrentTrx_index in clientTrxList) {
    CurrentTrx = clientTrxList[CurrentTrx_index];
    savingsList = await getsavings(CurrentTrx);
    savingsM = savingsM + savingsList.slice(-1)[0];
    savingsO = savingsO + 1;
  }
  return [savingsM, savingsO]
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GetClientJourney() {
  console.log('=D00= GetClientJourney');
  ClientList = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) == 1 ? '' : String('agentid=') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userid')))).setProperties((['cmpname',',','name',',','AgrDocLink',',','AgrSigLink',',','isACHcomplete',',','ACHcompleteDate',',','CSAactive',',','CSApending'].join(''))).setPageSize(100)));
  clientList2 = [];
  for (var j_index in ClientList) {
    j = ClientList[j_index];
    addItemToList(clientList2, ({ [`cmpname`]: (typeof (getObjectProperty(j, 'cmpname')) === 'undefined') || ((getObjectProperty(j, 'cmpname')) === null) ? '' : (getObjectProperty(j, 'cmpname')).trim(),[`name`]: (typeof (getObjectProperty(j, 'name')) === 'undefined') || ((getObjectProperty(j, 'name')) === null) ? '' : (getObjectProperty(j, 'name')).trim(),[`imgAGR`]: (typeof (getObjectProperty(j, 'AgrDocLink')) === 'undefined') || ((getObjectProperty(j, 'AgrDocLink')) === null) ? false : true,[`imgSIG`]: (typeof (getObjectProperty(j, 'AgrSigLink')) === 'undefined') || ((getObjectProperty(j, 'AgrSigLink')) === null) ? false : true,[`imgACH`]: (typeof (getObjectProperty(j, 'ACHcompleteDate')) === 'undefined') || ((getObjectProperty(j, 'ACHcompleteDate')) === null) ? false : true,[`imgCSAA`]: (getObjectProperty(j, 'CSAactive')),[`imgCSAP`]: (getObjectProperty(j, 'CSApending')) }));
  }
  ___arguments.context.pageData['clientJourney'] = clientList2;
  console.log('=D00= END ClientJourney=');
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function FormatDirContent() {
  dirlist = [(await Backendless.Files.listing(encodePath('documents/agents'), '*.pdf', false, 100, 0))];
  for (var j_index2 in dirlist) {
    j = dirlist[j_index2];
    rptr_name = (getObjectProperty(j, 'name')).slice(0, ((getObjectProperty(j, 'name')).lastIndexOf('.') + 1) - 1);
    console.log(String('filename=') + String(rptr_name));
  }
  return { [`type`]: 'PDF',[`document`]: (getObjectProperty(j, 'name')),[`size`]: (Number((getObjectProperty(j, 'size')))) / 1024,[`action`]: ['<button type=\'button\' style=\'border:"none"; padding:"5px 15px"; background-color:"#008CBA";\'>',(getObjectProperty(j, 'url')),'</button>'].join('') }
}

/**
 * Describe this function...
 */
async function getsavings(currentMonthTrx) {
  CurrClientBase = (getObjectProperty(currentMonthTrx, 'billbaseamt'));
  savingsTotal = CurrClientBase - (getObjectProperty(currentMonthTrx, 'billamount'));
  if (savingsTotal <= 0) {
    savingsTotal = 0;
    savingsGPR = 0;
  } else {
    savingsGPR = savingsTotal / 2;
  }
  savingsGPR = (await BackendlessUI.Functions.Custom['fn_269ae5233b7fb77961825d7b294a2826'](savingsGPR, 2));
  return [savingsTotal, savingsGPR]
}

/**
 * Describe this function...
 */
async function Calc_Monthly() {
  savings = await getTrxTotals(clientTrxListM);
  ___arguments.context.pageData['savingsMonthlyM'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (savings[0])));
  ___arguments.context.pageData['savingsMonthlyO'] = (savings.slice(-1)[0]);
}

/**
 * Describe this function...
 */
async function getAgentResources() {
  console.log('=D00= GetAgentResources');
  AgentRes1 = (await Backendless.Data.of('vwAgentResources').find(Backendless.DataQueryBuilder.create().setSortBy('resourcename').setPageSize(100)));
  AgentRes2 = [];
  for (var j_index3 in AgentRes1) {
    j = AgentRes1[j_index3];
    addItemToList(AgentRes2, ({ [`resname`]: (typeof (getObjectProperty(j, 'resourcename')) === 'undefined') || ((getObjectProperty(j, 'resourcename')) === null) ? '' : (getObjectProperty(j, 'resourcename')).trim(),[`resdesc`]: (typeof (getObjectProperty(j, 'resourcedescription')) === 'undefined') || ((getObjectProperty(j, 'resourcedescription')) === null) ? '' : (getObjectProperty(j, 'resourcedescription')).trim(),[`resimg`]: (typeof (getObjectProperty(j, 'resourceimage')) === 'undefined') || ((getObjectProperty(j, 'resourceimage')) === null) ? '' : (getObjectProperty(j, 'resourceimage')).trim(),[`reslink`]: (typeof (getObjectProperty(j, 'resourcelink')) === 'undefined') || ((getObjectProperty(j, 'resourcelink')) === null) ? '' : (getObjectProperty(j, 'resourcelink')).trim(),[`resdwn`]: (typeof (getObjectProperty(j, 'resourcelink')) === 'undefined') || ((getObjectProperty(j, 'resourcelink')) === null) ? '' : (getObjectProperty(j, 'resourcelink')).trim() }));
  }
  ___arguments.context.pageData['agentResources'] = AgentRes2;
}

/**
 * Describe this function...
 */
async function getAgent(agid) {
  console.log(String('=D00 Page= getagent == agid=') + String(agid));
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(agid))).setPageSize(100)));
  ___arguments.context.appData['agent'] = (list[0]);
  console.log(String('=D00 Page= agent=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'agent')))));
  console.log('=D00= end getagent');
}

/**
 * Describe this function...
 */
async function Calc_Daily() {
  savings = await getTrxTotals(clientTrxListD);
  ___arguments.context.pageData['savingsDailyM'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (savings[0])));
  ___arguments.context.pageData['savingsDailyO'] = (savings.slice(-1)[0]);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getTrxLists() {
  clientTrxListY = (await Backendless.Data.of('vwClientTrx').find(Backendless.DataQueryBuilder.create().setWhereClause(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) == 1 ? ['created >= \'',((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('Y')).valueOf()),'\''].join('') : ['agentid=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userid')),' AND ',['created >= \'',((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('Y')).valueOf()),'\''].join('')].join(''))).setPageSize(10)));
  ___arguments.context.pageData['savingsYearlyO'] = 0;
  ___arguments.context.pageData['savingsYearlyM'] = 0;
  clientTrxListM = (await asyncListFilter(clientTrxListY, async (item) => {


   return ((getObjectProperty(item, 'created')) >= ((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('M')).valueOf()));
  }));
  ___arguments.context.pageData['savingsMonthlyO'] = 0;
  ___arguments.context.pageData['savingsMonthlyM'] = 0;
  clientTrxListD = (await asyncListFilter(clientTrxListY, async (item) => {


   return ((getObjectProperty(item, 'created')) >= ((await BackendlessUI.Functions.Custom['fn_4496bd57400824fe76c4deb64607becf']('D')).valueOf()));
  }));
  ___arguments.context.pageData['savingsDailyO'] = 0;
  ___arguments.context.pageData['savingsDailyM'] = 0;
}


  if ((typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'currentUser')) === null)) {
    console.log('=D00= No CurrentUser -- go back to Login');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
  } else {
    console.log(String('=D00 Page= CurrentUser=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser')))));
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) > 2) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);
    } else {
      if ((typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'agent')) === null)) {
        console.log('=D00 Page= agent undefined');
        await getAgent((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userid')));
      }
      await GetClientJourney();
      await getAgentResources();
      await getTrxLists();
      await Calc_Yearly();
      await Calc_Monthly();
      await Calc_Daily();
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboard/components/5f6d1dc73e2d5739bb7f80b1aed39ba4/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5fe555cb921ab2240c442fa7de7bf773'), 'imgAGR')) == true ? 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_green.png' : 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_red.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboard/components/b54e171a1bfb3ed6090bad91509d97dd/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5fe555cb921ab2240c442fa7de7bf773'), 'imgSIG')) == true ? 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_green.png' : 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_red.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboard/components/cc5170a1b5cf674c19dc8ac3eada2c27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5fe555cb921ab2240c442fa7de7bf773'), 'imgACH')) == true ? 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_green.png' : 'https://backendlessappcontent.com/DEC6B808-645B-7B62-FF97-8D7C3B617700/6FB96329-6E0F-45FE-9BF3-E2BB1C7600F0/files/images/check_circle_red.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboard/components/910130819f82eda896ffe7f5dfc6bd2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['agInfo'] = ({ [`agSubject`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ac2b2dca9b03fe3fb97d1e324ddf3a62'), 'resname')),[`agName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'name')),[`agEmail`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')),[`agPhone`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone')),[`agLink`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ac2b2dca9b03fe3fb97d1e324ddf3a62'), 'reslink')),[`agDwn`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ac2b2dca9b03fe3fb97d1e324ddf3a62'), 'resdwn')),[`agLinkB`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'qrbusinesscard')),[`agLinkC`]: ['https://app.gprsaves.com/?page=landing00','&agid=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid'))].join('') });
  console.log(String('agInfo=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'agInfo')))));
  console.log(String('agent=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'agInfo')))));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('0632e05b7eb935d8fdd9488f5afd7aae');

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('910130819f82eda896ffe7f5dfc6bd2a'))['animation'] = 'shake 0.5s';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('910130819f82eda896ffe7f5dfc6bd2a'))['animation-iteration-count'] = 'infinite';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('910130819f82eda896ffe7f5dfc6bd2a'))['animation-iteration-count'] = '0';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/dashboard/components/f08bca3aae8953fafbc68e9b2fee7a82/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var filepath, filename;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  filepath = '/agent-docs/resources/';
  filename = subsequenceFromStartLast((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d5d1cd1702962d8ec0f87df92572bb9'), 'resimg')), (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d5d1cd1702962d8ec0f87df92572bb9'), 'resimg')).lastIndexOf('/') + 1 + 1) - 1));

  return (String(filepath) + String(filename))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f08bca3aae8953fafbc68e9b2fee7a82'))['width'] = '50px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f08bca3aae8953fafbc68e9b2fee7a82'))['height'] = '50px';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f08bca3aae8953fafbc68e9b2fee7a82'))['width'] = '150px';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f08bca3aae8953fafbc68e9b2fee7a82'))['width'] = '50px';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/dashboard/components/38b5cd0c7dea4246580da97cb4e39bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ac2b2dca9b03fe3fb97d1e324ddf3a62'), 'resdwn')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38b5cd0c7dea4246580da97cb4e39bc5'))['animation-iteration-count'] = '0';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38b5cd0c7dea4246580da97cb4e39bc5'))['animation'] = 'shake 0.5s';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('38b5cd0c7dea4246580da97cb4e39bc5'))['animation-iteration-count'] = 'infinite';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/dashboard/components/268599ffd1cf38df9ae11c786cec989d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f2854fb170c29b3e73e3b5a061a9aa3', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dashboard/components/5c2f2f679c070a3d93695572062a6016/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agSubject'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dashboard/components/cb3a777be2a5f442c80e1f43ea2f958f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dashboard/components/66fe2b3bfdf4bcb22fb68f4ae72c3bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agEmail'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dashboard/components/a9d3139f5069760c908256ed37f4614e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agPhone'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dashboard/components/318dcd3fb39d93fdb5ff0db1045cca89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0632e05b7eb935d8fdd9488f5afd7aae');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/33ed3b5a63c646bc822df3e5d7598e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f2854fb170c29b3e73e3b5a061a9aa3', (!((new RegExp('', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6b656776e7a638f3ce19c6ce8a63b866'), 'recipEmail'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6b656776e7a638f3ce19c6ce8a63b866'), 'recipEmail')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dashboard/components/6b656776e7a638f3ce19c6ce8a63b866/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var filename, filepath, list, lprec, startpage, templateVars, tid, x;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function getLPstartpage() {
  startpage = '';
  if ((getObjectProperty(___arguments.context.dataModel, 'rbGrp')) > 0) {
    lprec = (await Backendless.Data.of('LandingPages').find(Backendless.DataQueryBuilder.create().setWhereClause('themeid=').setPageSize(10)))[0];
    startpage = ['https://app.gprsaves.com/?page=',(getObjectProperty(lprec, 'pgSTART')),'&agid=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid'))].join('');
  }
  return startpage
}


  filepath = '/agent-docs/resources/';
  filename = subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agLink')), (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agLink')).lastIndexOf('/') + 1 + 1) - 1));
  templateVars = ({ [`name`]: (getObjectProperty(___arguments.context.dataModel, 'recipName')),[`ag_id`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')),[`ag_name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agName')),[`ag_email`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agEmail')),[`ag_phone`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agPhone')),[`ag_card`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'agInfo')), 'agCard')),[`ag_qrLink`]: await getLPstartpage() });
  console.log(String('templateVars=') + String(JSON.stringify(templateVars)));
  console.log((await Backendless.Messaging.sendEmailFromTemplate('Document_You_Requested', Backendless.EmailEnvelope.create({ addresses: [(getObjectProperty(___arguments.context.dataModel, 'recipEmail'))], ccAddresses: ((typeof (getObjectProperty(___arguments.context.dataModel, 'recipCC')) === 'undefined') || ((getObjectProperty(___arguments.context.dataModel, 'recipCC')) === null) ? null : [(getObjectProperty(___arguments.context.dataModel, 'recipCC'))]), bccAddresses: undefined, query: '', uniqueEmails: false }), templateVars, [String(filepath) + String(filename)])));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0632e05b7eb935d8fdd9488f5afd7aae');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/landing00/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var agSelect, agid, pageset, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function QueryAgid() {
  if (!(typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined')) {
    console.log('=00=QueryAgent= 1');
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')));
  } else if (typeof ___arguments.context.pageData === 'undefined') {
    console.log('=00=QueryAgent= 2');
    await setAgid('1');
  } else if (!(typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined')) {
    console.log('=00=QueryAgent= 3');
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')));
  } else {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'agid')) === 'undefined') {
      console.log('=00=QueryAgent= 4a');
      await setAgid('1');
    } else {
      console.log('=00=QueryAgent= 4b');
      await setAgid((getObjectProperty(___arguments.context.pageData, 'agid')));
    }
  }
  await getAgent();
}

/**
 * Describe this function...
 */
async function getAgSelect() {
  agSelect = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('active=') + String(true))).setProperties('name as label, agentid as value').setSortBy('name').setPageSize(100)));
  ___arguments.context.pageData['agSelect'] = agSelect;
}

/**
 * Describe this function...
 */
async function setAgid(agid) {
  if (agid > 1) {
    ___arguments.context.pageData['AskForAgent'] = false;
  } else {
    ___arguments.context.pageData['AskForAgent'] = true;
  }
  ___arguments.context.pageData['agid'] = agid;
}

/**
 * Describe this function...
 */
async function getLandingPages(pageset) {
  ___arguments.context.appData['pages'] = ((await Backendless.Data.of('LandingPages').find(Backendless.DataQueryBuilder.create().setWhereClause((['pageset=\'',pageset,'\''].join(''))).setPageSize(10)))[0]);
}

/**
 * Describe this function...
 */
async function getAgent() {
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((['agentid=\'',(getObjectProperty(___arguments.context.pageData, 'agid')),'\''].join(''))).setPageSize(100)));
  ___arguments.context.appData['agent'] = (list[0]);
}


  console.log('=== Entering Landing00 ===');
  await QueryAgid();
  if ((function () { return BackendlessUI.isProd })()) {
    console.log('=00= PROD Mode');
    ___arguments.context.appData['srcFilePath'] = (String('https://app.gprsaves.com/api/files/') + String('client-docs/AGR-completed/'));
  } else {
    console.log('=00= TEST Mode');
    ___arguments.context.appData['srcFilePath'] = (String('https://perkycollar.backendless.app/api/files/') + String('client-docs/AGR-completed/'));
  }
  await getLandingPages('2-part Landing');
  await getAgSelect();
  ___arguments.context.appData['srcFileName'] = 'GPR_Savings_Agreement_V3.pdf';
  ___arguments.context.appData['pdfSavedFile'] = (String(getObjectProperty(___arguments.context.appData, 'srcFilePath')) + String(getObjectProperty(___arguments.context.appData, 'srcFileName')));
  ___arguments.context.appData['tgtFilePath'] = 'client-docs/AGR-completed/';
  console.log(String('=00= pdfSavedFile=') + String(getObjectProperty(___arguments.context.appData, 'pdfSavedFile')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/landing00/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list, selectedClient, addr2, clientSearchString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function SetStateRelations() {
  console.log(String('=00= set state relations - DB Updates=') + String((await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]))));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['state'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2'));
}

/**
 * Describe this function...
 */
async function CreateClient() {
  selectedClient = ({ [`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'cmpname')),[`lastname`]: (getObjectProperty(___arguments.context.pageData, 'lastname')),[`firstname`]: (getObjectProperty(___arguments.context.pageData, 'firstname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'addr1')),[`addr2`]: addr2,[`city`]: (getObjectProperty(___arguments.context.pageData, 'city')),[`state`]: undefined,[`zip_postalcode`]: (getObjectProperty(___arguments.context.pageData, 'zip')),[`country`]: 'US',[`phone1`]: (getObjectProperty(___arguments.context.pageData, 'phone')),[`phone2`]: undefined,[`phone3`]: undefined,[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`agentid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')),[`agentemail`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')),[`clientType`]: undefined,[`AgrDocDate`]: undefined,[`AgrDocLink`]: undefined,[`AgrSigDate`]: undefined,[`AgrSigLink`]: undefined,[`isAGRcomplete`]: false,[`isACHcomplete`]: false,[`ACHcompleteDate`]: undefined,[`CSAactive`]: 0,[`CSApending`]: 0,[`isClient`]: false,[`billingmethod`]: undefined,[`accountholdername`]: undefined,[`achrout`]: undefined,[`achacct`]: undefined,[`achauth`]: false,[`ccacct`]: undefined,[`ccexpdt`]: undefined,[`cccvc`]: undefined,[`ccauth`]: false,[`ccfeeauth`]: false,[`zelleid`]: undefined,[`othClientid`]: undefined,[`othPO`]: undefined,[`approvalcode`]: undefined,[`approvaldate`]: undefined });
  ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save( selectedClient ));
  await SetStateRelations();
  await SetAgentRelations();
  await SetClientType();
  console.log(String('=00= selected client=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
}

/**
 * Describe this function...
 */
async function DoesClientExist() {
  clientSearchString = ['state=\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')),'\' AND ','city=\'',(getObjectProperty(___arguments.context.pageData, 'city')),'\'',' AND ','lastname=\'',(getObjectProperty(___arguments.context.pageData, 'lastname')),'\'',' AND ','addr1 LIKE \'',(getObjectProperty(___arguments.context.pageData, 'addr1')),'%\''].join('').toLowerCase();
  list = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause(clientSearchString).setPageSize(100)));
}

/**
 * Describe this function...
 */
async function SetAgentRelations() {
  ___arguments.context.pageData['agent'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'objectId'))]));
}

/**
 * Describe this function...
 */
async function SetClientType() {
  ___arguments.context.pageData['ClientType'] = ((await Backendless.Data.of('ClientType').find(Backendless.DataQueryBuilder.create().setWhereClause('clientTypeId=1').setPageSize(10)))[0]);
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['clientType'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'clientType', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'ClientType')), 'objectId'))]));
}


  if ((typeof (getObjectProperty(___arguments.context.appData, 'selectedState')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'selectedState')) === null)) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter State Value', 'Error!', 'error');
  } else if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')) === 'undefined') || !(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')).length) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter State Value', 'Error!', 'error');
  } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'lastname')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'lastname')).length) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter NAME Value', 'Error!', 'error');
  } else {
    await DoesClientExist();
    if (list.length == 0) {
      console.log('=00= client not found NEW');
      await CreateClient();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('START', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
    } else if (list.length == 1) {
      console.log('=00= client found OLD match');
      ___arguments.context.appData['selectedClient'] = (list[0]);
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('START', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
    } else {
      console.log('=00= multiple clients found OLD match, display modal client list. Wait for user choice');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('079fb8cc8f7c5d8141033a8a21bf2966');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/landing00/components/7f322afd76ee3815eaea3425f68366ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf('(') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace('(', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf(')') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace(')', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf('-') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace('-', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf(' ') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace(' ', ''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/landing00/components/340cc93129e7fdc241fa71f10d3be0fb/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedClient'] = ___arguments.selectedRecord;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('079fb8cc8f7c5d8141033a8a21bf2966');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('START', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onRecordSelect */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var clientSearchString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  clientSearchString = ['state=\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')),'\' AND ','city=\'',(getObjectProperty(___arguments.context.pageData, 'city')),'\'',' AND ','lname=\'',(getObjectProperty(___arguments.context.pageData, 'lastname')),'\'',' AND ','addr1 LIKE \'',(getObjectProperty(___arguments.context.pageData, 'addr1')),'%\''].join('').toLowerCase();
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('340cc93129e7fdc241fa71f10d3be0fb'))['whereClause'] = clientSearchString;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/landing00/components/e67e744f799b47a55b97afd2f58ad752/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;


  console.log(String('Changed Value=') + String(___arguments.value));
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(___arguments.value))).setPageSize(10)))[0];
  console.log(String('Selected Agent=') + String(JSON.stringify(list)));
  ___arguments.context.appData['agent'] = list;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/landing00/components/dd4ff7d6229f7fa39293104ca6b46a49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'AskForAgent')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/landing01/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var pageset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function getTestData() {
  ___arguments.context.appData['selectedClient'] = ((await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause('clientid=829').setPageSize(10)))[0]);
  ___arguments.context.appData['agent'] = ((await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause('agentid=58').setPageSize(10)))[0]);
}


  console.log('=== Entering Landing01 (BILL) ===');
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    ___arguments.context.appData['selectedClient'] = ({ [`clientid`]: undefined,[`clientid-temp`]: (generateUUID().short()),[`cmpname`]: undefined,[`firstname`]: undefined,[`lastname`]: undefined,[`agent`]: ({ [`agentid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))),[`agentemail`]: undefined }),[`objectId`]: undefined });
  }
  ___arguments.context.appData['filesUploadedTotal'] = 0;
  ___arguments.context.appData['selectedCatList'] = [];
  console.log(String('selectedClient=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) === null)) {
    ___arguments.context.pageData['welcomeMessage'] = 'Welcome';
  } else {
    ___arguments.context.pageData['welcomeMessage'] = (['Welcome (',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),') ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name'))].join(''));
  }
  console.log(String('welcomeMessage=') + String(getObjectProperty(___arguments.context.pageData, 'welcomeMessage')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/landing01/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var CSApending;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function SetAgentRelations() {
  console.log('=landing01= set agent relations');
  ___arguments.context.pageData['agent'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'objectId'))]));
  console.log('=landing01= set agent relations END');
}


  console.log('=01= button ONCLICK');
  console.log(String('=01= filesUploadedTotal = ') + String(getObjectProperty(___arguments.context.appData, 'filesUploadedTotal')));
  CSApending = CSApending + (getObjectProperty(___arguments.context.appData, 'filesUploadedTotal'));
  console.log(String('=01= selectedClient B4=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) === null)) {
    console.log('==landing01== add client record');
    ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save( ({ [`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`clientid-temp`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid-temp')),[`CSApending`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending')),[`objectId`]: undefined }) ));
    await SetAgentRelations();
  } else {
    console.log('==landing01== update client record');
    ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save( ({ [`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`clientid-temp`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid-temp')),[`CSApending`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }) ));
    await SetAgentRelations();
  }
  console.log(String('=01= selectedClient AF=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('BILL', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/landing01/components/cc375e4186ce046bbc03be7a1bc99bce/bundle.js', [], () => ({
  /* content */
  /* handler:fileNameLogic */
  async ['fileNameLogic'](___arguments) {
    var adjFileName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setFileName() {
  adjFileName = [(typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) === null) ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid-temp')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),'_',(getObjectProperty(___arguments['file'], 'name'))].join('');
  console.log(String('=01=DZ= adjFilename=') + String(adjFileName));
}


  await setFileName();

  return adjFileName

  },
  /* handler:fileNameLogic */
  /* handler:onUploadFailed */
  async ['onUploadFailed'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('98cdf25e5677d41f7d2e7ef60902e7aa', true, false, undefined, (JSON.stringify((getObjectProperty(___arguments['error'], 'message')))), 'error');

  },
  /* handler:onUploadFailed */
  /* content */
}))

define('./pages/lpAGR/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var srcFileName, srcFilePath, tgtFileName, extFilePath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GeneratePdf() {
  if ((function () { return BackendlessUI.isProd })()) {
    await genPdf();
  } else {
    await genPdf();
  }
}

/**
 * Describe this function...
 */
async function FillVariables() {
  console.log('=AGR= FillVariables ==');
  ___arguments.context.pageData['templateId'] = '1cd77b2346010f7c';
  ___arguments.context.pageData['EffectiveDate'] = ((new Date()).toDateString());
  ___arguments.context.pageData['ClientName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name'));
  ___arguments.context.pageData['ClientAddress'] = ([String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr1')) + String(', '),(typeof (getObjectProperty(___arguments.context.appData, 'addr2')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'addr2')) === null) ? '' : String(getObjectProperty(___arguments.context.appData, 'addr2')) + String(', '),String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'city')) + String(', '),String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'state')) + String(' '),(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zip'))].join(''));
  ___arguments.context.pageData['CompanyName'] = ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')));
  if (typeof (getObjectProperty(___arguments.context.pageData, 'CompanyName')) === 'undefined') {
    ___arguments.context.pageData['NAME01'] = (getObjectProperty(___arguments.context.pageData, 'ClientName'));
  } else {
    ___arguments.context.pageData['NAME01'] = (getObjectProperty(___arguments.context.pageData, 'CompanyName'));
  }
  if (typeof (getObjectProperty(___arguments.context.pageData, 'CompanyName')) === 'undefined') {
    ___arguments.context.pageData['NAME02'] = '';
  } else {
    ___arguments.context.pageData['NAME02'] = (getObjectProperty(___arguments.context.pageData, 'CompanyName'));
  }
  ___arguments.context.pageData['NAME03'] = (getObjectProperty(___arguments.context.pageData, 'ClientName'));
  ___arguments.context.pageData['signature'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigLink'));
  ___arguments.context.appData['tgtFileName'] = (String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) + String('_AGR_document.pdf'));
  ___arguments.context.pageData['pdfFileName'] = (getObjectProperty(___arguments.context.appData, 'tgtFileName'));
  console.log('=AGR= END FillVariables ==');
}

/**
 * Describe this function...
 */
async function genPdf() {
  console.log('=AGR= genPdf ==');
  ___arguments.context.pageData['pdfReturnedURL'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CraftMyPDF/generate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`templateId`]: (getObjectProperty(___arguments.context.pageData, 'templateId')),[`data`]: ({ [`ClientAddress`]: (getObjectProperty(___arguments.context.pageData, 'ClientAddress')),[`EffectiveDate`]: (getObjectProperty(___arguments.context.pageData, 'EffectiveDate')),[`NAME01`]: (getObjectProperty(___arguments.context.pageData, 'NAME01')),[`NAME02`]: (getObjectProperty(___arguments.context.pageData, 'NAME02')),[`NAME03`]: (getObjectProperty(___arguments.context.pageData, 'NAME03')),[`Signature`]: (getObjectProperty(___arguments.context.pageData, 'signature')) }),[`outputFile`]: (getObjectProperty(___arguments.context.pageData, 'pdfFileName')),[`isCmyk`]: false,[`imageResampleRes`]: 0 }))));
  console.log(String('=AGR= genPDF returned URL = ') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pdfReturnedURL')))));
}

/**
 * Describe this function...
 */
async function ProcessFilename() {
  console.log('=AGR= ProcessFilename ==');
  extFilePath = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'pdfReturnedURL')), 'fileUrl'));
  ___arguments.context.pageData['pdfSavedFile'] = extFilePath;
  console.log(String('=AGR= pdfSavedFile = ') + String(getObjectProperty(___arguments.context.pageData, 'pdfSavedFile')));
  ___arguments.context.pageData['pdfExists'] = true;
}


  console.log('=AGR= btnNext Click');
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigDate')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigDate')) === null)) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('dae93722c3a458f46a8ca81e15fd470d', true, undefined, undefined, 'Please supply a signature before proceeding!', 'error');
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigDate'] = null;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigLink'] = null;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isAGRcomplete'] = false;
  } else {
    console.log('=AGR= SIG exists. Gen the PDF');
    await FillVariables();
    await GeneratePdf();
    await ProcessFilename();
    console.log('=AGR= save AGR detail in DB');
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isAGRcomplete'] = true;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrDocDate'] = ((new Date()).valueOf());
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrDocLink'] = (getObjectProperty(___arguments.context.pageData, 'pdfSavedFile'));
    ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`isAGRcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isAGRcomplete')),[`AgrDocDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocDate')),[`AgrDocLink`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')),[`AgrSigDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigDate')),[`AgrSigLink`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigLink')) }), true));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('AGR', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/lpAGR/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getClientData() {
  console.log('=AGR=getclientdata START');
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'objid')) === 'undefined')) {
    for (var count = 0; count < 3; count++) {
      try {
        list = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause((['objid=\'',(getObjectProperty(___arguments.context.pageData, 'objid')),'\''].join(''))).setPageSize(10)))[0];
        ___arguments.context.appData['selectedClient'] = list;
        console.log(String('=AGR= selectedClient=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
        console.log('=AGR=getclientdata END');
        break;

      } catch (error) {
        console.log(String('=AGR getclientdata= Error=') + String(error));

      }
    }
  }
}


  console.log('=AGR=');
  await getClientData();
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('landing00', ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
  } else {
    if ((function () { return BackendlessUI.isProd })()) {
      console.log('=AGR= PROD Mode');
      ___arguments.context.appData['srcFilePath'] = (String('https://app.gprsaves.com/api/files/') + String('client-docs/AGR-completed/'));
    } else {
      console.log('=AGR= TEST Mode');
      ___arguments.context.appData['srcFilePath'] = (String('https://perkycollar.backendless.app/api/files/') + String('client-docs/AGR-completed/'));
    }
    ___arguments.context.appData['srcFileName'] = 'GPR_Savings_Agreement_V4.pdf';
    ___arguments.context.appData['pdfSavedFile'] = (String(getObjectProperty(___arguments.context.appData, 'srcFilePath')) + String(getObjectProperty(___arguments.context.appData, 'srcFileName')));
    ___arguments.context.appData['tgtFilePath'] = 'client-docs/AGR-completed/';
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lpAGR/components/6bd7e4628352366c8ab3a1d8f5b39a7d/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function AGR_SigSave() {
  console.log('=AGR= Sig Save');
  console.log(String('=AGR= tgtFilePath = ') + String(getObjectProperty(___arguments.context.appData, 'tgtFilePath')));
  ___arguments.context.pageData['sigFilePath'] = (getObjectProperty(___arguments.context.appData, 'tgtFilePath'));
  console.log(String('=AGR= sigFilePath = ') + String(getObjectProperty(___arguments.context.pageData, 'sigFilePath')));
  ___arguments.context.pageData['sigFileName'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),'_AGR_','sig.png'].join(''));
  console.log(String('=AGR= sigFileName = ') + String(getObjectProperty(___arguments.context.pageData, 'sigFileName')));
  ___arguments.context.pageData['sigFileURL'] = (await Backendless.Files.saveFile(encodePath((getObjectProperty(___arguments.context.pageData, 'sigFilePath'))), (getObjectProperty(___arguments.context.pageData, 'sigFileName')), ___arguments['signature'], true));
  console.log(String('=AGR= Sig has been saved - ') + String(getObjectProperty(___arguments.context.pageData, 'sigFileURL')));
  if (typeof (getObjectProperty(___arguments.context.pageData, 'sigFileURL')) === 'undefined') {
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigDate'] = null;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigLink'] = null;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('dae93722c3a458f46a8ca81e15fd470d', true, undefined, undefined, 'Please supply a signature before proceeding!', 'error');
  } else {
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigDate'] = ((new Date()).valueOf());
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigLink'] = (getObjectProperty(___arguments.context.pageData, 'sigFileURL'));
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('dae93722c3a458f46a8ca81e15fd470d', true, undefined, undefined, 'Signature has been saved!', 'info');
  }
}


  await AGR_SigSave();

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/lpAGR/components/eae5bb6b89f41e22a3e53ea29bf1a649/bundle.js', [], () => ({
  /* content */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'pdfSavedFile'))

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/lpAGR/components/c22bf028cd1ead893681dbe38e96618a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    await new Promise(r => setTimeout(r, 1500 || 0));
  }
  console.log(['=10 txClientname= name=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')),'  cmpname=',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname'))].join(''));

  return ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === null) ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) : [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/lpAGR/components/93e9625ed99fe87573c7e78b474bbad7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    await new Promise(r => setTimeout(r, 1500 || 0));
  }

  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/lpBILL/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var pageset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getLandingPages(pageset) {
  ___arguments.context.appData['pages'] = ((await Backendless.Data.of('LandingPages').find(Backendless.DataQueryBuilder.create().setWhereClause((['pageset=\'',pageset,'\''].join(''))).setPageSize(10)))[0]);
}


  console.log('=== Entering lpBILL ===');
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    console.log('== invalid data - reverting back to START ==');
    await getLandingPages('2-part Landing');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e'](null, 'START', (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
  } else {
    ___arguments.context.appData['filesUploadedTotal'] = 0;
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lpBILL/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var CSApending, cpr_FileName, cpr_FilePath, EmailTmplName, cpr_PostResponse, cpr_doc_uid, cpr_doc, achcompleteDate, approvalDate, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ClientProfileRpt() {
  console.log('=01= ClientProfileRpt');
  cpr_FilePath = 'client-docs/AGR-completed/';
  cpr_FileName = [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),'_','ClientProfileRpt.docx'].join('');
  await docGenerate();
  console.log('=01= END ClientProfileRpt');
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function checkEmailSend() {
  EmailTmplName = 'Client_TY_Reg';
  if (getValueLength(EmailTmplName) > 0) {
    console.log(String('=01= Email Template chosen = ') + String(EmailTmplName));
    await SendEmailToClient();
    await SendEmailToGPR();
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function docGenerate() {
  console.log('=01= docGenerate');
  console.log(String('=01= selectedClient=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
  approvalDate = (new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate'))));
  console.log(String('=01= approvalDate=') + String(approvalDate));
  achcompleteDate = (new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate'))));
  cpr_doc = (await Backendless.Request.get(`${Backendless.appPath}/services/DocsGenerator/documents`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'templateUid': JSON.stringify('bf5129ec3d2b4f25bcc09600f0366206'),'createPdf': false,'AGRstatus': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isAGRcomplete')) == true ? 'ON FILE' : 'MISSING')),'ACHstatus': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')) == true ? 'ON FILE' : 'MISSING')),'CSApending': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'))),'CSAcomplete': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSAactive'))),'onboardingDate': JSON.stringify(approvalDate),'clientid': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid'))),'agentid': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid'))),'agentname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'name'))),'cmpname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname'))),'firstname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'firstname'))),'lastname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'lastname'))),'addr1': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr1'))),'addr2': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr2'))),'city': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'city'))),'state': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'state'))),'zip': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zip_postalcode'))),'phone1': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'phone'))),'phone2': JSON.stringify(''),'email': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'email'))),'savingssplit': JSON.stringify('50%'),'AGRsignature': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigLink'))),'billingmethod': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? 'ACH-Bank Draft' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? 'Credit/Debit' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? 'Zelle' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'O' ? 'Other' : 'METHOD NOT SPECIFIED'))))),'financialinstitution': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 3 ? 'American Express' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 4 ? 'Visa' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 5 ? 'MasterCard' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 6 ? 'Discover' : 'CC-Other')))) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? 'BANK' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? 'Zelle-Bank' : 'Invoice/PO/Other')))),'accountnumber': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? String('xxxx-xxxx-xxxx-') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')), 3)) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? String('xxxxxxx-') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct')), 3)) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zelleid')) : 'N/A')))),'dateofupdate': JSON.stringify(achcompleteDate),'docPending': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'))),'outputFilePath': JSON.stringify(cpr_FilePath),'outputFileName': JSON.stringify(cpr_FileName) }).send());
  console.log(String('cpr_doc=') + String(cpr_doc));
  console.log('=01= END docGenerate = ');
}

/**
 * Describe this function...
 */
async function SendEmailToClient() {
  console.log('=01= Send Email To Client');
  for (var count = 0; count < 3; count++) {
    try {
      console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'email'))], ccAddresses: undefined, bccAddresses: ['support@eigercreative.com'], query: '', uniqueEmails: false }), ({ [`clientname`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) }), undefined)));
      console.log('=01= Email Sent to Client');
      break;

    } catch (error) {

    }
  }
}

/**
 * Describe this function...
 */
async function SendEmailToGPR() {
  console.log('=01= Send Email To GPR');
  for (var count2 = 0; count2 < 3; count2++) {
    try {
      console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: ['info@gprsaves.com'], ccAddresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')), 'jacqui@grouppurchasingresources.com', 'sean@grouppurchasingresources.com'], bccAddresses: ['support@eigercreative.com'], query: '', uniqueEmails: false }), ({ [`clientname`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) }), [String(cpr_FilePath) + String(cpr_FileName)])));
      console.log('=01= Email Sent to GPR');
      break;

    } catch (error) {

    }
  }
}


  console.log('=BILL= check filesUploaded');
  CSApending = 0;
  CSApending = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'));
  console.log(['=BILL= filesUploadedTotal = ',(getObjectProperty(___arguments.context.appData, 'filesUploadedTotal')),'  =BILL= CSApending=',CSApending].join(''));
  CSApending = CSApending + (getObjectProperty(___arguments.context.appData, 'filesUploadedTotal'));
  console.log(String('=BILL= Updated CSApending=') + String(CSApending));
  ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`CSApending`]: CSApending }), true));
  await ClientProfileRpt();
  await checkEmailSend();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('BILL', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/lpBILL/components/2e7bef254da17121276c93fbb93505d7/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFailed */
  ['onUploadFailed'](___arguments) {
      console.log(String('=02DZ= File Upload Failed =') + String(___arguments['error']));

  },
  /* handler:onUploadFailed */
  /* handler:fileNameLogic */
  async ['fileNameLogic'](___arguments) {
    var adjFileName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setFileName() {
  console.log(String('=01DZ= FN Orig FIle=') + String(getObjectProperty(___arguments['file'], 'name')));
  adjFileName = [(typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'selectedClient')) === null) ? 'XXX' : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),'_',(getObjectProperty(___arguments['file'], 'name'))].join('');
  console.log(String('=01DZ= adjFileName=') + String(adjFileName));
  return adjFileName
}



  return (await setFileName())

  },
  /* handler:fileNameLogic */
  /* content */
}))

define('./pages/lpBILL/components/dcccba95bad6ec676ddb6e341aa72af5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var reqsList;


  reqsList = (await Backendless.Data.of('vwVendReqs').find(Backendless.DataQueryBuilder.create().setPageSize(10)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dcccba95bad6ec676ddb6e341aa72af5', reqsList);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/lpCALC/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  console.log('=== Entering lpCALC ===');
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    console.log('=02= selectedClient is missing');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('START', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
  } else {
    ___arguments.context.pageData['CalcTimerSw'] = true;

    ;(function() {
      const callback = async () => {
          ___arguments.context.pageData['CalcTimerSw'] = false;

      };

      const timerId = 'CalcTimer';
      const timerDelay = 20000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lpCALC/components/4289e709819b44ac6f1c0494d6192f04/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'CalcTimerSw')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/lpCALC/components/4c5f97c39451bebcce7c96dca5b16772/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('CALC', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/lpCONT/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var agSelect, agid, pageset, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function queryAgid() {
  console.log('=00=STARTqueryAgid');
  if (!(typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined')) {
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')));
    console.log(String('=00=QueryAgid=') + String(getObjectProperty(___arguments.context.pageData, 'agid')));
  } else if (typeof ___arguments.context.pageData === 'undefined') {
    console.log('=00=QueryAgent= 2');
    await setAgid('1');
    await getAgent();
  } else if (!(typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined')) {
    console.log('=00=QueryAgent= 3');
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')));
    await getAgent();
  } else {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'agid')) === 'undefined') {
      console.log('=00=QueryAgent= 4a');
      await setAgid('1');
    } else {
      console.log('=00=QueryAgent= 4b');
      await setAgid((getObjectProperty(___arguments.context.pageData, 'agid')));
    }
    await getAgent();
  }
  console.log('=00=END queryAgid');
}

/**
 * Describe this function...
 */
async function getAgSelect() {
  agSelect = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('active=') + String(true))).setProperties('name as label, agentid as value').setSortBy('name').setPageSize(100)));
  ___arguments.context.pageData['agSelect'] = agSelect;
}

/**
 * Describe this function...
 */
async function setAgid(agid) {
  console.log('=00=START setAgid ');
  if (agid > 1) {
    ___arguments.context.pageData['AskForAgent'] = false;
  } else {
    ___arguments.context.pageData['AskForAgent'] = true;
  }
  ___arguments.context.pageData['agid'] = agid;
  console.log('=00=END setAgid ');
}

/**
 * Describe this function...
 */
async function getAgent() {
  console.log(String('=00=START getAgent= agid =') + String(getObjectProperty(___arguments.context.pageData, 'agid')));
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((['agentid=\'',(getObjectProperty(___arguments.context.pageData, 'agid')),'\''].join(''))).setPageSize(100)));
  ___arguments.context.appData['agent'] = (list[0]);
  console.log(String('=00=END getAgent= agent=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'agent')))));
}

/**
 * Describe this function...
 */
async function getLandingPages(pageset) {
  ___arguments.context.appData['pages'] = ((await Backendless.Data.of('LandingPages').find(Backendless.DataQueryBuilder.create().setWhereClause((['pageset=\'',pageset,'\''].join(''))).setPageSize(10)))[0]);
}


  console.log('=== ENTER lpCONT ===');
  if ((function () { return BackendlessUI.isProd })()) {
    console.log('=00= PROD Mode');
    ___arguments.context.appData['srcFilePath'] = (String('https://app.gprsaves.com/api/files/') + String('client-docs/AGR-completed/'));
  } else {
    console.log('=00= TEST Mode');
    ___arguments.context.appData['srcFilePath'] = (String('https://perkycollar.backendless.app/api/files/') + String('client-docs/AGR-completed/'));
  }
  if (typeof (getObjectProperty(___arguments.context.appData, 'pages')) === 'undefined') {
    await getLandingPages('Savings Calculator');
  }
  await queryAgid();
  await getAgSelect();
  ___arguments.context.appData['srcFileName'] = 'GPR_Savings_Agreement_V3.pdf';
  ___arguments.context.appData['pdfSavedFile'] = (String(getObjectProperty(___arguments.context.appData, 'srcFilePath')) + String(getObjectProperty(___arguments.context.appData, 'srcFileName')));
  ___arguments.context.appData['tgtFilePath'] = 'client-docs/AGR-completed/';
  console.log(String('=lpCONT= pdfSavedFile=') + String(getObjectProperty(___arguments.context.appData, 'pdfSavedFile')));
  console.log(String('=lpCONT= pages=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'pages')))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lpCONT/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list, selectedClient, addr2, clientSearchString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function SetStateRelations() {
  console.log('=lpCONT= set state relations');
  console.log(String('APP SelectedState=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedState')))));
  console.log(String('=lpCONT= set state relations - DB Updates=') + String((await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]))));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['state'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2'));
  console.log('=lpCONT= set state relations END');
}

/**
 * Describe this function...
 */
async function CreateClient() {
  console.log('=lpCONT= CREATE CLIENT NEW');
  selectedClient = ({ [`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'cmpname')),[`lastname`]: (getObjectProperty(___arguments.context.pageData, 'lastname')),[`firstname`]: (getObjectProperty(___arguments.context.pageData, 'firstname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'addr1')),[`addr2`]: addr2,[`city`]: (getObjectProperty(___arguments.context.pageData, 'city')),[`state`]: undefined,[`zip_postalcode`]: (getObjectProperty(___arguments.context.pageData, 'zip')),[`country`]: 'US',[`phone1`]: (getObjectProperty(___arguments.context.pageData, 'phone')),[`phone2`]: undefined,[`phone3`]: undefined,[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`agentid`]: undefined,[`agentemail`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')),[`clientType`]: undefined,[`AgrDocDate`]: undefined,[`AgrDocLink`]: undefined,[`AgrSigDate`]: undefined,[`AgrSigLink`]: undefined,[`isAGRcomplete`]: false,[`isACHcomplete`]: false,[`ACHcompleteDate`]: undefined,[`CSAactive`]: 0,[`CSApending`]: 0,[`isClient`]: false,[`billingmethod`]: undefined,[`accountholdername`]: undefined,[`achrout`]: undefined,[`achacct`]: undefined,[`achauth`]: false,[`ccacct`]: undefined,[`ccexpdt`]: undefined,[`cccvc`]: undefined,[`ccauth`]: false,[`ccfeeauth`]: false,[`zelleid`]: undefined,[`othClientid`]: undefined,[`othPO`]: undefined,[`approvalcode`]: undefined,[`approvaldate`]: undefined });
  ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save( selectedClient ));
  await SetStateRelations();
  await SetAgentRelations();
  await SetClientType();
  console.log(String('=00= selected client=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
  console.log('=lpCONT= CREATE CLIENT NEW END');
}

/**
 * Describe this function...
 */
async function DoesClientExist() {
  clientSearchString = ['state=\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')),'\' AND ','city=\'',(getObjectProperty(___arguments.context.pageData, 'city')),'\'',' AND ','lastname=\'',(getObjectProperty(___arguments.context.pageData, 'lastname')),'\'',' AND ','addr1 LIKE \'',(getObjectProperty(___arguments.context.pageData, 'addr1')),'%\''].join('').toLowerCase();
  list = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause(clientSearchString).setPageSize(100)));
}

/**
 * Describe this function...
 */
async function SetAgentRelations() {
  console.log('=lpCONT= set agent relations');
  ___arguments.context.pageData['agent'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'objectId'))]));
  console.log('=lpCONT= set agent relations END');
}

/**
 * Describe this function...
 */
async function SetClientType() {
  ___arguments.context.pageData['ClientType'] = ((await Backendless.Data.of('ClientType').find(Backendless.DataQueryBuilder.create().setWhereClause('clientTypeId=1').setPageSize(10)))[0]);
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['clientType'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'clientType', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'ClientType')), 'objectId'))]));
}


  console.log('=lpCONT= Next BTN Click');
  if ((typeof (getObjectProperty(___arguments.context.appData, 'selectedState')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'selectedState')) === null)) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter State Value', 'Error!', 'error');
  } else if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')) === 'undefined') || !(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')).length) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter State Value', 'Error!', 'error');
  } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'lastname')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'lastname')).length) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter NAME Value', 'Error!', 'error');
  } else {
    await DoesClientExist();
    console.log(String('=lpCONT= client exists  0=New else Exists Result=') + String(list.length));
    if (list.length == 0) {
      console.log('=lpCONT= client not found NEW');
      await CreateClient();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('CONT', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
    } else if (list.length == 1) {
      console.log('=lpCONT= client found OLD match');
      ___arguments.context.appData['selectedClient'] = (list[0]);
      console.log(String('=lpCONT= selected client=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
      console.log(String('=lpCONT= pages=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'pages')))));
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('CONT', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
    } else {
      console.log('=lpCONT= multiple clients found OLD match, display modal client list. Wait for user choice');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('079fb8cc8f7c5d8141033a8a21bf2966');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/lpCONT/components/7f322afd76ee3815eaea3425f68366ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf('(') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace('(', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf(')') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace(')', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf('-') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace('-', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf(' ') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace(' ', ''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/lpCONT/components/340cc93129e7fdc241fa71f10d3be0fb/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var selectedClientid, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedClient'] = ___arguments.selectedRecord;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('079fb8cc8f7c5d8141033a8a21bf2966');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('CONT', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onRecordSelect */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var clientSearchString, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  clientSearchString = ['state=\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')),'\' AND ','city=\'',(getObjectProperty(___arguments.context.pageData, 'city')),'\'',' AND ','lastname=\'',(getObjectProperty(___arguments.context.pageData, 'lastname')),'\'',' AND ','addr1 LIKE \'',(getObjectProperty(___arguments.context.pageData, 'addr1')),'%\''].join('').toLowerCase();
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('340cc93129e7fdc241fa71f10d3be0fb'))['whereClause'] = clientSearchString;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/lpCONT/components/e67e744f799b47a55b97afd2f58ad752/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;


  console.log(String('Changed Value=') + String(___arguments.value));
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(___arguments.value))).setPageSize(10)))[0];
  console.log(String('Selected Agent=') + String(JSON.stringify(list)));
  ___arguments.context.appData['agent'] = list;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/lpCONT/components/dd4ff7d6229f7fa39293104ca6b46a49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'AskForAgent')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/lpFIN/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var cpr_FileName, cpr_FilePath, EmailTmplName, clientobj, cpr_PostResponse, cpr_doc_uid, cpr_doc, achcompleteDate, approvalDate, error, isOKstatusOTH, isOKstatusACH, isOKstatusCC;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ClientProfileRpt() {
  console.log('=01= ClientProfileRpt');
  cpr_FilePath = 'client-docs/AGR-completed/';
  cpr_FileName = [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),'_','ClientProfileRpt.docx'].join('');
  await docGenerate();
  console.log('=01= END ClientProfileRpt');
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function checkEmailSend() {
  console.log(String('=01= ChkEmail = pages= ') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'pages')))));
  console.log(String('=01= ChkEmail = selectedClient= ') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
  EmailTmplName = 'Client_TY_CSA';
  if (getValueLength(EmailTmplName) > 0) {
    console.log(String('=01= Email Template chosen = ') + String(EmailTmplName));
    await SendEmailToClient();
    await SendEmailToGPR();
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function docGenerate() {
  console.log('=01= docGenerate');
  console.log(String('=01= selectedClient=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
  approvalDate = (new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate'))));
  console.log(String('=01= approvalDate=') + String(approvalDate));
  achcompleteDate = (new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate'))));
  cpr_doc = (await Backendless.Request.get(`${Backendless.appPath}/services/DocsGenerator/documents`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'templateUid': JSON.stringify('bf5129ec3d2b4f25bcc09600f0366206'),'createPdf': false,'AGRstatus': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isAGRcomplete')) == true ? 'ON FILE' : 'MISSING')),'ACHstatus': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')) == true ? 'ON FILE' : 'MISSING')),'CSApending': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'))),'CSAcomplete': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSAactive'))),'onboardingDate': JSON.stringify(approvalDate),'clientid': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid'))),'agentid': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid'))),'agentname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'name'))),'cmpname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname'))),'firstname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'firstname'))),'lastname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'lastname'))),'addr1': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr1'))),'addr2': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr2'))),'city': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'city'))),'state': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'state'))),'zip': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zip_postalcode'))),'phone1': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'phone'))),'phone2': JSON.stringify(''),'email': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'email'))),'savingssplit': JSON.stringify('50%'),'AGRdocument': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink'))),'AGRsignature': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigLink'))),'billingmethod': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? 'ACH-Bank Draft' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? 'Credit/Debit' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? 'Zelle' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'O' ? 'Other' : 'METHOD NOT SPECIFIED'))))),'financialinstitution': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 3 ? 'American Express' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 4 ? 'Visa' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 5 ? 'MasterCard' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 6 ? 'Discover' : 'CC-Other')))) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? 'BANK' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? 'Zelle-Bank' : 'Invoice/PO/Other')))),'accountnumber': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? String('xxxx-xxxx-xxxx-') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')), 3)) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? String('xxxxxxx-') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct')), 3)) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zelleid')) : 'N/A')))),'dateofupdate': JSON.stringify(achcompleteDate),'docPending': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'))),'docNames': JSON.stringify((JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedCatList'))))),'outputFilePath': JSON.stringify(cpr_FilePath),'outputFileName': JSON.stringify(cpr_FileName) }).send());
  console.log(String('cpr_doc=') + String(cpr_doc));
  console.log('=01= END docGenerate = ');
}

/**
 * Describe this function...
 */
async function OnclickACH() {
  console.log('=11= OnClickACH ');
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'achAccountholderName'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['achrout'] = (getObjectProperty(___arguments.context.pageData, 'achRout'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['achacct'] = (getObjectProperty(___arguments.context.pageData, 'achAcct'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['achauth'] = (getObjectProperty(___arguments.context.pageData, 'achAuth'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ACHcompleteDate'] = (new Date());
  clientobj = ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername')),[`achrout`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achrout')),[`achacct`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct')),[`achauth`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvalcode')),[`iaACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate')) });
  await ClientUpdate();
  console.log('=11= OnClickACH END');
}

/**
 * Describe this function...
 */
async function OnclickCC() {
  console.log('=11= OnClickCC');
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'cardholderName'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccacct'] = (getObjectProperty(___arguments.context.pageData, 'cardNumber'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccexpdt'] = (getObjectProperty(___arguments.context.pageData, 'expiry'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['cccvc'] = (getObjectProperty(___arguments.context.pageData, 'cvc'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccauth'] = (getObjectProperty(___arguments.context.pageData, 'ccAuth'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccfeeauth'] = (getObjectProperty(___arguments.context.pageData, 'ccFeeAuth'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ACHcompleteDate'] = (new Date());
  clientobj = ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername')),[`ccacct`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')),[`ccexpdt`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccexpdt')),[`cccvc`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cccvc')),[`ccauth`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccauth')),[`ccfeeauth`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccfeeauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate')) });
  await ClientUpdate();
  console.log('=11= OnClickCC END');
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function SendEmailToClient() {
  console.log('=11= send email to client');
  for (var count = 0; count < 3; count++) {
    try {
      if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')) === null)) {
        console.log('AgrDocLink is null');
        console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'email'))], ccAddresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentemail'))], bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`clientname`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) }), undefined)));
        break;
      } else {
        console.log('AgrDocLink exists');
        console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'email'))], ccAddresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentemail'))], bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`clientname`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) }), [String('/client-docs/AGR-completed/') + String(subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')), (((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')).lastIndexOf('/') + 1 + 1) - 1)))])));
        break;
      }

    } catch (error) {

    }
  }
}

/**
 * Describe this function...
 */
async function OnclickOTH() {
  console.log('=11= OnClickOTH');
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['othClientid'] = (getObjectProperty(___arguments.context.pageData, 'othClientid'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['othPO'] = (getObjectProperty(___arguments.context.pageData, 'othPOnumber'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ACHcompleteDate'] = (new Date());
  console.log(String('=11= isACHcomplete=') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')));
  clientobj = ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')),[`othClientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'othClientid')),[`othPO`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'othPO')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvalcode')),[`iaACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate')) });
  await ClientUpdate();
  console.log('=11= OnClickOTH END');
}

/**
 * Describe this function...
 */
async function ClientUpdate() {
  console.log(String('=ClientUpdate= clientobj received=') + String(JSON.stringify(clientobj)));
  ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save(clientobj, true));
  console.log(String('=ClientUpdate= selectedClient=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
}

/**
 * Describe this function...
 */
async function statusOTH() {
  console.log('=11= statusOTH');
  isOKstatusOTH = true;
  console.log('=11= statusOTH END');
  return isOKstatusOTH
}

/**
 * Describe this function...
 */
async function statusACH() {
  console.log('=11= statusACH');
  isOKstatusACH = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'achRout')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Routing Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb444cf6af2d5f1a75cfbf08a5d9eb0d')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achAcct')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Account Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf51883665d86cab373e7eea3a660b73')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achAuth')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'ACH Billing Authority must be granted to proceed.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c27f99ad092f90af22b7632d3d39f443')));
  }
  console.log('=11= statusACH END');
  return isOKstatusACH
}

/**
 * Describe this function...
 */
async function statusCC() {
  console.log('=11= statusCC');
  console.log(String('PD=') + String(JSON.stringify(___arguments.context.pageData)));
  isOKstatusCC = true;
  if ((typeof (getObjectProperty(___arguments.context.pageData, 'cardNumber')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'cardNumber')) === null)) {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Card Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dbc8fad92129355584d3e0e140d6a6d2')));
  } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'cardholderName')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'cardholderName')) === null)) {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Cardholder Name missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dbc8fad92129355584d3e0e140d6a6d2')));
  } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'expiry')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'expiry')) === null)) {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'CC Expire Date missing or invalid', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dbc8fad92129355584d3e0e140d6a6d2')));
  } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'cvc')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'cvc')) === null)) {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'CVC Number missing or invalid.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dbc8fad92129355584d3e0e140d6a6d2')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccAuth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'You must authorize charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6834de540c1d9a2e96d50397dbe865c')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccFeeAuth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'You must authorize the CC Fee charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0f981c1ff9c747bc4bb75d2f839ba4c')));
  }
  console.log('=11= statusCC END');
  return isOKstatusCC
}

/**
 * Describe this function...
 */
async function SendEmailToGPR() {
  console.log('=11= send email to GPR');
  for (var count2 = 0; count2 < 3; count2++) {
    try {
      if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')) === null)) {
        console.log('AgrDocLink is null');
        console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: ['rmunger@eigercreative.com'], ccAddresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentemail')), 'support@eigercreative.com'], bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`clientname`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) }), undefined)));
        break;
      } else {
        console.log('AgrDocLink exists');
        console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: ['rmunger@eigercreative.com'], ccAddresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentemail')), 'support@eigercreative.com'], bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`clientname`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) }), [String('/client-docs/AGR-completed/') + String(subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')), (((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')).lastIndexOf('/') + 1 + 1) - 1)))])));
        break;
      }

    } catch (error) {

    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'A') {
    if (await statusACH()) {
      await OnclickACH();
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'C') {
    if (await statusCC()) {
      await OnclickCC();
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'O') {
    if (await statusOTH()) {
      await OnclickOTH();
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'P') {
    if (await statusOTH()) {
      await OnclickOTH();
    }
  }
  await ClientProfileRpt();
  await checkEmailSend();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('FIN', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/lpFIN/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var ccexpdt, pageset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function BillingInfoYES() {
  console.log('=11= BillingInfoYES');
  ___arguments.context.pageData['showBillingInfo'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f796d00648693694d3b7edf49ce2ac3f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', false);
  ___arguments.context.pageData['BillingMethod'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod'));
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A') {
    ___arguments.context.pageData['achRout'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achrout'));
    ___arguments.context.pageData['achAcct'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct'));
    ___arguments.context.pageData['achAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achauth'));
    ___arguments.context.pageData['achAccount'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername'));
  } else {
    ___arguments.context.pageData['cardNumber'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct'));
    ___arguments.context.pageData['expiry'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccexpdt'));
    ___arguments.context.pageData['cvc'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cccvc'));
    ___arguments.context.pageData['cardholderName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername'));
  }
}

/**
 * Describe this function...
 */
async function BillingInfoNO() {
  console.log('=11= BillingInfoNO');
  ___arguments.context.pageData['showBillingInfo'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f796d00648693694d3b7edf49ce2ac3f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', true);
  ___arguments.context.pageData['BillingMethod'] = 'A';
}

/**
 * Describe this function...
 */
async function getTestData() {
  ___arguments.context.appData['selectedClient'] = ((await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause('clientid=682').setPageSize(10)))[0]);
  ___arguments.context.appData['agent'] = ((await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause('agentid=5').setPageSize(10)))[0]);
}

/**
 * Describe this function...
 */
async function CheckCC() {
}

/**
 * Describe this function...
 */
async function getLandingPages(pageset) {
  ___arguments.context.appData['pages'] = ((await Backendless.Data.of('LandingPages').find(Backendless.DataQueryBuilder.create().setWhereClause((['pageset=\'',pageset,'\''].join(''))).setPageSize(10)))[0]);
}


  console.log('=FIN= Enter');
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('landing00', ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
  } else {
    console.log(String('=11= clientid=') + String(Number((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')))));
    if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) === 'undefined') || (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == null) {
      await BillingInfoNO();
    } else {
      await BillingInfoYES();
    }
    await CheckCC();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', true);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lpFIN/components/707c031c6c21d72d9a4ee0169e0f1432/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['BillingMethod'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/lpFIN/components/d3c5947539daf58a6591872b73bae486/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'A' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/lpFIN/components/0e2c1d2a153ee95a2b171e6ec9d766e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'C' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/lpFIN/components/dbc8fad92129355584d3e0e140d6a6d2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateNumber() })('dbc8fad92129355584d3e0e140d6a6d2')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateExpiry() })('dbc8fad92129355584d3e0e140d6a6d2')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateCVC() })('dbc8fad92129355584d3e0e140d6a6d2')) == false) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onSubmit */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('Card Details(blur)=') + String(JSON.stringify(___arguments['formData'])));
  ___arguments.context.pageData['cardNumber'] = (getObjectProperty(___arguments['formData'], 'cardNumber'));
  ___arguments.context.pageData['cardholderName'] = (getObjectProperty(___arguments['formData'], 'cardholderName'));
  ___arguments.context.pageData['expiry'] = (getObjectProperty(___arguments['formData'], 'expiry'));
  ___arguments.context.pageData['cvc'] = (getObjectProperty(___arguments['formData'], 'cvc'));

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/lpFIN/components/6939e51870a1ba5c07464e0cbf29ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BillingChanges'] = ___arguments.checkedValue;
  if (___arguments.checkedValue == 'Y') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', true);
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A') {
      ___arguments.context.pageData['achRout'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achrout'));
      ___arguments.context.pageData['achAcct'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct'));
      ___arguments.context.pageData['achAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achauth'));
      ___arguments.context.pageData['achAccountholderName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername'));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C') {
      ___arguments.context.pageData['Credit Card-873d'] = ({ [`cardNumber`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')),[`expiry`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccexpdt')),[`cvc`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cccvc')),[`cardholderName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername')) });
      ___arguments.context.pageData['ccAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccauth'));
      ___arguments.context.pageData['ccFeeAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccfeeauth'));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'O') {
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z') {
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', false);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('lpEND', undefined);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/lpFIN/components/c48d304e2b639d21ed14d778508e0432/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'O' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/lpSave/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var pageset, agid, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function QueryAgid() {
  if (!(typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined')) {
    console.log('=00=QueryAgent= 1');
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')));
  } else if (typeof ___arguments.context.pageData === 'undefined') {
    console.log('=00=QueryAgent= 2');
    await setAgid('1');
  } else if (!(typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined')) {
    console.log('=00=QueryAgent= 3');
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')));
  } else {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'agid')) === 'undefined') {
      console.log('=00=QueryAgent= 4a');
      await setAgid('1');
    } else {
      console.log('=00=QueryAgent= 4b');
      await setAgid((getObjectProperty(___arguments.context.pageData, 'agid')));
    }
  }
  await getAgent();
}

/**
 * Describe this function...
 */
async function getLandingPages(pageset) {
  ___arguments.context.appData['pages'] = ((await Backendless.Data.of('LandingPages').find(Backendless.DataQueryBuilder.create().setWhereClause((['pageset=\'',pageset,'\''].join(''))).setPageSize(10)))[0]);
  console.log(String('pages=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'pages')))));
}

/**
 * Describe this function...
 */
async function setAgid(agid) {
  if (agid > 1) {
    ___arguments.context.pageData['AskForAgent'] = false;
  } else {
    ___arguments.context.pageData['AskForAgent'] = true;
  }
  ___arguments.context.pageData['agid'] = agid;
}

/**
 * Describe this function...
 */
async function getAgent() {
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((['agentid=\'',(getObjectProperty(___arguments.context.pageData, 'agid')),'\''].join(''))).setPageSize(100)));
  ___arguments.context.appData['agent'] = (list[0]);
}


  if ((function () { return BackendlessUI.isProd })()) {
    console.log('=00= PROD Mode');
    ___arguments.context.appData['srcFilePath'] = (String('https://app.gprsaves.com/api/files/') + String('client-docs/AGR-completed/'));
  } else {
    console.log('=00= TEST Mode');
    ___arguments.context.appData['srcFilePath'] = (String('https://perkycollar.backendless.app/api/files/') + String('client-docs/AGR-completed/'));
  }
  await getLandingPages('Savings Calculator');
  await QueryAgid();
  ___arguments.context.appData['srcFileName'] = 'GPR_Savings_Agreement_V3.pdf';
  ___arguments.context.appData['pdfSavedFile'] = (String(getObjectProperty(___arguments.context.appData, 'srcFilePath')) + String(getObjectProperty(___arguments.context.appData, 'srcFileName')));
  ___arguments.context.appData['tgtFilePath'] = 'client-docs/AGR-completed/';
  console.log(String('=00= pdfSavedFile=') + String(getObjectProperty(___arguments.context.appData, 'pdfSavedFile')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lpSave/components/974a3c33d1f3bb2a497d9e322ae23f88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currPage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currPage = 'START';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e'](currPage, null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') || (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))),[`theme=1`]: undefined }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/lpUpload/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var pageset;


  console.log('=== Entering lpUpload ===');
  ___arguments.context.pageData['filesUploadedTotal'] = 0;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lpUpload/components/2e7bef254da17121276c93fbb93505d7/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFailed */
  ['onUploadFailed'](___arguments) {
      console.log(String('=02DZ= File Upload Failed =') + String(___arguments['error']));

  },
  /* handler:onUploadFailed */
  /* handler:fileNameLogic */
  async ['fileNameLogic'](___arguments) {
    var adjFileName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setFileName() {
  adjFileName = [(typeof (getObjectProperty(___arguments.context.pageData, 'selectedClient')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'selectedClient')) === null) ? 'WEB' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'clientid')),'_',(getObjectProperty(___arguments['file'], 'name'))].join('');
  return adjFileName
}



  return (await setFileName())

  },
  /* handler:fileNameLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(String('Files List=') + String(JSON.stringify(___arguments['filesList'])));
  ___arguments.context.pageData['filesUploadedTotal'] = (___arguments['filesList'].length);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/lpUpload/components/ee847c7a8f145bbe2f0ed037006f9d54/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var selectedClient, addr2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateClient() {
  selectedClient = ({ [`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'cmpname')),[`lastname`]: (getObjectProperty(___arguments.context.pageData, 'lastname')),[`firstname`]: (getObjectProperty(___arguments.context.pageData, 'firstname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'addr1')),[`addr2`]: addr2,[`city`]: (getObjectProperty(___arguments.context.pageData, 'city')),[`state`]: undefined,[`zip_postalcode`]: (getObjectProperty(___arguments.context.pageData, 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty(___arguments.context.pageData, 'phone')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`agentid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')),[`agentemail`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')),[`clientType`]: undefined,[`AgrDocDate`]: undefined,[`AgrDocLink`]: undefined,[`AgrSigDate`]: undefined,[`AgrSigLink`]: undefined,[`isAGRcomplete`]: false,[`isACHcomplete`]: false,[`ACHcompleteDate`]: undefined,[`CSAactive`]: 0,[`CSApending`]: 0,[`isClient`]: false,[`billingmethod`]: undefined,[`accountholdername`]: undefined,[`achrout`]: undefined,[`achacct`]: undefined,[`achauth`]: false,[`ccacct`]: undefined,[`ccexpdt`]: undefined,[`cccvc`]: undefined,[`ccauth`]: false,[`ccfeeauth`]: false,[`zelleid`]: undefined,[`othClientid`]: undefined,[`othPO`]: undefined,[`approvalcode`]: undefined,[`approvaldate`]: undefined });
  ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save( selectedClient ));
  console.log(String('=00= selected client=') + String(JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedClient')))));
}


  console.log('===== save prospect data as client =====');
  ___arguments.context.pageData['selectedClient'] = (await Backendless.Data.of('Clients').save( ({ [`cmpname`]: (typeof (getObjectProperty(___arguments.context.dataModel, 'in-company')) === 'undefined') || ((getObjectProperty(___arguments.context.dataModel, 'in-company')) === null) ? '' : (getObjectProperty(___arguments.context.dataModel, 'in-company')),[`firstname`]: (getObjectProperty(___arguments.context.dataModel, 'in-firstname')),[`lastname`]: (getObjectProperty(___arguments.context.dataModel, 'in-lastname')),[`phone`]: (getObjectProperty(___arguments.context.dataModel, 'in-phone')),[`email`]: (getObjectProperty(___arguments.context.dataModel, 'in-email')),[`CSAactive`]: 0,[`CSApending`]: 0,[`approvalDate`]: (new Date()),[`approvalCode`]: 'lpUpload' }) ));
  console.log('===== upload and docs dropped in dropzone =====');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).uploadFiles() })('2e7bef254da17121276c93fbb93505d7');
  console.log(String('B4 filesUploadTotal=') + String(getObjectProperty(___arguments.context.pageData, 'filesUploadedTotal')));
  (getObjectProperty(___arguments.context.pageData, 'selectedClient'))['CSApending'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'CSApending')) + ((typeof (getObjectProperty(___arguments.context.pageData, 'filesUploadedTotal')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'filesUploadedTotal')) === null) ? 0 : (getObjectProperty(___arguments.context.pageData, 'filesUploadedTotal'))));
  console.log('===== insert upload count to client rec');
  ___arguments.context.pageData['selectedClient'] = (await Backendless.Data.of('Clients').save(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'clientid')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'objectId')),[`CSApending`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedClient')), 'CSApending')) }), true));
  await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('98cdf25e5677d41f7d2e7ef60902e7aa', true, true, 'You may close this window now.', 'Information successfully submitted!', 'info');

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/nflticket/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var agSelect, pageset, agid, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function QueryAgid() {
  if (!(typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined')) {
    console.log('=00=QueryAgent= 1');
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')));
  } else if (typeof ___arguments.context.pageData === 'undefined') {
    console.log('=00=QueryAgent= 2');
    await setAgid('1');
  } else if (!(typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined')) {
    console.log('=00=QueryAgent= 3');
    await setAgid((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')));
  } else {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'agid')) === 'undefined') {
      console.log('=00=QueryAgent= 4a');
      await setAgid('1');
    } else {
      console.log('=00=QueryAgent= 4b');
      await setAgid((getObjectProperty(___arguments.context.pageData, 'agid')));
    }
  }
}

/**
 * Describe this function...
 */
async function setContactInfo() {
  ___arguments.context.pageData['contactphone'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone'));
  ___arguments.context.pageData['contactphoneurl'] = (String('tel:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone')));
  ___arguments.context.pageData['contactemail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email'));
  ___arguments.context.pageData['contactemailurl'] = (String('mailto:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')));
  ___arguments.context.pageData['contactaddress'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'addr1')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'city')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'state')),' ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'zip'))].join(''));
}

/**
 * Describe this function...
 */
async function getAgSelect() {
  agSelect = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('active=') + String(true))).setProperties('name as label, agentid as value').setSortBy('name').setPageSize(100)));
  ___arguments.context.pageData['agSelect'] = agSelect;
}

/**
 * Describe this function...
 */
async function setAgid(agid) {
  if (agid > 1) {
    ___arguments.context.pageData['AskForAgent'] = false;
  } else {
    ___arguments.context.pageData['AskForAgent'] = true;
  }
  ___arguments.context.pageData['agid'] = agid;
  await getAgent();
}

/**
 * Describe this function...
 */
async function getLandingPages(pageset) {
  ___arguments.context.appData['pages'] = ((await Backendless.Data.of('LandingPages').find(Backendless.DataQueryBuilder.create().setWhereClause((['pageset=\'',pageset,'\''].join(''))).setPageSize(10)))[0]);
}

/**
 * Describe this function...
 */
async function getAgent() {
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((['agentid=\'',(getObjectProperty(___arguments.context.pageData, 'agid')),'\''].join(''))).setPageSize(100)));
  ___arguments.context.appData['agent'] = (list[0]);
}


  console.log('=== Entering NFLticket ===');
  if ((function () { return BackendlessUI.isProd })()) {
    ___arguments.context.appData['srcFilePath'] = (String('https://app.gprsaves.com/api/files/') + String('client-docs/AGR-completed/'));
  } else {
    ___arguments.context.appData['srcFilePath'] = (String('https://perkycollar.backendless.app/api/files/') + String('client-docs/AGR-completed/'));
  }
  await QueryAgid();
  await getLandingPages('NFL Ticket');
  await getAgSelect();
  ___arguments.context.appData['srcFileName'] = 'GPR_Savings_Agreement_V3.pdf';
  ___arguments.context.appData['pdfSavedFile'] = (String(getObjectProperty(___arguments.context.appData, 'srcFilePath')) + String(getObjectProperty(___arguments.context.appData, 'srcFileName')));
  ___arguments.context.appData['tgtFilePath'] = 'client-docs/AGR-completed/';
  console.log(String('=NFL00= pdfSavedFile=') + String(getObjectProperty(___arguments.context.appData, 'pdfSavedFile')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/nflticket/components/e4cfd4cbb5c5fdded86a195964a73cc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ee847c7a8f145bbe2f0ed037006f9d54');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nflticket/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list, selectedClient, addr2, clientSearchString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateClient() {
  await Address2Cleanup();
  selectedClient = ({ [`cmpname`]: (getObjectProperty(___arguments.context.pageData, 'cmpname')),[`lastname`]: (getObjectProperty(___arguments.context.pageData, 'lastname')),[`firstname`]: (getObjectProperty(___arguments.context.pageData, 'firstname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'addr1')),[`addr2`]: addr2,[`city`]: (getObjectProperty(___arguments.context.pageData, 'city')),[`state`]: undefined,[`zip_postalcode`]: (getObjectProperty(___arguments.context.pageData, 'zip')),[`country`]: 'US',[`phone1`]: (getObjectProperty(___arguments.context.pageData, 'phone')),[`phone2`]: undefined,[`phone3`]: undefined,[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`agentid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')),[`agentemail`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')),[`clientType`]: undefined,[`AgrDocDate`]: undefined,[`AgrDocLink`]: undefined,[`AgrSigDate`]: undefined,[`AgrSigLink`]: undefined,[`isAGRcomplete`]: false,[`isACHcomplete`]: false,[`ACHcompleteDate`]: undefined,[`CSAactive`]: 0,[`CSApending`]: 0,[`isClient`]: false,[`billingmethod`]: undefined,[`accountholdername`]: undefined,[`achrout`]: undefined,[`achacct`]: undefined,[`achauth`]: false,[`ccacct`]: undefined,[`ccexpdt`]: undefined,[`cccvc`]: undefined,[`ccauth`]: false,[`ccfeeauth`]: false,[`zelleid`]: undefined,[`approvalcode`]: undefined,[`approvaldate`]: undefined });
  ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save( selectedClient ));
  await SetStateRelations();
  await SetAgentRelations();
  await SetClientType();
}

/**
 * Describe this function...
 */
async function SetStateRelations() {
  await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]);
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['state'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2'));
}

/**
 * Describe this function...
 */
async function DoesClientExist() {
  clientSearchString = ['state=\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')),'\' AND ','city=\'',(getObjectProperty(___arguments.context.pageData, 'city')),'\'',' AND ','lastname=\'',(getObjectProperty(___arguments.context.pageData, 'lastname')),'\'',' AND ','addr1 LIKE \'',(getObjectProperty(___arguments.context.pageData, 'addr1')),'%\''].join('').toLowerCase();
  list = (await Backendless.Data.of('vwClients').find(Backendless.DataQueryBuilder.create().setWhereClause(clientSearchString).setPageSize(100)));
}

/**
 * Describe this function...
 */
async function SetAgentRelations() {
  ___arguments.context.pageData['agent'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'agentid', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'objectId'))]));
}

/**
 * Describe this function...
 */
async function SetClientType() {
  ___arguments.context.pageData['ClientType'] = ((await Backendless.Data.of('ClientType').find(Backendless.DataQueryBuilder.create().setWhereClause('clientTypeId=1').setPageSize(10)))[0]);
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['clientType'] = (await Backendless.Data.of('Clients').setRelation(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')) }), 'clientType', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'ClientType')), 'objectId'))]));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty(___arguments.context.pageData, 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
}


  if ((typeof (getObjectProperty(___arguments.context.appData, 'selectedState')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'selectedState')) === null)) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter State Value', 'Error!', 'error');
  } else if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')) === 'undefined') || !(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')).length) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter State Value', 'Error!', 'error');
  } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'lastname')) === 'undefined') || !(getObjectProperty(___arguments.context.pageData, 'lastname')).length) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter NAME Value', 'Error!', 'error');
  } else if (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('19dab91d3015e2b88725af6bb2bc644f', true, true, 'Please Enter REFERRED-BY Value', 'Error!', 'error');
  } else {
    await DoesClientExist();
    if (list.length == 0) {
      await CreateClient();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('START', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
    } else if (list.length == 1) {
      ___arguments.context.appData['selectedClient'] = (list[0]);
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isAGRcomplete')) != true) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e'](null, 'AGR', (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('START', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
      }
    } else {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('079fb8cc8f7c5d8141033a8a21bf2966');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nflticket/components/7f322afd76ee3815eaea3425f68366ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf('(') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace('(', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf(')') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace(')', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf('-') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace('-', ''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'phone')).indexOf(' ') !== -1) {
    ___arguments.context.pageData['phone'] = ((getObjectProperty(___arguments.context.pageData, 'phone')).replace(' ', ''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/nflticket/components/340cc93129e7fdc241fa71f10d3be0fb/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedClient'] = ___arguments.selectedRecord;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('079fb8cc8f7c5d8141033a8a21bf2966');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('START', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onRecordSelect */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var clientSearchString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  clientSearchString = ['state=\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')),'\' AND ','city=\'',(getObjectProperty(___arguments.context.pageData, 'city')),'\'',' AND ','lname=\'',(getObjectProperty(___arguments.context.pageData, 'lastname')),'\'',' AND ','addr1 LIKE \'',(getObjectProperty(___arguments.context.pageData, 'addr1')),'%\''].join('').toLowerCase();
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('340cc93129e7fdc241fa71f10d3be0fb'))['whereClause'] = clientSearchString;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/nflticket/components/b04c5ed4cd8ace3a0ab6c098bee7f132/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;


  console.log(String('Changed Value=') + String(___arguments.value));
  list = (await Backendless.Data.of('vwAgents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid=') + String(___arguments.value))).setPageSize(10)));
  console.log(String('Selected Agent=') + String(JSON.stringify((list[0]))));
  ___arguments.context.appData['agent'] = (list[0]);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/nflticketAGR/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var srcFileName, srcFilePath, tgtFileName, extFilePath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GeneratePdf() {
  if ((function () { return BackendlessUI.isProd })()) {
    await genPdf();
  } else {
    await genPdf();
  }
}

/**
 * Describe this function...
 */
async function FillVariables() {
  console.log('=01= FillVariables ==');
  ___arguments.context.pageData['templateId'] = '6d977b23a0deb8b8';
  ___arguments.context.pageData['EffectiveDate'] = ((new Date()).toDateString());
  ___arguments.context.pageData['ClientName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name'));
  ___arguments.context.pageData['ClientAddress'] = ([String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr1')) + String(', '),(typeof (getObjectProperty(___arguments.context.appData, 'addr2')) === 'undefined') || ((getObjectProperty(___arguments.context.appData, 'addr2')) === null) ? '' : String(getObjectProperty(___arguments.context.appData, 'addr2')) + String(', '),String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'city')) + String(', '),String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'code_2')) + String(' '),(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zip_postalcode'))].join(''));
  ___arguments.context.pageData['CompanyName'] = ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === 'undefined') ? '' : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')));
  if (typeof (getObjectProperty(___arguments.context.pageData, 'CompanyName')) === 'undefined') {
    ___arguments.context.pageData['NAME01'] = (getObjectProperty(___arguments.context.pageData, 'ClientName'));
  } else {
    ___arguments.context.pageData['NAME01'] = (getObjectProperty(___arguments.context.pageData, 'CompanyName'));
  }
  if (typeof (getObjectProperty(___arguments.context.pageData, 'CompanyName')) === 'undefined') {
    ___arguments.context.pageData['NAME02'] = '';
  } else {
    ___arguments.context.pageData['NAME02'] = (getObjectProperty(___arguments.context.pageData, 'CompanyName'));
  }
  ___arguments.context.pageData['NAME03'] = (getObjectProperty(___arguments.context.pageData, 'ClientName'));
  ___arguments.context.pageData['signature'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigLink'));
  ___arguments.context.appData['tgtFileName'] = (String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')) + String('_AGR_document.pdf'));
  ___arguments.context.pageData['pdfFileName'] = (getObjectProperty(___arguments.context.appData, 'tgtFileName'));
  console.log(String('=01= output pdfFileName/PageData = ') + String(getObjectProperty(___arguments.context.pageData, 'pdfFileName')));
}

/**
 * Describe this function...
 */
async function genPdf() {
  console.log('=01= genPdf ==');
  ___arguments.context.pageData['pdfReturnedURL'] = (await Backendless.Request.post(`${Backendless.appPath}/services/CraftMyPDF/generate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`templateId`]: (getObjectProperty(___arguments.context.pageData, 'templateId')),[`data`]: ({ [`ClientAddress`]: (getObjectProperty(___arguments.context.pageData, 'ClientAddress')),[`EffectiveDate`]: (getObjectProperty(___arguments.context.pageData, 'EffectiveDate')),[`NAME01`]: (getObjectProperty(___arguments.context.pageData, 'NAME01')),[`NAME02`]: (getObjectProperty(___arguments.context.pageData, 'NAME02')),[`NAME03`]: (getObjectProperty(___arguments.context.pageData, 'NAME03')),[`Signature`]: (getObjectProperty(___arguments.context.pageData, 'signature')) }),[`outputFile`]: (getObjectProperty(___arguments.context.pageData, 'pdfFileName')),[`isCmyk`]: false,[`imageResampleRes`]: 0 }))));
  console.log(String('=01= genPDF returned URL = ') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'pdfReturnedURL')))));
}

/**
 * Describe this function...
 */
async function ProcessFilename() {
  console.log('=01= ProcessFilename ==');
  extFilePath = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'pdfReturnedURL')), 'fileUrl'));
  ___arguments.context.pageData['pdfSavedFile'] = extFilePath;
  console.log(String('=01= pdfSavedFile = ') + String(getObjectProperty(___arguments.context.pageData, 'pdfSavedFile')));
  ___arguments.context.pageData['pdfExists'] = true;
}


  console.log('=01= btnNext Click');
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigDate')) === 'undefined') || ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigDate')) === null)) {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('dae93722c3a458f46a8ca81e15fd470d', true, undefined, undefined, 'Please supply a signature before proceeding!', 'error');
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigDate'] = null;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigLink'] = null;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isAGRcomplete'] = false;
  } else {
    console.log('=01= SIG exists. Gen the PDF');
    await FillVariables();
    await GeneratePdf();
    await ProcessFilename();
    console.log('=01= save AGR detail in DB');
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isAGRcomplete'] = true;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrDocDate'] = ((new Date()).valueOf());
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrDocLink'] = (getObjectProperty(___arguments.context.pageData, 'pdfSavedFile'));
    ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`isAGRcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isAGRcomplete')),[`AgrDocDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocDate')),[`AgrDocLink`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')),[`AgrSigDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigDate')),[`AgrSigLink`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigLink')) }), true));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('AGR', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nflticketAGR/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('=01=');
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    console.log('=01= invalid data - reverting back to nflticket00 ==');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nflticket', ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
  }

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setContactInfo() {
  ___arguments.context.pageData['contactphone'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone'));
  ___arguments.context.pageData['contactphoneurl'] = (String('tel:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone')));
  ___arguments.context.pageData['contactemail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email'));
  ___arguments.context.pageData['contactemailurl'] = (String('mailto:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')));
  ___arguments.context.pageData['contactaddress'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'addr1')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'city')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'state')),' ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'zip'))].join(''));
}


  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    console.log('=01= invalid data - reverting back to landing00 ==');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nflticket', ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
  }
  await setContactInfo();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/nflticketAGR/components/6bd7e4628352366c8ab3a1d8f5b39a7d/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function AGR_SigSave() {
  console.log('=01= Sig Save');
  console.log(String('=01= tgtFilePath = ') + String(getObjectProperty(___arguments.context.appData, 'tgtFilePath')));
  ___arguments.context.pageData['sigFilePath'] = (getObjectProperty(___arguments.context.appData, 'tgtFilePath'));
  console.log(String('=01= sigFilePath = ') + String(getObjectProperty(___arguments.context.pageData, 'sigFilePath')));
  ___arguments.context.pageData['sigFileName'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),'_AGR_','sig.png'].join(''));
  console.log(String('=01= sigFileName = ') + String(getObjectProperty(___arguments.context.pageData, 'sigFileName')));
  ___arguments.context.pageData['sigFileURL'] = (await Backendless.Files.saveFile(encodePath((getObjectProperty(___arguments.context.pageData, 'sigFilePath'))), (getObjectProperty(___arguments.context.pageData, 'sigFileName')), ___arguments['signature'], true));
  console.log(String('=01= Sig has been saved - ') + String(getObjectProperty(___arguments.context.pageData, 'sigFileURL')));
  if (typeof (getObjectProperty(___arguments.context.pageData, 'sigFileURL')) === 'undefined') {
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigDate'] = null;
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigLink'] = null;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('dae93722c3a458f46a8ca81e15fd470d', true, undefined, undefined, 'Please supply a signature before proceeding!', 'error');
  } else {
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigDate'] = ((new Date()).valueOf());
    (getObjectProperty(___arguments.context.appData, 'selectedClient'))['AgrSigLink'] = (getObjectProperty(___arguments.context.pageData, 'sigFileURL'));
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('dae93722c3a458f46a8ca81e15fd470d', true, undefined, undefined, 'Signature has been saved!', 'info');
  }
}


  await AGR_SigSave();

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/nflticketAGR/components/eae5bb6b89f41e22a3e53ea29bf1a649/bundle.js', [], () => ({
  /* content */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'pdfSavedFile'))

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/nflticketBILL/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('=== Entering nflticketBILL ===');
  ___arguments.context.appData['filesUploadedTotal'] = 0;
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('c28d401fdb51c0f226690dac3c3f55d9', (await Promise.all((await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setWhereClause('catname like \'%NFL%\'').setSortBy('catname').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'catname')),[`value`]: (getObjectProperty(item, 'catid')) });}))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setContactInfo() {
  ___arguments.context.pageData['contactphone'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone'));
  ___arguments.context.pageData['contactphoneurl'] = (String('tel:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone')));
  ___arguments.context.pageData['contactemail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email'));
  ___arguments.context.pageData['contactemailurl'] = (String('mailto:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')));
  ___arguments.context.pageData['contactaddress'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'addr1')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'city')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'state')),' ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'zip'))].join(''));
}


  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    console.log('== invalid data - reverting back to landing00 ==');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nflticket', ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
  }
  await setContactInfo();

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/nflticketBILL/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var CSApending, cpr_FileName, cpr_FilePath, cpr_doc, AgrDocName, AgrDocPath, EmailTmplName, cpr_PostResponse, cpr_doc_uid, achcompleteDate, approvalDate, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ClientProfileRpt() {
  console.log('=03= ClientProfileRpt = ');
  cpr_FilePath = 'client-docs/AGR-completed/';
  cpr_FileName = [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),'_','ClientProfileRpt.docx'].join('');
  await docGenerate();
  console.log('=03= END ClientProfileRpt = ');
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function checkEmailSend() {
  EmailTmplName = 'Client_TY_CSA';
  if (getValueLength(EmailTmplName) > 0) {
    console.log(String('=03= Email Template chosen = ') + String(EmailTmplName));
    AgrDocPath = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')).slice((((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')).indexOf('client-docs') + 1) - 1), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')).lastIndexOf('/') + 1);
    AgrDocName = subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')), (((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')).lastIndexOf('/') + 1 + 1) - 1));
    console.log(String('=03= AGR Doc Link = ') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrDocLink')));
    console.log(String('=03= AGR Doc Path = ') + String(AgrDocPath));
    console.log(String('=03= AGR Doc Name = ') + String(AgrDocName));
    await SendEmailToClient();
    await SendEmailToGPR();
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function docGenerate() {
  console.log('=03= docGenerate = ');
  approvalDate = (new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate'))));
  achcompleteDate = (new Date((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate'))));
  cpr_doc = (await Backendless.Request.get(`${Backendless.appPath}/services/DocsGenerator/documents`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'templateUid': JSON.stringify('bf5129ec3d2b4f25bcc09600f0366206'),'createPdf': false,'AGRstatus': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isAGRcomplete')) == true ? 'ON FILE' : 'MISSING')),'ACHstatus': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')) == true ? 'ON FILE' : 'MISSING')),'CSApending': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'))),'CSAcomplete': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSAactive'))),'onboardingDate': JSON.stringify(approvalDate),'clientid': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid'))),'agentid': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid'))),'agentname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'name'))),'cmpname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname'))),'firstname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'firstname'))),'lastname': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'lastname'))),'addr1': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr1'))),'addr2': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'addr2'))),'city': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'city'))),'state': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'state'))),'zip': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zip_postalcode'))),'phone1': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'phone'))),'phone2': JSON.stringify(''),'email': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'email'))),'savingssplit': JSON.stringify('50%'),'AGRsignature': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'AgrSigLink'))),'billingmethod': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? 'ACH-Bank Draft' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? 'Credit/Debit' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? 'Zelle' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'O' ? 'Other' : 'METHOD NOT SPECIFIED'))))),'financialinstitution': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 3 ? 'American Express' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 4 ? 'Visa' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 5 ? 'MasterCard' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')) == 6 ? 'Discover' : 'CC-Other')))) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? 'BANK' : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? 'Zelle-Bank' : 'Invoice/PO/Other')))),'accountnumber': JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'C' ? String('xxxx-xxxx-xxxx-') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')), 3)) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A' ? String('xxxxxxx-') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct')), 3)) : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'Z' ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'zelleid')) : 'N/A')))),'dateofupdate': JSON.stringify(achcompleteDate),'docPending': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'))),'outputFilePath': JSON.stringify(cpr_FilePath),'outputFileName': JSON.stringify(cpr_FileName) }).send());
  console.log(String('cpr_doc=') + String(cpr_doc));
  console.log('=03= END docGenerate = ');
}

/**
 * Describe this function...
 */
async function SendEmailToClient() {
  console.log('=03= Send Email To Client');
  for (var count = 0; count < 3; count++) {
    try {
      console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'email'))], ccAddresses: undefined, bccAddresses: ['support@eigercreative.com'], query: '', uniqueEmails: false }), ({ [`customer_name`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) }), [String(AgrDocPath) + String(AgrDocName)])));
      break;

    } catch (error) {

    }
  }
}

/**
 * Describe this function...
 */
async function SendEmailToGPR() {
  console.log('=03= Send Email To GPR');
  for (var count2 = 0; count2 < 3; count2++) {
    try {
      console.log((await Backendless.Messaging.sendEmailFromTemplate(EmailTmplName, Backendless.EmailEnvelope.create({ addresses: [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email'))], ccAddresses: ['info@gprsaves.com', 'jacqui@grouppurchasingresources.com', 'sean@grouppurchasingresources.com', 'support@eigercreative.com'], bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`customer_name`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) === 'undefined') ? (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cmpname')) }), [String(AgrDocPath) + String(AgrDocName), String(cpr_FilePath) + String(cpr_FileName)])));
      break;

    } catch (error) {

    }
  }
}


  console.log('=03= check filesUploaded');
  CSApending = 0;
  CSApending = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'CSApending'));
  if ((getObjectProperty(___arguments.context.appData, 'filesUploadedTotal')) > 0) {
    CSApending = CSApending + (getObjectProperty(___arguments.context.appData, 'filesUploadedTotal'));
    ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`CSApending`]: CSApending }), true));
  }
  await ClientProfileRpt();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('BILL', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nflticketBILL/components/c28d401fdb51c0f226690dac3c3f55d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedCat;


  selectedCat = (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setWhereClause((String('catid=') + String(___arguments.value))).setPageSize(100)))[0];
  ___arguments.context.pageData['selectedCat'] = selectedCat;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/nflticketBILL/components/ee5cc52230212eb17d3411a8c9a4b1de/bundle.js', [], () => ({
  /* content */
  /* handler:fileNameLogic */
  async ['fileNameLogic'](___arguments) {
    var adjFileName, selectedClient;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setFileName() {
  selectedClient = (getObjectProperty(___arguments.context.appData, 'selectedClient'));
  adjFileName = [(getObjectProperty(selectedClient, 'clientid')),'_',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedCat')), 'catid')),'_',(getObjectProperty(___arguments['file'], 'name'))].join('');
  console.log(String('=BILL= Dropzone = adjFilename=') + String(adjFileName));
}


  await setFileName();

  return adjFileName

  },
  /* handler:fileNameLogic */
  /* handler:onUpload */
  ['onUpload'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function saveUploadedFile() {
  if (typeof (getObjectProperty(___arguments.context.appData, 'filesUploadedTotal')) === 'undefined') {
    ___arguments.context.appData['filesUploadedTotal'] = 0;
  } else {
    ___arguments.context.appData['filesUploadedTotal'] = ((getObjectProperty(___arguments.context.appData, 'filesUploadedTotal')) + 1);
  }
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedCatList')) === 'undefined') {
    ___arguments.context.appData['selectedCatList'] = [];
  }
  console.log(String('=01DZ= filesUploadedTotal=') + String(getObjectProperty(___arguments.context.appData, 'filesUploadedTotal')));
  addItemToList((getObjectProperty(___arguments.context.appData, 'selectedCatList')), ({ [`docNumber`]: (getObjectProperty(___arguments.context.appData, 'filesUploadedTotal')),[`docName`]: (getObjectProperty(___arguments['file'], 'name')) }));
}

  },
  /* handler:onUpload */
  /* content */
}))

define('./pages/nflticketFIN/components/0d6a356d1bd18a51336e141f4465b608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var isOKstatusACH, isOKstatusCC, clientobj, isOKstatusOTH;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function OnclickOTH() {
  console.log('=02= OnClickOTH');
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['othClientid'] = (getObjectProperty(___arguments.context.pageData, 'othClientid'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['othPO'] = (getObjectProperty(___arguments.context.pageData, 'othPOnumber'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ACHcompleteDate'] = (new Date());
  console.log(String('=02= isACHcomplete=') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')));
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')),[`othClientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'othClientid')),[`othPO`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'othPO')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvalcode')),[`iaACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate')) }));
  console.log('=02= OnClickOTH END');
}

/**
 * Describe this function...
 */
async function OnclickACH() {
  console.log('=02= OnClickACH ');
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['accountholdername'] = (getObjectProperty(___arguments.context.pageData, 'achAccountholderName'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['achrout'] = (getObjectProperty(___arguments.context.pageData, 'achRout'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['achacct'] = (getObjectProperty(___arguments.context.pageData, 'achAcct'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['achauth'] = (getObjectProperty(___arguments.context.pageData, 'achAuth'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ACHcompleteDate'] = (new Date());
  console.log(String('=02= isACHcomplete=') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')));
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername')),[`achrout`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achrout')),[`achacct`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct')),[`achauth`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvalcode')),[`iaACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate')) }));
  console.log('=02= OnClickACH END');
}

/**
 * Describe this function...
 */
async function OnclickCC() {
  console.log('=02= OnClickCC');
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['billingmethod'] = (getObjectProperty(___arguments.context.pageData, 'BillingMethod'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['accountholdername'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-873d')), 'cardholderName'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccacct'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-873d')), 'cardNumber'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccexpdt'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-873d')), 'expiry'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['cccvc'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Credit Card-873d')), 'cvc'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccauth'] = (getObjectProperty(___arguments.context.pageData, 'ccAuth'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ccfeeauth'] = (getObjectProperty(___arguments.context.pageData, 'ccFeeAuth'));
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['approvaldate'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['isACHcomplete'] = true;
  (getObjectProperty(___arguments.context.appData, 'selectedClient'))['ACHcompleteDate'] = (new Date());
  await ClientUpdate(({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'objectId')),[`clientid`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')),[`billingmethod`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')),[`accountholdername`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername')),[`ccacct`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')),[`ccexpdt`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccexpdt')),[`cccvc`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cccvc')),[`ccauth`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccauth')),[`ccfeeauth`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccfeeauth')),[`approvaldate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvaldate')),[`approvalcode`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'approvalcode')),[`isACHcomplete`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'isACHcomplete')),[`ACHcompleteDate`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ACHcompleteDate')) }));
  console.log('=02= OnClickCC END');
}

/**
 * Describe this function...
 */
async function ClientUpdate(clientobj) {
  ___arguments.context.appData['selectedClient'] = (await Backendless.Data.of('Clients').save(clientobj, true));
}

/**
 * Describe this function...
 */
async function statusOTH() {
  console.log('=02= statusOTH');
  isOKstatusOTH = true;
  console.log('=02= statusOTH END');
  return isOKstatusOTH
}

/**
 * Describe this function...
 */
async function statusACH() {
  console.log('=02= statusACH');
  isOKstatusACH = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'achRout')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Routing Number missing or invalid.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'achRout')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achAcct')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Account Number missing or invalid.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'achAcct')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'achAuth')) === 'undefined') {
    isOKstatusACH = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'ACH Billing Authority must be granted to proceed.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'achAuth')));
  }
  console.log('=02= statusACH END');
  return isOKstatusACH
}

/**
 * Describe this function...
 */
async function statusCC() {
  console.log('=02= statusCC');
  isOKstatusCC = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'cardNumber')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Card Number missing or invalid.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'cardNumber')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'cardholderName')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'Cardholder Name missing or invalid.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'cardholderName')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'expiry')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'CC Expire Date missing or invalid', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'expiry')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'cvc')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'CVC Number missing or invalid.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'cvc')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccAuth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'You must authorize charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'ccAuth')));
  } else if (typeof (getObjectProperty(___arguments.context.pageData, 'ccFeeAuth')) === 'undefined') {
    isOKstatusCC = false;
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('51348dcd95a93e2d09eb0d2d8f8b7018', true, undefined, undefined, 'You must authorize the CC Fee charges against your Credit/Debit card.', 'error');
    (function (component) { component.focus() })((getObjectProperty(___arguments.context.pageData, 'ccFeeAuth')));
  }
  console.log('=02= statusCC END');
  return isOKstatusCC
}


  if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'A') {
    if (await statusACH()) {
      await OnclickACH();
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'C') {
    if (await statusCC()) {
      await OnclickCC();
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'O') {
    if (await statusOTH()) {
      await OnclickOTH();
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'P') {
    if (await statusOTH()) {
      await OnclickOTH();
    }
  }
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((await BackendlessUI.Functions.Custom['fn_c44ffc3ca2e2aa52008a39e743ed1c5e']('FIN', null, (getObjectProperty(___arguments.context.appData, 'pages')))), ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nflticketFIN/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setContactInfo() {
  ___arguments.context.pageData['contactphone'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone'));
  ___arguments.context.pageData['contactphoneurl'] = (String('tel:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'phone')));
  ___arguments.context.pageData['contactemail'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email'));
  ___arguments.context.pageData['contactemailurl'] = (String('mailto:') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'email')));
  ___arguments.context.pageData['contactaddress'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'addr1')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'city')),', ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'state')),' ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'zip'))].join(''));
}


  console.log('=02=');
  if (typeof (getObjectProperty(___arguments.context.appData, 'selectedClient')) === 'undefined') {
    console.log('=02= invalid data - reverting back to landing00 ==');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nflticket', ({ [`agid`]: (typeof (getObjectProperty(___arguments.context.appData, 'agent')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'agent')), 'agentid')))) }));
  }
  await setContactInfo();

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var ccexpdt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function BillingInfoYES() {
  console.log('=02= BillingInfoYES');
  ___arguments.context.pageData['showBillingInfo'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f796d00648693694d3b7edf49ce2ac3f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', false);
  ___arguments.context.pageData['BillingMethod'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod'));
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A') {
    ___arguments.context.pageData['achRout'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achrout'));
    ___arguments.context.pageData['achAcct'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct'));
    ___arguments.context.pageData['achAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achauth'));
    ___arguments.context.pageData['achAccount'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername'));
  } else {
    ___arguments.context.pageData['cardNumber'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct'));
    ___arguments.context.pageData['expiry'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccexpdt'));
    ___arguments.context.pageData['cvc'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cccvc'));
    ___arguments.context.pageData['cardholderName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername'));
  }
}

/**
 * Describe this function...
 */
async function BillingInfoNO() {
  console.log('=02= BillingInfoNO');
  ___arguments.context.pageData['showBillingInfo'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f796d00648693694d3b7edf49ce2ac3f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', true);
  ___arguments.context.pageData['BillingMethod'] = 'A';
}

/**
 * Describe this function...
 */
async function CheckCC() {
}


  console.log('=02= Entering nflticket02 ===');
  console.log(String('=02= clientid=') + String(Number((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'clientid')))));
  if ((typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) === 'undefined') || (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == null) {
    await BillingInfoNO();
  } else {
    await BillingInfoYES();
  }
  await CheckCC();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/nflticketFIN/components/707c031c6c21d72d9a4ee0169e0f1432/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['BillingMethod'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/nflticketFIN/components/d3c5947539daf58a6591872b73bae486/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'A' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/nflticketFIN/components/0e2c1d2a153ee95a2b171e6ec9d766e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'C' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/nflticketFIN/components/dbc8fad92129355584d3e0e140d6a6d2/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateNumber() })('dbc8fad92129355584d3e0e140d6a6d2')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateExpiry() })('dbc8fad92129355584d3e0e140d6a6d2')) == false) {
    return false;
  } else if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).validateCVC() })('dbc8fad92129355584d3e0e140d6a6d2')) == false) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/nflticketFIN/components/6939e51870a1ba5c07464e0cbf29ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BillingChanges'] = ___arguments.checkedValue;
  if (___arguments.checkedValue == 'Y') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', true);
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'billingmethod')) == 'A') {
      ___arguments.context.pageData['achRout'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achrout'));
      ___arguments.context.pageData['achAcct'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achacct'));
      ___arguments.context.pageData['achAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'achauth'));
      ___arguments.context.pageData['achAccountholderName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername'));
    } else {
      ___arguments.context.pageData['Credit Card-873d'] = ({ [`cardNumber`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccacct')),[`expiry`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccexpdt')),[`cvc`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'cccvc')),[`cardholderName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'accountholdername')) });
      ___arguments.context.pageData['ccAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccauth'));
      ___arguments.context.pageData['ccFeeAuth'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'ccfeeauth'));
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0eebe770a68667e58866d0487a7ed07', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0266eb0f85efa5fbf2ad1a4343da1bbc', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7aec55f20dfeac9e159f72a400af2dd', false);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nflticketFIN', ({ [`agid`]: (typeof (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')) === 'undefined') ? 1 : (JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedClient')), 'agentid')))) }));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/nflticketFIN/components/c48d304e2b639d21ed14d778508e0432/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'BillingMethod')) == 'O' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/savingscalculator/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, pageset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('e538a74653a3cbbcabe6169445b34cef', (await Promise.all((await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setWhereClause((String('shortlist=') + String(true))).setSortBy('shortorder,catname').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'catname')),[`value`]: (getObjectProperty(item, 'catid')) });}))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/savingscalculator/components/68fc8fdf8d09ac07d33e519f119938bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var estSavingsYY, estSavingsMM, estSavingsPct;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'selectedCat')) === 'undefined') {
    await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('b4bb2a19358792ed6202eecf8378182e', true, false, undefined, '', 'error');
  } else {
    estSavingsPct = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedCat')), 'catEstSavingsPct')))) / 100;
    estSavingsMM = estSavingsPct * ___arguments.value;
    estSavingsYY = estSavingsMM * 12;
    ___arguments.context.pageData['estSavingsMM'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (roundDecimals(estSavingsMM,2))));
    ___arguments.context.pageData['estSavingsYY'] = (await BackendlessUI.Functions.Custom['fn_e5c2d44fae98ad119555d2c93f14b509']('$', (roundDecimals(estSavingsYY,2))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/savingscalculator/components/e538a74653a3cbbcabe6169445b34cef/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedCat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  selectedCat = (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setWhereClause((String('catid=') + String(___arguments.value))).setPageSize(10)))[0];
  ___arguments.context.pageData['selectedCat'] = selectedCat;
  console.log(String('selectedCat=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedCat')))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/047db4ddebd1c6686b2a359546647e53/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedRecord'] = ___arguments.selectedRecord;
  ___arguments.context.appData['selectedState'] = ((await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2 like \'',(getObjectProperty(___arguments.selectedRecord, 'state')),'%\''].join(''))).setPageSize(10)))[0]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('5db144f869bd266f4948c13495f4cd15');
  console.log(String('Whole Record=') + String(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'selectedRecord')))));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/ven_profile/components/513451f381bec312d8c4398ccaa7c58e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.contactname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/29064a0e68bb04be23953574bf5ef057/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.vendorname'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/10c81e8d7368930ac57d57b8e89558f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/a7d929754a543632484ac6c93338d9af/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/a03e7657ee042ee726d9e7cf0f0cb93a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.addr2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/600596583c0f8c133e5982fa637e2e58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.city'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/a4550ddd18c60368069b23c3241240dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/41b7f8b93736cf3c8c3afd12b3e979a4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/025113c2649aa09a4efd081e750e0875/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.phone2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/601343a6fb9a94a381cb43e90f1fc15d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e3e7f951e18cddf2a8c440410c9454c5');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ven_profile/components/3db451cfadc949192f486d71905fb5b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vendor, addr2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updVendor() {
  console.log('==update Vendor record from screen');
  console.log(String('Vendor B4=') + String(JSON.stringify(vendor)));
  vendor['vendorname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorname'));
  vendor['addr1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1'));
  vendor['addr2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2'));
  vendor['city'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city'));
  vendor['state'] = null;
  vendor['zip'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip'));
  vendor['phone1'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone1'));
  vendor['phone2'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone2'));
  vendor['email'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email'));
  vendor['contactname'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.contactname'));
  vendor['active'] = (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active'));
  vendor['catid'] = null;
  console.log(String('vendor AF=') + String(JSON.stringify(vendor)));
  vendor = (await Backendless.Data.of('Vendors').save( vendor ));
  console.log('==update Vendor with state info');
  await Backendless.Data.of('Vendors').setRelation(({ [`objectId`]: (getObjectProperty(vendor, 'objectId')) }), 'state', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedState')), 'objectId'))]);
  console.log('==update Vendor with category');
  await Backendless.Data.of('Vendors').setRelation(({ [`objectId`]: (getObjectProperty(vendor, 'objectId')) }), 'catid', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedRecord.catid')), 'objectId'))]);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Address2Cleanup() {
  addr2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5'), 'addr2'));
  if (typeof addr2 === 'undefined') {
    addr2 = '';
  } else if (addr2 === null) {
    addr2 = '';
  } else if (getValueLength(addr2) == 0) {
    addr2 = '';
  }
  ___arguments.context.getComponentDataStoreByUid('e3e7f951e18cddf2a8c440410c9454c5')['addr2'] = addr2;
}


  console.log('========== BUTTON CLICK ==========');
  await Address2Cleanup();
  console.log('==Get Vendor record');
  vendor = (await Backendless.Data.of('Vendors').find(Backendless.DataQueryBuilder.create().setWhereClause((String('vendorid=') + String(getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorid')))).setPageSize(10)))[0];
  console.log(String('vendor from table=') + String(JSON.stringify(vendor)));
  await updVendor();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5db144f869bd266f4948c13495f4cd15');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ven_profile/components/e3e7f951e18cddf2a8c440410c9454c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`active`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.active')),[`vendorid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorid')),[`vendorname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendorname')),[`addr1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr1')),[`addr2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.addr2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.city')),[`state`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.state')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.zip')),[`contactname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.contactname')),[`phone1`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone1')),[`phone2`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.phone2')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.email')),[`vendortype`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.vendortype')),[`catid`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.catid')),[`catname`]: (getObjectProperty(___arguments.context.pageData, 'selectedRecord.catname')) })

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/ven_profile/components/d6cf47245836b42f723ad349229d9065/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(String('Changed Value=') + String(___arguments.value));
  ___arguments.context.pageData['selectedRecord.vendortype'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/7dd90d0a79df87a5b7c2a13eb851a85c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
      return (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setProperties('catname as label, catid as value').setSortBy('catname').setPageSize(100)))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(String('changed value=') + String(___arguments.value));
  list = (await Backendless.Data.of('SavingsCategory').find(Backendless.DataQueryBuilder.create().setWhereClause((['catid like \'',___arguments.value,'%\''].join(''))).setPageSize(10)))[0];
  console.log(String('list=') + String(JSON.stringify(list)));
  ___arguments.context.pageData['selectedRecord.catid'] = (getObjectProperty(list, 'catid'));
  ___arguments.context.pageData['selectedRecord.catname'] = (getObjectProperty(list, 'catname'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ven_profile/components/0541e49c37efb81fdbbe959147614e88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['selectedRecord.active'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_e66e1f3ffb0eddfa297776436e83049c/logic/a861be28416ae37dc04b87f8c204d3e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;


  console.log(String('Input Agent Value=') + String(___arguments['inputValue']));
  list = (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setWhereClause((String('agentid =') + String(___arguments['inputValue']))).setPageSize(10)));
  ___arguments.context.appData['selectedAgent'] = (list[0]);

  },
  /* handler:onChange */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
      return (await Backendless.Data.of('Agents').find(Backendless.DataQueryBuilder.create().setProperties('name as label, agentid as value').setSortBy('').setPageSize(100)))

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./components/reusable/r_17cc6c672bb5a5ef64d5dc89cb3293ea/logic/8162c4119569802e58fcbd5a61cc038c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;

/**
 * Describe this function...
 */
async function GetStates() {
  list = (await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setWhereClause((['code_2 like \'',___arguments.value,'%\''].join(''))).setPageSize(10)));
  ___arguments.context.appData['selectedState'] = (list[0]);
}


  await GetStates();

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
      return (await Backendless.Data.of('States').find(Backendless.DataQueryBuilder.create().setProperties('name as label, code_2 as value').setSortBy('name').setPageSize(100)))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('cli_profile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('cli_fin_data', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('cli_trx_activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/f698e6116229e15a86429d929febc7c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('cli_data_import', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/0faa9e420696d889dfe6011743c790c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aff_profile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/fe115553c794e484f85351a76b0a644e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aff_fin_data', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/63e97588f4cc7db5100532140ced35c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aff_trx_activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/0cf4c6ea0849501fc16998823a02b422/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aff_data_import', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/6ea9a9ecc2d2f8a4a1dc87ee70f2139b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/1eb21a01071975b793b1b8c4fffe966c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ven_profile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://gprsaves.com', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4dc17b2d13afb996a0c47eb598ebdded/logic/f9fdc4ca7ab8081e1023efa1ae584a93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ven_profile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/b05b5acb10b7059c5f53d9a562d73779/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a183ae3e207e0fcc89580963ab5055a')).includes('clicked')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a183ae3e207e0fcc89580963ab5055a')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3a183ae3e207e0fcc89580963ab5055a')), 'clicked');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/723f4a91fd47ac2c613538daa936c6cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7e1835794955b88190d9e9b61b78ada6')).includes('clicked')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7e1835794955b88190d9e9b61b78ada6')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7e1835794955b88190d9e9b61b78ada6')), 'clicked');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/605b5c4e655f85fdaec7762c59fafaf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad0648017568724433399bd7f8786fc8')).includes('clicked')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad0648017568724433399bd7f8786fc8')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad0648017568724433399bd7f8786fc8')), 'clicked');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/3db226893afc04da1b4848d8a05927c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) < 3) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3db226893afc04da1b4848d8a05927c1')).includes('clicked')) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3db226893afc04da1b4848d8a05927c1')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3db226893afc04da1b4848d8a05927c1')), 'clicked');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/4d1363d1e725f974a7578ddfc8497c5f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') ? false : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) > 1 ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/ea8eb82afffeb3498acf898a883344e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') ? false : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) > 2 ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/670eefe3f1fc109145c225653f3e240d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') ? false : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) > 1 ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/202b2388dc6a63942cb73d5d2612ce31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') ? false : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) > 1 ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_71bbe289cce808b68969e9ca5669f3db/logic/49b2660bb8492db50025a1c613ea5d92/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.appData, 'currentUser')) === 'undefined') ? false : ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'usertype')) > 2 ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

